"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[847,2826,8906],{

/***/ 30079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T3": function() { return /* binding */ Page; },
/* harmony export */   "V3": function() { return /* binding */ privacyPageTheme; }
/* harmony export */ });
/* unused harmony export Theme */
var theme = {};
var Theme;
(function(Theme) {
    Theme["dark"] = "dark";
    Theme["light"] = "light";
})(Theme || (Theme = {}));
var Page;
(function(Page) {
    Page["privacyDark"] = "privacy-page-dark";
    Page["privacyLight"] = "privacy-page-light";
})(Page || (Page = {}));
var privacyPageTheme = {
    dark: {
        page: Page.privacyDark,
        textPrimary: "#cbcbcb",
        textSecondary: "#858585",
        backgroundPrimary: "#121212",
        backgroundSecondary: "#121212",
        borderPrimary: "#121212"
    },
    light: {
        page: Page.privacyLight,
        textPrimary: "#333333",
        textSecondary: "#858585",
        backgroundPrimary: "#ffffff",
        backgroundSecondary: "#f2f2f2",
        borderPrimary: "#dadada"
    }
};

/* harmony default export */ __webpack_exports__["ZP"] = (theme);


/***/ }),

/***/ 37213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* binding */ STOCKBIT_ACADEMY_URL; },
/* harmony export */   "CT": function() { return /* binding */ API_BASE_URL; },
/* harmony export */   "Cb": function() { return /* binding */ API_TRADING_URL; },
/* harmony export */   "GV": function() { return /* binding */ CUSTOM_USER_AGENT; },
/* harmony export */   "J3": function() { return /* binding */ GIPHY_STICKERS_URL; },
/* harmony export */   "Me": function() { return /* binding */ AWS_IMAGES_BUCKET; },
/* harmony export */   "UY": function() { return /* binding */ GIPHY_API_KEY; },
/* harmony export */   "VE": function() { return /* binding */ GOOGLE_PLAY_URL; },
/* harmony export */   "ZB": function() { return /* binding */ API_CURATOR_URL; },
/* harmony export */   "_O": function() { return /* binding */ SITE_URL; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "cu": function() { return /* binding */ API_TRADING_URL_V2; },
/* harmony export */   "fN": function() { return /* binding */ GIPHY_URL; },
/* harmony export */   "jd": function() { return /* binding */ CURATOR_FEED_ID; },
/* harmony export */   "kg": function() { return /* binding */ API_SECURITIES_GENERAL_URL; },
/* harmony export */   "l5": function() { return /* binding */ APP_STORE_URL; },
/* harmony export */   "lZ": function() { return /* binding */ FACEBOOK_APP_ID; },
/* harmony export */   "q$": function() { return /* binding */ AVATAR_URL; },
/* harmony export */   "q7": function() { return /* binding */ API_EXODUS_URL; },
/* harmony export */   "rM": function() { return /* binding */ AWS_EBOOK_BUCKET; },
/* harmony export */   "uJ": function() { return /* binding */ GOPAY_URL_JAVASCRIPT; },
/* harmony export */   "vw": function() { return /* binding */ AWS_TRADE_REG_BUCKET; }
/* harmony export */ });
/* unused harmony exports STAGE, API_SECURITIES_ALT_URL, SOCKET_URL, AWS_CHAT_BUCKET, GOPAY_QR_CODE_URL, GOPAY_REF_ID_URL, API_VERSION_ALT, DESKTOP_APP_BUCKET, DESKTOP_APP_SECRET_KEY, DESKTOP_APP_ACCESS_KEY, DESKTOP_APP_URL, DESKTOP_APP_END_POINT, CURATOR_TOKEN, APPLE_APP_SITE_ID */
/* provided dependency */ var process = __webpack_require__(34155);
var STAGE = (/* unused pure expression or super */ null && ("production" || 0));
var SITE_URL = "https://ui.lab.stockbit.com" || 0;
var SOCKET_URL = (/* unused pure expression or super */ null && ("https://ws3.lab.stockbit.com/"));
// Separate the version with base URL, if we need more version
// just add from `.env`, then add them into this file
var API_VERSION = "v25-staging";
var API_VERSION_ALT = "exodus-migration" || 0;
var API_BASE_URL = "".concat("https://api.lab.stockbit.com", "/").concat(API_VERSION);
var API_EXODUS_URL = "https://exodus.lab.stockbit.com";
var API_TRADING_URL = "https://trading.lab.masonline.id";
var API_TRADING_URL_V2 = "https://trading-core.lab.stockbit.com";
var API_SECURITIES_ALT_URL = "".concat("https://api.lab.stockbit.com", "/").concat(API_VERSION_ALT);
// Can be used with social or trading authorization
var API_SECURITIES_GENERAL_URL = "https://api.trading-lab.stockbit.com";
var API_CURATOR_URL = "https://api.curator.io";
var AVATAR_URL = "https://avatar.lab.stockbit.com" || 0;
var AWS_AVATAR_BUCKET = "https://avatar.lab.stockbit.com" || 0;
var AWS_IMAGES_BUCKET = "https://stockbit-stream-dev.s3.amazonaws.com";
var AWS_TRADE_REG_BUCKET = "https://simasreg.s3.amazonaws.com";
var AWS_EBOOK_BUCKET = "https://s3-ap-southeast-1.amazonaws.com/ebookstbx";
var AWS_CHAT_BUCKET = process.env.NEXT_PUBLIC_AWS_CHAT_BUCKET;
var GIPHY_URL = "https://api.giphy.com/v1/gifs";
var GIPHY_STICKERS_URL = "https://api.giphy.com/v1/stickers";
var GIPHY_API_KEY = "ZME7nTxOPIqXCf9qhCfqB1ICqtFCbCs5" || 0;
var GOPAY_URL_JAVASCRIPT = "https://app.sandbox.midtrans.com/snap/snap.js" || 0;
var GOPAY_QR_CODE_URL = (/* unused pure expression or super */ null && ("https://api.sandbox.veritrans.co.id/v2/gopay/" || 0));
var GOPAY_REF_ID_URL = (/* unused pure expression or super */ null && ("https://simulator.sandbox.midtrans.com/gopay/ui/checkout?referenceid=" || 0));
var FACEBOOK_APP_ID = "247631672013136" || 0;
// link to download stockbit app
var GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.stockbit.android&hl=en";
var APP_STORE_URL = "https://itunes.apple.com/us/app/stockbit/id1184800207?mt=8";
var STOCKBIT_ACADEMY_URL = "https://academy.lab.stockbit.com";
var CUSTOM_USER_AGENT = "webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d";
var DESKTOP_APP_BUCKET = (/* unused pure expression or super */ null && ("sb-sda-release"));
var DESKTOP_APP_SECRET_KEY = (/* unused pure expression or super */ null && ("EFKHBWQHWq0jWNNGM2/e35vU4vOrN4OHyd4f09Kv"));
var DESKTOP_APP_ACCESS_KEY = (/* unused pure expression or super */ null && ("AKIAX4CD7C6D4DF5LTF6"));
var DESKTOP_APP_URL = (/* unused pure expression or super */ null && ("https://sda-release.stockbit.com/"));
var DESKTOP_APP_END_POINT = (/* unused pure expression or super */ null && ("https://s3.ap-southeast-3.amazonaws.com/"));
var CURATOR_TOKEN = (/* unused pure expression or super */ null && ("ae406fc1-d23a-4a34-a0c9-164c7d2204ea"));
var CURATOR_FEED_ID = "1e81f0c0-550d-492e-b3ae-0dd4706df21f";
var APPLE_APP_SITE_ID = (/* unused pure expression or super */ null && ("ASHUNREKRL.com.stockbitdev.ios"));



/***/ }),

/***/ 86123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ax": function() { return /* binding */ GTM_ID; },
/* harmony export */   "C5": function() { return /* binding */ isClient; },
/* harmony export */   "Vc": function() { return /* binding */ assetPrefix; },
/* harmony export */   "cU": function() { return /* binding */ AWS_AVATAR_BUCKET; },
/* harmony export */   "d7": function() { return /* binding */ CLEVERTAP_ID; },
/* harmony export */   "mM": function() { return /* binding */ assetsStatic; },
/* harmony export */   "or": function() { return /* binding */ STAGE; },
/* harmony export */   "qV": function() { return /* binding */ PROJECT_FOLDER_PATH; },
/* harmony export */   "sP": function() { return /* binding */ PROJECT_FOLDER; },
/* harmony export */   "t0": function() { return /* binding */ CRISP_ID; },
/* harmony export */   "yv": function() { return /* binding */ isProduction; },
/* harmony export */   "yz": function() { return /* binding */ siteUrl; }
/* harmony export */ });
/* unused harmony exports CDN, R2_ASSET_PREFIX, FB_APP_ID, USER_AGENT, OPEN_HOUR, CLOSE_HOUR, isMarketOpen, STRUCTURED_DATA */
/* provided dependency */ var process = __webpack_require__(34155);
var PROJECT_FOLDER = process.env.NEXT_PUBLIC_PROJECT_FOLDER;
var PROJECT_FOLDER_PATH = PROJECT_FOLDER ? "/".concat(PROJECT_FOLDER) : "";
var CDN = "https://ui.lab.stockbit.com" || 0;
var assetPrefix = CDN ? "".concat(CDN).concat(PROJECT_FOLDER_PATH) : "";
var R2_ASSET_PREFIX = "https://web-assets.stockbit.com";
var FB_APP_ID = (/* unused pure expression or super */ null && ("247631672013136" || 0));
var GTM_ID = "GTM-WWZ885M" || 0;
var siteUrl = "https://ui.lab.stockbit.com" || 0;
var STAGE = "production" || 0;
var CLEVERTAP_ID = "TEST-7ZW-897-5R6Z";
var AWS_AVATAR_BUCKET = "https://avatar.lab.stockbit.com" || 0;
var USER_AGENT = (/* unused pure expression or super */ null && ("webapp-api-293bf2f3-2d64-4948-94dd-9277ebbe96d" || 0));
var CRISP_ID = "9961bcff-8da8-43a1-917e-39d352a4a0dd" || 0;
var isClient = function() {
    return "object" !== "undefined";
};
var isProduction = "production" === "production";
// Market hour
var OPEN_HOUR = 9;
var CLOSE_HOUR = 15;
var isMarketOpen = function() {
    var currentTime = new Date().getHours();
    // return currentTime >= OPEN_HOUR && currentTime <= CLOSE_HOUR;
    return currentTime >= OPEN_HOUR;
};
var STRUCTURED_DATA = {
    "@context": "http://schema.org",
    "@type": "Corporation",
    name: "Stockbit",
    legalName: "Stockbit",
    description: "Stockbit adalah komunitas investasi di Indonesia. Stockbit memberi ruang bagi investor dan trader untuk berbagi ide, berita dan informasi keuangan lainya secara real-time. Pengguna bisa membuat profil dan mengikuti saham tertentu atau investor favorit untuk mendapatkan informasi berharga dan bertukar pikiran. Fitur utama dari Stockbit yaitu 'stream' terdiri dari ide-ide, grafik saham, link dan data keuangan lainya. Stockbit menggunakan tanda '$' sebelum kode saham sebagai penandaan ide untuk mempermudah pengguna dalam mencari informasi tentang saham individu tertentu. Platform Stockbit juga terintegrasi dengan platform social media lainya, seperti Twitter dan Facebook, sehingga mudah untuk berbagi ide-ide di Stockbit ke akun Twitter dan Facebook pengguna. Stockbit dirancang dengan fitur yang terfokus dengan keperilakuan investor dan trader sehingga akan lebih berguna sebagai social media khusus investasi.",
    logo: "https://assets-nextjs.stockbit.com/img/favicon.ico",
    url: "https://stockbit.com",
    telephone: "+6221 57906242",
    sameAs: [
        "https://twitter.com/Stockbit",
        "https://www.linkedin.com/company/stockbit",
        "https://www.facebook.com/Stockbit",
        "https://www.youtube.com/c/Stockbit",
        "https://instagram.com/stockbit",
        "https://www.crunchbase.com/organization/stockbit", 
    ],
    address: {
        "@type": "PostalAddress",
        streetAddress: "RDTX Square 33rd Floor, Jl. Prof. Dr. Satrio No 164 - Jakarta",
        addressLocality: "Jakarta Selatan",
        postalCode: "12930",
        addressCountry: "Indonesia"
    }
};
var assetsStatic = "".concat("https://assets.stockbit.com");


/***/ }),

/***/ 39246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/calendar.ts


var request = (0,requestExodus/* default */.Z)();
var CALENDAR_URL = "".concat(api/* API_EXODUS_URL */.q7, "/corpaction");
var getCalendarTodaySummary = function(symbol) {
    return request.get(CALENDAR_URL, {
        params: {
            symbol: symbol
        }
    });
};
/**
 * @summary - Get Calendar Data based on Type
 * @param {string} calendarType - type of calendar. type: economic | dividend | stocksplit
 * | reversesplit | rightissue | warrant | bonus | tenderoffer | rups | pubex | ipo
 * @return {Promise} Axios promise
 */ var getCalendarFor = function(calendarType, symbol) {
    return request.get("".concat(CALENDAR_URL, "/").concat(calendarType), {
        params: {
            symbol: symbol
        }
    });
};


;// CONCATENATED MODULE: ./src/features/calendar/slice.ts




var CONTEXT = "@feature/calendar";
var actionType = {
    GET_CALENDAR_TODAY: "".concat(CONTEXT, "/GET_CALENDAR_TODAY"),
    GET_CALENDAR_ECONOMIC: "".concat(CONTEXT, "/GET_CALENDAR_ECONOMIC"),
    GET_CALENDAR_CASH_DIVIDEND: "".concat(CONTEXT, "/GET_CALENDAR_CASH_DIVIDEND"),
    GET_CALENDAR_STOCK_DIVIDEND: "".concat(CONTEXT, "/GET_CALENDAR_STOCK_DIVIDEND"),
    GET_CALENDAR_STOCKSPLIT: "".concat(CONTEXT, "/GET_CALENDAR_STOCKSPLIT"),
    GET_CALENDAR_REVERSESPLIT: "".concat(CONTEXT, "/GET_CALENDAR_REVERSESPLIT"),
    GET_CALENDAR_RIGHTISSUE: "".concat(CONTEXT, "/GET_CALENDAR_RIGHTISSUE"),
    GET_CALENDAR_WARRANT: "".concat(CONTEXT, "/GET_CALENDAR_WARRANT"),
    GET_CALENDAR_BONUS: "".concat(CONTEXT, "/GET_CALENDAR_BONUS"),
    GET_CALENDAR_TENDER: "".concat(CONTEXT, "/GET_CALENDAR_TENDER"),
    GET_CALENDAR_RUPS: "".concat(CONTEXT, "/GET_CALENDAR_RUPS"),
    GET_CALENDAR_PUBEX: "".concat(CONTEXT, "/GET_CALENDAR_PUBEX"),
    GET_CALENDAR_IPO: "".concat(CONTEXT, "/GET_CALENDAR_IPO")
};
var initialState = {
    calendarToday: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarEconomic: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarCashDividend: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarStockDividend: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarStocksplit: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarReversesplit: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarRightIssue: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarWarrant: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarBonus: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarTender: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarRups: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarPubex: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    },
    calendarIpo: {
        data: undefined,
        error: undefined,
        isLoading: undefined,
        message: undefined
    }
};
var calendarState = function(state) {
    return state.calendar;
};
var selectors = (0,es/* createSelector */.P1)(calendarState, function(calendar) {
    return {
        calendarToday: calendar.calendarToday,
        calendarEconomic: calendar.calendarEconomic,
        calendarCashDividend: calendar.calendarCashDividend,
        calendarStockDividend: calendar.calendarStockDividend,
        calendarStocksplit: calendar.calendarStocksplit,
        calendarReversesplit: calendar.calendarReversesplit,
        calendarRightIssue: calendar.calendarRightIssue,
        calendarWarrant: calendar.calendarWarrant,
        calendarBonus: calendar.calendarBonus,
        calendarTender: calendar.calendarTender,
        calendarRups: calendar.calendarRups,
        calendarPubex: calendar.calendarPubex,
        calendarIpo: calendar.calendarIpo
    };
});
/**
 * Get Calendar Data based on Type
 * @summary - available calendar type: economic | dividened | stocksplit
 * | reversesplit | reversesplit | rightissue | warrant | bonus | tenderoffer | rups | pubex | ipo
 * @param {string} calendarTypes - type of calendar
 */ var effects = {
    getCalendarToday: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_TODAY, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarTodaySummary();
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get today calendar is failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarEconomic: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_ECONOMIC, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("economic");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for economic failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarCashDividend: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_CASH_DIVIDEND, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("dividend");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for dividend failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarStockDividend: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_STOCK_DIVIDEND, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("stock_dividend");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for stock dividend failed");
                case 6:
                    data = responds.data;
                    console.log("data", data);
                    console.log("responds", responds);
                    return _ctx.abrupt("return", data);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    getCalendarStocksplit: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_STOCKSPLIT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("stocksplit");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for stocksplit failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarReversesplit: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_REVERSESPLIT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("reversesplit");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for reverse split failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarRightIssue: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_RIGHTISSUE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("rightissue");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for right issue failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarWarrant: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_WARRANT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("warrant");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for warrant failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarBonus: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_BONUS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("bonus");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for bonus failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarTender: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_TENDER, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("tenderoffer");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for tender offer failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarRups: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_RUPS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("rups");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for RUPS failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarPubex: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_PUBEX, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("pubex");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for PUBEX failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCalendarIpo: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_CALENDAR_IPO, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var responds, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getCalendarFor("ipo");
                case 3:
                    responds = _ctx.sent;
                    if (responds.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get calender for IPO failed");
                case 6:
                    data = responds.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    })))
};
var extraReducer = function(builder) {
    builder.addCase(effects.getCalendarToday.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarToday.isLoading = false;
        state.calendarToday.data = data;
        state.calendarToday.message = message;
    }).addCase(effects.getCalendarToday.pending, function(state, action) {
        state.calendarToday.isLoading = true;
    }).addCase(effects.getCalendarToday.rejected, function(state, action) {
        state.calendarToday.isLoading = false;
        state.calendarToday.error = action.payload.error;
    }).addCase(effects.getCalendarEconomic.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarEconomic.data = data;
        state.calendarEconomic.message = message;
        state.calendarEconomic.isLoading = false;
    }).addCase(effects.getCalendarEconomic.pending, function(state, action) {
        state.calendarEconomic.isLoading = true;
    }).addCase(effects.getCalendarEconomic.rejected, function(state, action) {
        state.calendarEconomic.error = action.payload.error;
        state.calendarEconomic.isLoading = false;
    }).addCase(effects.getCalendarCashDividend.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarCashDividend.data = data;
        state.calendarCashDividend.message = message;
        state.calendarCashDividend.isLoading = false;
    }).addCase(effects.getCalendarCashDividend.pending, function(state, action) {
        state.calendarCashDividend.isLoading = true;
    }).addCase(effects.getCalendarCashDividend.rejected, function(state, action) {
        state.calendarCashDividend.error = action.payload.error;
        state.calendarCashDividend.isLoading = false;
    }).addCase(effects.getCalendarStockDividend.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarStockDividend.data = data;
        state.calendarStockDividend.message = message;
        state.calendarStockDividend.isLoading = false;
    }).addCase(effects.getCalendarStockDividend.pending, function(state, action) {
        state.calendarStockDividend.isLoading = true;
    }).addCase(effects.getCalendarStockDividend.rejected, function(state, action) {
        state.calendarStockDividend.error = action.payload.error;
        state.calendarStockDividend.isLoading = false;
    }).addCase(effects.getCalendarStocksplit.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarStocksplit.data = data;
        state.calendarStocksplit.message = message;
        state.calendarStocksplit.isLoading = false;
    }).addCase(effects.getCalendarStocksplit.pending, function(state, action) {
        state.calendarStocksplit.isLoading = true;
    }).addCase(effects.getCalendarStocksplit.rejected, function(state, action) {
        state.calendarStocksplit.error = action.payload.error;
        state.calendarStocksplit.isLoading = false;
    }).addCase(effects.getCalendarReversesplit.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarReversesplit.data = data;
        state.calendarReversesplit.message = message;
        state.calendarReversesplit.isLoading = false;
    }).addCase(effects.getCalendarReversesplit.pending, function(state, action) {
        state.calendarReversesplit.isLoading = true;
    }).addCase(effects.getCalendarReversesplit.rejected, function(state, action) {
        state.calendarReversesplit.error = action.payload.error;
        state.calendarReversesplit.isLoading = false;
    }).addCase(effects.getCalendarRightIssue.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarRightIssue.data = data;
        state.calendarRightIssue.message = message;
        state.calendarRightIssue.isLoading = false;
    }).addCase(effects.getCalendarRightIssue.pending, function(state, action) {
        state.calendarRightIssue.isLoading = true;
    }).addCase(effects.getCalendarRightIssue.rejected, function(state, action) {
        state.calendarRightIssue.error = action.payload.error;
        state.calendarRightIssue.isLoading = false;
    }).addCase(effects.getCalendarWarrant.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarWarrant.data = data;
        state.calendarWarrant.message = message;
        state.calendarWarrant.isLoading = false;
    }).addCase(effects.getCalendarWarrant.pending, function(state, action) {
        state.calendarWarrant.isLoading = true;
    }).addCase(effects.getCalendarWarrant.rejected, function(state, action) {
        state.calendarWarrant.error = action.payload.error;
        state.calendarWarrant.isLoading = false;
    }).addCase(effects.getCalendarBonus.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarBonus.data = data;
        state.calendarBonus.message = message;
        state.calendarBonus.isLoading = false;
    }).addCase(effects.getCalendarBonus.pending, function(state, action) {
        state.calendarBonus.isLoading = true;
    }).addCase(effects.getCalendarBonus.rejected, function(state, action) {
        state.calendarBonus.error = action.payload.error;
        state.calendarBonus.isLoading = false;
    }).addCase(effects.getCalendarTender.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarTender.data = data;
        state.calendarTender.message = message;
        state.calendarTender.isLoading = false;
    }).addCase(effects.getCalendarTender.pending, function(state, action) {
        state.calendarTender.isLoading = true;
    }).addCase(effects.getCalendarTender.rejected, function(state, action) {
        state.calendarTender.error = action.payload.error;
        state.calendarTender.isLoading = false;
    }).addCase(effects.getCalendarRups.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarRups.data = data;
        state.calendarRups.message = message;
        state.calendarRups.isLoading = false;
    }).addCase(effects.getCalendarRups.pending, function(state, action) {
        state.calendarRups.isLoading = true;
    }).addCase(effects.getCalendarRups.rejected, function(state, action) {
        state.calendarRups.error = action.payload.error;
        state.calendarRups.isLoading = false;
    }).addCase(effects.getCalendarPubex.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarPubex.data = data;
        state.calendarPubex.message = message;
        state.calendarPubex.isLoading = false;
    }).addCase(effects.getCalendarPubex.pending, function(state, action) {
        state.calendarPubex.isLoading = true;
    }).addCase(effects.getCalendarPubex.rejected, function(state, action) {
        state.calendarPubex.error = action.payload.error;
        state.calendarPubex.isLoading = false;
    }).addCase(effects.getCalendarIpo.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.calendarIpo.data = data;
        state.calendarIpo.message = message;
        state.calendarIpo.isLoading = false;
    }).addCase(effects.getCalendarIpo.pending, function(state, action) {
        state.calendarIpo.isLoading = true;
    }).addCase(effects.getCalendarIpo.rejected, function(state, action) {
        state.calendarIpo.error = action.payload.error;
        state.calendarIpo.isLoading = false;
    });
};
var calendarSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "calendar",
    initialState: initialState,
    // for non-async reducer logic
    reducers: {},
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ var slice = (calendarSlice);


/***/ }),

/***/ 52892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/catalog.ts


var request = (0,requestExodus/* default */.Z)();
var SECTOR_API = "".concat(api/* API_EXODUS_URL */.q7, "/emitten");
var getSectorList = function() {
    return request.get("".concat(SECTOR_API, "/sectors"));
};
var getSubsectorList = function(sectorId) {
    return request.get("".concat(SECTOR_API, "/sectors/").concat(sectorId, "/subsectors"));
};
var getCompanyList = function(sectorId, subSectorId) {
    return request.get("".concat(SECTOR_API, "/v3/sector/").concat(sectorId, "/subsector/").concat(subSectorId, "/company"));
};
var getCompanyInSector = function(sectorId) {
    return request.get("".concat(SECTOR_API, "/v3/sector/").concat(sectorId, "/company"));
};
/* harmony default export */ var catalog = ({
    getSectorList: getSectorList,
    getSubsectorList: getSubsectorList,
    getCompanyList: getCompanyList,
    getCompanyInSector: getCompanyInSector
});

// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/features/catalog/slice.ts








// APIs


// Initial state
var initialState = {
    list: {},
    subsectors: [],
    sectors: [],
    pageTitle: null,
    error: null,
    isLoading: false,
    message: "",
    companies: []
};
// Selectors
var slice_catalog = function(state) {
    return state.catalog;
};
var selectors = (0,es/* createSelector */.P1)(slice_catalog, function(cat) {
    return (0,_object_spread/* default */.Z)({}, cat);
});
// Action type
var CONTEXT = "@feature/catalog";
var actionType = {
    GET_COMPANY_LIST: "".concat(CONTEXT, "/GET_COMPANY_LIST"),
    GET_SECTOR_LIST: "".concat(CONTEXT, "/GET_SECTOR_LIST")
};
// Side effects
var effects = {
    getSectorList: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SECTOR_LIST, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var res, _data, data, error_type, error, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return catalog.getSectorList();
                case 2:
                    res = _ctx.sent;
                    if (res.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Failed to fetch sector list");
                case 5:
                    _data = res.data, data = _data.data, error_type = _data.error_type, error = _data.error, message = _data.message;
                    if (!(error_type || error)) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error(message);
                case 8:
                    return _ctx.abrupt("return", {
                        data: data,
                        error: error,
                        message: message
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    getCompanyList: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_COMPANY_LIST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var sector, subsector, _isCatalog, isCatalog, getState, companies, companyListPayload, getSectors, ref, sectors, getSectorData, sectorData, getSubsector, getSubsectorData, subsectorData, companyResponse, isSyariah, newSubsector, getCompanyInSector, getCompanyInSectorData, companyRequest, listCompanyResponse, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        sector = param.sector, subsector = param.subsector, _isCatalog = param.isCatalog, isCatalog = _isCatalog === void 0 ? false : _isCatalog, getState = param1.getState;
                        _ctx.prev = 1;
                        companies = [];
                        companyListPayload = {};
                        ;
                        if (sector) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Sector is required");
                    case 7:
                        ref = getState(), sectors = ref.catalog.sectors;
                        if (!(sectors.length === 0)) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 11;
                        return catalog.getSectorList();
                    case 11:
                        // Get sector list first
                        getSectors = _ctx.sent;
                        if (getSectors.data) {
                            _ctx.next = 14;
                            break;
                        }
                        throw new Error("Attempt to get sector list failed");
                    case 14:
                        getSectorData = sectors.length > 0 ? {
                            data: sectors
                        } : getSectors === null || getSectors === void 0 ? void 0 : getSectors.data;
                        if (!getSectorData.error) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: "Error sector",
                            message: getSectorData.message
                        });
                    case 17:
                        sectorData = getSectorData.data.find(function(sc) {
                            return (0,general/* convertToSlug */.k6)(sc.alias1) === (0,general/* convertToSlug */.k6)(sector);
                        });
                        if (sectorData) {
                            _ctx.next = 20;
                            break;
                        }
                        throw new Error("Sector not found");
                    case 20:
                        _ctx.next = 22;
                        return catalog.getSubsectorList(sectorData.id);
                    case 22:
                        getSubsector = _ctx.sent;
                        if (getSubsector.data) {
                            _ctx.next = 25;
                            break;
                        }
                        throw new Error("Attempt to get sub sector data failed");
                    case 25:
                        getSubsectorData = getSubsector.data;
                        if (!getSubsectorData.error) {
                            _ctx.next = 28;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: "Error subsector",
                            message: getSubsectorData.message
                        });
                    case 28:
                        ;
                        companyResponse = {
                            data: {
                                data: null
                            }
                        };
                        if (!subsector) {
                            _ctx.next = 46;
                            break;
                        }
                        isSyariah = sector.toLowerCase() === "indeks" && subsector.toLowerCase() === "syariah";
                        newSubsector = isSyariah ? "ISSI" : subsector;
                        // if subsector available in url path, we will
                        // call company list by subsector id
                        subsectorData = getSubsectorData.data.find(function(sb) {
                            return (0,general/* convertToSlug */.k6)(sb.alias1) === (0,general/* convertToSlug */.k6)(newSubsector);
                        });
                        if (subsectorData) {
                            _ctx.next = 38;
                            break;
                        }
                        {
                            companyListPayload = {
                                error: "Error subsector",
                                message: "Subsector not found"
                            };
                        }
                        _ctx.next = 44;
                        break;
                    case 38:
                        _ctx.next = 40;
                        return catalog.getCompanyList(sectorData.id, subsectorData.id);
                    case 40:
                        // Get company list based on subsector
                        companyResponse = _ctx.sent;
                        if (companyResponse.data) {
                            _ctx.next = 43;
                            break;
                        }
                        throw new Error("Attempt to get company list failed");
                    case 43:
                        companies = companyResponse.data.data;
                    case 44:
                        _ctx.next = 62;
                        break;
                    case 46:
                        if (!isCatalog) {
                            _ctx.next = 54;
                            break;
                        }
                        _ctx.next = 49;
                        return catalog.getCompanyInSector(sectorData.id);
                    case 49:
                        getCompanyInSector = _ctx.sent;
                        getCompanyInSectorData = getCompanyInSector.data;
                        companies = getCompanyInSectorData.data;
                        _ctx.next = 62;
                        break;
                    case 54:
                        _ctx.next = 56;
                        return getSubsectorData.data.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(subsector) {
                                var company;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return catalog.getCompanyList(sectorData.id, subsector.id);
                                        case 2:
                                            company = _ctx.sent;
                                            return _ctx.abrupt("return", {
                                                company: company,
                                                subsectorName: subsector.alias1
                                            });
                                        case 4:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(subsector) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                    case 56:
                        companyRequest = _ctx.sent;
                        _ctx.next = 59;
                        return Promise.all(companyRequest);
                    case 59:
                        listCompanyResponse = _ctx.sent;
                        companyResponse = {
                            data: {
                                data: []
                            }
                        };
                        listCompanyResponse.map(function(response) {
                            companyResponse.data.data.push({
                                alias: response.subsectorName,
                                data: (0,_to_consumable_array/* default */.Z)(response.company.data.data)
                            });
                        });
                    case 62:
                        _data = companyResponse.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 66;
                            break;
                        }
                        (0,AlertErrorMessage/* default */.Z)(message || (_$error === null || _$error === void 0 ? void 0 : _$error.message), errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 66:
                        return _ctx.abrupt("return", (0,_object_spread/* default */.Z)({
                            data: data,
                            message: message,
                            sector: sector,
                            sectors: getSectorData.data,
                            subsector: subsector,
                            subsectors: getSubsectorData.data,
                            companies: companies
                        }, companyListPayload));
                    case 69:
                        _ctx.prev = 69;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,AlertErrorMessage/* default */.Z)(_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 73:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    69
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {
    updateList: function(state, action) {
        var newList = {};
        var _payload = action.payload, symbol = _payload.index, data = _payload.data;
        Object.keys(state.list).map(function(key1) {
            newList[key1] = {};
            Object.keys(state.list[key1]).map(function(key2) {
                newList[key1][key2] = [];
                var values = state.list[key1][key2];
                values.map(function(value) {
                    if (value.symbol === symbol) {
                        newList[key1][key2].push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                            last: data.lastprice,
                            change: data.change,
                            percent: data.percentage_change
                        }));
                    } else {
                        newList[key1][key2].push(value);
                    }
                });
            });
        });
        state.list = newList;
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getCompanyList.pending, function(state, action) {
        state.error = null;
        state.isLoading = true;
        var sector = action.meta.arg.sector;
        if (!state.list[sector]) {
            state.list[sector] = {};
        }
    }).addCase(effects.getCompanyList.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, sector = _payload.sector, sectors = _payload.sectors, subsector = _payload.subsector, subsectors = _payload.subsectors, companies = _payload.companies;
        if (error) {
            state.error = error;
        }
        if (sectors && sector && !subsector) {
            state.sectors = sectors;
            var activeSector = sectors.find(function(item) {
                return (0,general/* convertToSlug */.k6)(item === null || item === void 0 ? void 0 : item.alias1) === (0,general/* convertToSlug */.k6)(sector);
            });
            state.pageTitle = (activeSector === null || activeSector === void 0 ? void 0 : activeSector.name) || null;
            if (data) {
                data.map(function(item) {
                    state.list[sector][item.alias] = item.data;
                });
            }
        }
        if (subsectors) {
            state.subsectors = subsectors;
            if (subsector) {
                state.list[sector][subsector] = data;
            }
        }
        state.companies = companies;
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getCompanyList.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    })// Get sector list
    .addCase(effects.getSectorList.pending, function(state) {
        state.isLoading = true;
        state.error = false;
    }).addCase(effects.getSectorList.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
        if (error) {
            state.error = error;
        } else {
            state.error = null;
            state.sectors = data;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(effects.getSectorList.rejected, function(state, action) {
        state.error = action.payload;
        state.isLoading = false;
    });
};
var catalogSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "catalog",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var slice = (catalogSlice);


/***/ }),

/***/ 34566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DY": function() { return /* binding */ DISCOVER_FILTERS; },
/* harmony export */   "FT": function() { return /* binding */ SUGGESTIONS_PERPAGE; },
/* harmony export */   "_u": function() { return /* binding */ LIMIT_SEARCH_USER; },
/* harmony export */   "ce": function() { return /* binding */ QUERY_KEY_DATA; }
/* harmony export */ });
/* unused harmony exports LIMIT_TRENDING_USER, USER_TYPES, EMPTY_MESSAGE */
var DISCOVER_FILTERS = [
    {
        label: "Trending",
        value: "TRENDING"
    },
    {
        label: "Suggestions",
        value: "SUGGEST"
    },
    {
        label: "Friends",
        value: "CONTACT"
    }, 
];
var EMPTY_MESSAGE = {
    contacts: "You have no suggested people on your contact",
    facebook: "You have no facebook friends",
    all: "You have no suggested people",
    official: "You have no suggested official contact"
};
var USER_TYPES = {
    OFFICIAL_USER: "OFFICIAL",
    TOP: "TOP"
};
var SUGGESTIONS_PERPAGE = 30;
var LIMIT_SEARCH_USER = 20;
var LIMIT_TRENDING_USER = 100;
var QUERY_KEY_DATA = {
    SUGGEST: "getDataFriendSuggestionsList",
    CONTACT: "getDataContactList",
    SEARCH: "getSearchUserList",
    TRENDING: "getTrendingUserList"
};



/***/ }),

/***/ 58603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ actionType; },
/* harmony export */   "FO": function() { return /* binding */ getTrendingUserDiscovery; },
/* harmony export */   "Fi": function() { return /* binding */ normalizeData; },
/* harmony export */   "Iq": function() { return /* binding */ getCurrentQueryKey; },
/* harmony export */   "NX": function() { return /* binding */ DiscoverPeopleContext; },
/* harmony export */   "P_": function() { return /* binding */ followUser; },
/* harmony export */   "Qd": function() { return /* binding */ INDEX_DATA_FILTER; },
/* harmony export */   "lU": function() { return /* binding */ getFriendSuggestionsContact; },
/* harmony export */   "n1": function() { return /* binding */ getSearchUser; },
/* harmony export */   "vR": function() { return /* binding */ getSuggestFriends; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var lib_api_friends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63699);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44590);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37213);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34566);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28635);







// app constants



var CONTEXT = "@discover-people";
var actionType = {
    FETCH_TRENDING: "".concat(CONTEXT, "/FETCH_TRENDING"),
    FETCH_SUGGESTIONS: "".concat(CONTEXT, "/FETCH_SUGGESTIONS"),
    FETCH_CONTACT: "".concat(CONTEXT, "/FETCH_CONTACT"),
    FOLLOW_ALL: "".concat(CONTEXT, "/FOLLOW_ALL"),
    SEARCH_USER: "".concat(CONTEXT, "/SEARCH_USER"),
    TOGGLE_FOLLOW_USER: "".concat(CONTEXT, "/TOGGLE_FOLLOW_USER")
};
var INDEX_DATA_FILTER = {
    SUGGEST: "useSuggestionList",
    CONTACT: "useContactList",
    SEARCH: "useSearchUser",
    TRENDING: "useTrendingList"
};
var DiscoverPeopleContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
// normalize data
var normalizeData = function(data, actionName) {
    if (actionName === actionType.FETCH_SUGGESTIONS) {
        return data.map(function(param) {
            var user = param.user, reason = param.reason, type = param.type;
            return {
                avatar: "".concat(constants_api__WEBPACK_IMPORTED_MODULE_5__/* .AVATAR_URL */ .q$, "/").concat(user.user_avatar),
                fullname: user.user_fullname,
                isFollowed: user.follow,
                isOfficial: user.is_verified,
                verifiedStatus: user === null || user === void 0 ? void 0 : user.verified_status,
                isLoading: false,
                reason: reason,
                type: type,
                id: user.userid,
                username: user.username
            };
        });
    }
    if (actionName === actionType.FETCH_CONTACT) {
        return data.map(function(user) {
            return {
                avatar: "".concat(constants_api__WEBPACK_IMPORTED_MODULE_5__/* .AVATAR_URL */ .q$, "/").concat(user.user_avatar),
                fullname: user.user_fullname,
                isFollowed: user.follow,
                isOfficial: user.is_verified,
                verifiedStatus: user === null || user === void 0 ? void 0 : user.verified_status,
                isLoading: false,
                id: user.userid,
                username: user.username
            };
        });
    }
    if (actionName === actionType.SEARCH_USER) {
        return data.people.map(function(_param) {
            var desc = _param.desc, is_following = _param.is_following, id = _param.id, img = _param.img, name = _param.name, is_verified = _param.is_verified, type = _param.type, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
                "desc",
                "is_following",
                "id",
                "img",
                "name",
                "is_verified",
                "type"
            ]);
            return {
                avatar: "".concat(constants_api__WEBPACK_IMPORTED_MODULE_5__/* .AVATAR_URL */ .q$, "/").concat(img),
                fullname: desc,
                id: id,
                isFollowed: is_following,
                isOfficial: is_verified,
                verifiedStatus: rest === null || rest === void 0 ? void 0 : rest.verified_status,
                isLoading: false,
                reason: "",
                type: type,
                username: name
            };
        });
    }
    if (actionName === actionType.FETCH_TRENDING) {
        return data.users.map(function(item) {
            var ref;
            return {
                avatar: item.avatar.thumb,
                id: item.id,
                username: item.username,
                fullname: item.fullname,
                isOfficial: item.status.is_verified,
                verifiedStatus: (ref = item.status) === null || ref === void 0 ? void 0 : ref.verified_status
            };
        });
    }
    return [];
};
var getSuggestFriends = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page) {
        var config, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    config = {
                        limit: _constants__WEBPACK_IMPORTED_MODULE_6__/* .SUGGESTIONS_PERPAGE */ .FT,
                        page: page
                    };
                    _ctx.next = 3;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSuggestFriends */ .Z.getSuggestFriends(config);
                case 3:
                    data = _ctx.sent.data;
                    if (!(!data || data.error)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("failed to fetch friends suggestions");
                case 6:
                    return _ctx.abrupt("return", normalizeData((data === null || data === void 0 ? void 0 : data.data) || [], actionType.FETCH_SUGGESTIONS));
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSuggestFriends(page) {
        return _ref.apply(this, arguments);
    };
}();
var getTrendingUserDiscovery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var timeframe, limit, cursor, response, data, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    timeframe = _args.length > 0 && _args[0] !== void 0 ? _args[0] : _types__WEBPACK_IMPORTED_MODULE_7__/* .TrendingTimeFrame.ALL */ .b.ALL, limit = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 100, cursor = _args.length > 2 ? _args[2] : void 0;
                    _ctx.next = 3;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getTrending */ .Z.getTrending(timeframe, limit, cursor);
                case 3:
                    response = _ctx.sent;
                    data = response.data.data;
                    if (data) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("failed to fetch trending user");
                case 7:
                    return _ctx.abrupt("return", data);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTrendingUserDiscovery() {
        return _ref.apply(this, arguments);
    };
}();
var getSearchUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page, keyword) {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_search__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getSearchPeople */ .Z.getSearchPeople(keyword, page);
                case 2:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Cannot perform request");
                case 5:
                    data = response.data.data;
                    return _ctx.abrupt("return", normalizeData(data, actionType.SEARCH_USER));
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSearchUser(page, keyword) {
        return _ref.apply(this, arguments);
    };
}();
var getFriendSuggestionsContact = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page) {
        var ref, config, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    config = {
                        limit: _constants__WEBPACK_IMPORTED_MODULE_6__/* .SUGGESTIONS_PERPAGE */ .FT,
                        page: page
                    };
                    _ctx.next = 4;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSuggestFriendsContacts */ .Z.getSuggestFriendsContacts(config.limit, config.page);
                case 4:
                    data = _ctx.sent.data;
                    if (!(!data || data.error)) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("failed to fetch friends suggestions");
                case 7:
                    return _ctx.abrupt("return", normalizeData((data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.found) || [], actionType.FETCH_CONTACT));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getFriendSuggestionsContact(page) {
        return _ref.apply(this, arguments);
    };
}();
var followUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var id, index, isFollowed, targetAPI, response;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    id = body.userid, index = body.index, isFollowed = body.isFollowed;
                    if (!(typeof index !== "number")) {
                        _ctx.next = 3;
                        break;
                    }
                    throw new Error("index must be a number");
                case 3:
                    if (id) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("userid is required");
                case 5:
                    targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postFollowUser */ .Z.postFollowUser;
                    if (isFollowed) {
                        targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postUnfollowUser */ .Z.postUnfollowUser;
                    }
                    _ctx.next = 9;
                    return targetAPI(id);
                case 9:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 12;
                        break;
                    }
                    throw new Error("Cannot perform request");
                case 12:
                    return _ctx.abrupt("return", response.data);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function followUser(body) {
        return _ref.apply(this, arguments);
    };
}();
var getCurrentQueryKey = function(filter) {
    return _constants__WEBPACK_IMPORTED_MODULE_6__/* .QUERY_KEY_DATA */ .ce[filter];
};


/***/ }),

/***/ 79695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "nO": function() { return /* binding */ earningsEffects; },
  "Y5": function() { return /* binding */ earningsSelectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/earnings.ts


var request = (0,requestExodus/* default */.Z)();
var GET_EARNINGS = "".concat(api/* API_EXODUS_URL */.q7, "/earnings");
var getEarnings = function(param) {
    var page = param.page, order = param.order, sortcol = param.sortcol, year = param.year, quarter = param.quarter, companySymbol = param.companySymbol, filter = param.filter;
    return request.get(GET_EARNINGS, {
        params: {
            filter: filter,
            search: companySymbol,
            quarter: quarter,
            year: year,
            sort_column: sortcol,
            order: order,
            page: page
        }
    });
};
/* harmony default export */ var earnings = (getEarnings);

// EXTERNAL MODULE: ./src/lib/api/screener.ts
var screener = __webpack_require__(70735);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
;// CONCATENATED MODULE: ./src/features/earnings/slice.ts








var CONTEXT = "@feature/earnings";
var actionType = {
    GET_SCREENER_UNIVERSE: "".concat(CONTEXT, "/GET_SCREENER_UNIVERSE"),
    GET_EARNINGS: "".concat(CONTEXT, "/GET_EARNINGS"),
    GET_SUGGESTED_COMPANY: "".concat(CONTEXT, "/GET_SUGGESTED_COMPANY")
};
var initialState = {
    screenerUniverse: {
        data: {},
        message: undefined,
        error: undefined,
        isLoading: undefined
    },
    earings: {
        data: {},
        message: undefined,
        error: undefined,
        isLoading: undefined
    },
    suggestedCompanies: {
        data: {},
        error: undefined,
        isLoading: undefined,
        message: undefined
    }
};
var earningsState = function(state) {
    return state.earnings;
};
var earningsSelectors = (0,es/* createSelector */.P1)(earningsState, function(calendar) {
    return {
        screenerUniverse: calendar.screenerUniverse,
        earnings: calendar.earings,
        suggestedCompanies: calendar.suggestedCompanies
    };
});
var reducers = {
    clearSuggestionCompany: function(state) {
        state.suggestedCompanies.data.company = [];
    }
};
var earningsEffects = {
    getScreenerUniverse: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SCREENER_UNIVERSE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return screener/* default.getScreenerUniverse */.Z.getScreenerUniverse();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get screener universe is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getEarnings: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EARNINGS, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var page, order, sortcol, year, quarter, companySymbol, filter, response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        page = param.page, order = param.order, sortcol = param.sortcol, year = param.year, quarter = param.quarter, companySymbol = param.companySymbol, filter = param.filter;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return earnings({
                            page: page,
                            order: order,
                            sortcol: sortcol,
                            year: year,
                            quarter: quarter,
                            companySymbol: companySymbol,
                            filter: filter
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt get earnings data is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            filter: filter
                        }));
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getsuggestedCompanies: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SUGGESTED_COMPANY, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var query, response, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = param.query;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return search/* default.getSearchCompany */.Z.getSearchCompany(query);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt get suggested companies is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var extraReducer = function(builder) {
    builder.addCase(earningsEffects.getScreenerUniverse.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, error = _payload.error;
        if (error) {
            state.screenerUniverse.error = error;
        } else {
            state.screenerUniverse.data = data;
            state.screenerUniverse.message = message;
        }
        state.screenerUniverse.isLoading = false;
    }).addCase(earningsEffects.getScreenerUniverse.pending, function(state) {
        state.screenerUniverse.isLoading = true;
    }).addCase(earningsEffects.getScreenerUniverse.rejected, function(state, action) {
        state.screenerUniverse.error = action.payload.error;
        state.screenerUniverse.isLoading = false;
    }).addCase(earningsEffects.getEarnings.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, error = _payload.error, filter = _payload.filter;
        if (error) {
            state.earings.error = error;
        } else {
            state.earings.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                filter: filter
            });
            state.earings.message = message;
        }
        state.earings.isLoading = false;
    }).addCase(earningsEffects.getEarnings.pending, function(state) {
        state.earings.isLoading = true;
    }).addCase(earningsEffects.getEarnings.rejected, function(state, action) {
        state.earings.error = action.payload.error;
        state.earings.isLoading = false;
    }).addCase(earningsEffects.getsuggestedCompanies.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, error = _payload.error;
        if (error) {
            state.suggestedCompanies.error = error;
        } else {
            state.suggestedCompanies.data = data;
            state.suggestedCompanies.message = message;
        }
        state.suggestedCompanies.isLoading = false;
    }).addCase(earningsEffects.getsuggestedCompanies.pending, function(state) {
        state.suggestedCompanies.isLoading = true;
    }).addCase(earningsEffects.getsuggestedCompanies.rejected, function(state, action) {
        state.suggestedCompanies.error = action.payload.error;
        state.suggestedCompanies.isLoading = false;
    });
};
var earningsSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "earnings",
    initialState: initialState,
    // for non-async reducer logic
    reducers: reducers,
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ var slice = (earningsSlice);


/***/ }),

/***/ 28563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51679);
/* harmony import */ var global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47225);
/* harmony import */ var lib_entities_stream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25641);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14601);
/* eslint-disable no-undef */ 







var STATUS_FOLLOWING = 1;
var STATUS_UNFOLLOWING = 0;
var STATUS_SAVED = 1;
var STATUS_UNSAVED = 0;
var STATUS_LIKED = 1;
var STATUS_UNLIKED = 0;
var initialState = {
    post: {},
    isLoading: true,
    error: null,
    message: ""
};
// selectors
var postDetail = function(state) {
    return state.postDetail;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(postDetail, function(detail) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, detail);
});
// Action types
var CONTEXT = "@features/post-detail";
var actionType = {
    GET_POST: "".concat(CONTEXT, "/GET_POST")
};
var effects = {
    getPostDetail: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.GET_POST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var postId, response, _data, _$error, message, postData, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postId = param.postId;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getStreamDetail */ .Z.getStreamDetail(postId);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get stream post detail failed");
                    case 7:
                        _data = response.data, _$error = _data.error_type, message = _data.message, postData = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        data = (0,utils_stream__WEBPACK_IMPORTED_MODULE_4__/* .transformStreamV3 */ .hp)(postData);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            postid: postId
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {};
var extraReducers = function(builder) {
    builder.addCase(effects.getPostDetail.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getPostDetail.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data, postid = _payload.postid;
        if (error) {
            state.error = error;
        } else {
            state.post[postid] = data;
        }
        state.isLoading = false;
        state.message = message;
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.likePost.fulfilled */ .Sz.likePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].liked = STATUS_LIKED;
            state.post[postid].likes = data.likes;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.unlikePost.fulfilled */ .Sz.unlikePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].liked = STATUS_UNLIKED;
            state.post[postid].likes = data.likes;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.followPost.fulfilled */ .Sz.followPost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].follow = STATUS_FOLLOWING;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.unfollowPost.fulfilled */ .Sz.unfollowPost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].follow = STATUS_UNFOLLOWING;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.savePost.fulfilled */ .Sz.savePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].saved = STATUS_SAVED;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.unsavePost.fulfilled */ .Sz.unsavePost.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, postid = _payload.postid;
        if (!error && state.post[postid]) {
            state.post[postid].saved = STATUS_UNSAVED;
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.postVotePolling.fulfilled */ .Sz.postVotePolling.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        var postid = action.meta.arg.postid;
        if (!error && state.post[postid]) {
            state.post[postid].polling = [
                data
            ];
        }
    }).addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.postVoteTargetPrice.fulfilled */ .Sz.postVoteTargetPrice.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        var postid = action.meta.arg.postid;
        if (!error && state.post[postid]) {
            state.post[postid].target_price = data === null || data === void 0 ? void 0 : data.target_price;
        }
    })// Update likes count after get stream likers
    .addCase(global_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_2__/* .effects.getStreamLikers.fulfilled */ .Sz.getStreamLikers.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, postid = _payload.postid, error = _payload.error;
        if (!error && state.post[postid]) {
            var ref;
            state.post[postid].likes = data === null || data === void 0 ? void 0 : (ref = data.likers) === null || ref === void 0 ? void 0 : ref.length;
        }
    })// Update stream if updated
    .addCase(lib_entities_stream__WEBPACK_IMPORTED_MODULE_3__/* .effects.updatePostStream.fulfilled */ .Sz.updatePostStream.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        var currentPost = state.post[data === null || data === void 0 ? void 0 : data.postid];
        // @ts-ignore
        if (data && !error && currentPost) {
            state.post[data === null || data === void 0 ? void 0 : data.postid] = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, currentPost, data);
        }
    });
};
var postDetailSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "postDetail",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (postDetailSlice);


/***/ }),

/***/ 39910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_research__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47752);





// action types
var CONTEXT = "@feature/research";
var actionType = {
    GET_SNIPS: "".concat(CONTEXT, "/GET_SNIPS"),
    GET_CATEGORIES: "".concat(CONTEXT, "/GET_CATEGORIES")
};
var initialState = {
    research: {
        isLoading: true,
        message: null,
        data: [],
        error: null,
        hasMore: true
    },
    categories: {
        isLoading: true,
        message: null,
        data: [],
        error: null
    }
};
var researchState = function(state) {
    return state.research;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(researchState, function(research) {
    return {
        research: {
            isLoading: research.research.isLoading,
            message: research.research.message,
            data: research.research.data,
            error: research.research.error,
            hasMore: research.research.hasMore
        },
        categories: {
            isLoading: research.categories.isLoading,
            message: research.categories.message,
            data: research.categories.data,
            error: research.categories.error
        }
    };
});
var effects = {
    getData: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_SNIPS, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params, param) {
            var getState, categories, ref, _$error, error_type, data, message, research, _research, oldData;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getState = param.getState;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,lib_api_research__WEBPACK_IMPORTED_MODULE_1__/* .getResearchData */ .RJ)(params);
                    case 4:
                        categories = _ctx.sent;
                        if (!(categories.status !== 200)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error");
                    case 7:
                        ref = categories === null || categories === void 0 ? void 0 : categories.data, _$error = ref.error, error_type = ref.error_type, data = ref.data, message = ref.message;
                        if (!(_$error || error_type)) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error || error_type);
                    case 10:
                        research = getState().research;
                        _research = research.research, oldData = _research.data;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            oldData: oldData
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(params, _) {
            return _ref.apply(this, arguments);
        };
    }()),
    getCategories: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_CATEGORIES, // @ts-ignore
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var categories, ref, _$error, error_type, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,lib_api_research__WEBPACK_IMPORTED_MODULE_1__/* .getCategories */ .CP)();
                case 3:
                    categories = _ctx.sent;
                    if (!(categories.status !== 200)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error");
                case 6:
                    ref = categories === null || categories === void 0 ? void 0 : categories.data, _$error = ref.error, error_type = ref.error_type, data = ref.data, message = ref.message;
                    if (!(_$error || error_type)) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error || error_type);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    })))
};
var extraReducer = function(builder) {
    builder.addCase(effects.getData.pending, function(state) {
        state.research.isLoading = true;
    }).addCase(effects.getData.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, oldData = _payload.oldData;
        state.research.isLoading = false;
        if (data === null || data === void 0 ? void 0 : data.length) {
            state.research.data = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(oldData).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(data));
        } else {
            state.research.hasMore = false;
        }
        state.research.message = message;
    }).addCase(effects.getData.rejected, function(state, action) {
        state.research.isLoading = false;
        state.research.error = action.payload.error;
    }).addCase(effects.getCategories.pending, function(state) {
        state.categories.isLoading = true;
    }).addCase(effects.getCategories.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        state.categories.isLoading = false;
        state.categories.data = (data === null || data === void 0 ? void 0 : data.category) || [];
        state.categories.message = message;
    }).addCase(effects.getCategories.rejected, function(state, action) {
        state.categories.isLoading = false;
        state.categories.error = action.payload.error;
    });
};
var researchSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "research",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducer
});
/* harmony default export */ __webpack_exports__["ZP"] = (researchSlice);


/***/ }),

/***/ 7021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export reducers */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6242);




// Auth Related Modules

// Actions
var CONTEXT = "@reset-password";
var actionType = {
    SUBMIT_NEW_PASSWORD: "".concat(CONTEXT, "/SUBMIT_NEW_PASSWORD")
};
// initial state
var initialState = {
    error: null,
    form: {
        newpass: "",
        confirmpass: "",
        passkey: "",
        userid: ""
    },
    isLoading: false,
    isSuccess: false,
    message: "",
    data: null
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return {
        error: state.resetPassword.error,
        isLoading: state.resetPassword.isLoading,
        isSuccess: state.resetPassword.isSuccess,
        message: state.resetPassword.message,
        data: state.resetPassword.data
    };
}, function(state) {
    return state;
});
// Reducer
var reducers = {
    storeCredentials: function(draft, actions) {
        draft.passkey = actions.payload.passkey;
        draft.userid = actions.payload.userid;
    }
};
// effects
var effects = {
    // login
    resetPassword: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.SUBMIT_NEW_PASSWORD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var passkey, userid, newpass, confirmpass, response, _data, message, _$error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        passkey = param.passkey, userid = param.userid, newpass = param.newpass, confirmpass = param.confirmpass;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_auth__WEBPACK_IMPORTED_MODULE_1__/* ["default"].resetPassword */ .Z.resetPassword(userid, passkey, newpass, confirmpass);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error when changing password, no data recevied");
                    case 7:
                        _data = response.data, message = _data.message, _$error = _data.error, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            message: message,
                            data: data
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var _obj;
// Extra / Async Reducer
var extraReducers = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, effects.resetPassword.pending, function(state) {
    state.isLoading = true;
    state.isSuccess = false;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, effects.resetPassword.fulfilled, function(state, action) {
    state.message = action.payload.message;
    state.isLoading = false;
    state.isSuccess = true;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, effects.resetPassword.rejected, function(state, action) {
    state.isLoading = false;
    state.isSuccess = false;
    state.error = action.error;
}), _obj);
// Slice
var resetPasswordSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "resetPassword",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (resetPasswordSlice);


/***/ }),

/***/ 15183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ko": function() { return /* binding */ screenerEffects; },
/* harmony export */   "p0": function() { return /* binding */ screenerSelectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61876);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_screener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70735);
/* eslint-disable no-undef */ 









// action types
var CONTEXT = "@feature/screener";
var actionType = {
    GET_SCREENER_FAVORITES: "".concat(CONTEXT, "/GET_SCREENER_FAVORITES"),
    GET_SCREENER_PRESET: "".concat(CONTEXT, "/GET_SCREENER_PRESET"),
    ADD_FAVORITE_SCREENER: "".concat(CONTEXT, "/ADD_FAVORITE_SCREENER"),
    REMOVE_FAVORITE_SCREENER: "".concat(CONTEXT, "/REMOVE_FAVORITE_SCREENER"),
    GET_SCREENER_UNIVERSE: "".concat(CONTEXT, "/GET_SCREENER_UNIVERSE"),
    GET_SCREENER_FINANCIAL: "".concat(CONTEXT, "/GET_SCREENER_FINANCIAL"),
    SAVE_OR_RUN_SCREENER: "".concat(CONTEXT, "/SAVE_OR_RUN_SCREENER"),
    GET_SCREENER: "".concat(CONTEXT, "/GET_SCREENER"),
    GET_SCREENER_CUSTOM: "".concat(CONTEXT, "/GET_SCREENER_CUSTOM"),
    REMOVE_SCREENER_CUSTOM: "".concat(CONTEXT, "/REMOVE_SCREENER_CUSTOM")
};
var initialState = {
    screenerUtils: {
        isFormActive: false,
        isFormEditMode: false,
        isFormCreateMode: false,
        isModalPresetScreenerActive: false,
        isModalFinancialMetricActive: false,
        isModalAddColumnActive: false,
        screenerAction: null,
        isEmptyResult: false
    },
    screenerFavorites: {
        data: [],
        message: "",
        isError: false,
        isLoading: false
    },
    screenerPreset: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    activeScreener: 0,
    addFavoriteScreenerResult: {
        isError: false,
        isLoading: false,
        message: ""
    },
    removeFavoriteScreenerResult: {
        isError: false,
        isLoading: false,
        message: ""
    },
    screenerUniverse: {
        data: {},
        message: "",
        isError: false,
        isLoading: false
    },
    screenerFinancialMetric: {
        data: [],
        message: "",
        isError: false,
        isLoading: false
    },
    screenerResult: {
        data: {},
        message: "",
        isError: false,
        isLoading: false
    },
    screenerModal: {
        financialModal: {
            id: null,
            name: null
        },
        presetModal: {
            id: null,
            name: null
        },
        addColumnModal: {
            id: null,
            name: null
        }
    },
    screenerCustom: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    removeCustomScreenerResult: {
        data: [],
        message: "",
        isError: false,
        isLoading: false
    },
    screenerPostResult: {
        data: {},
        message: "",
        isError: false,
        isLoading: false
    }
};
var screenerState = function(state) {
    return state.screener;
};
var screenerSelectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(screenerState, function(screener) {
    return {
        screenerUtils: screener.screenerUtils,
        screenerPreset: screener.screenerPreset,
        screenerFavorites: screener.screenerFavorites,
        addFavoriteScreenerResult: screener.addFavoriteScreenerResult,
        removeFavoriteScreenerResult: screener.removeFavoriteScreenerResult,
        screenerUniverse: screener.screenerUniverse,
        screenerFinancialMetric: screener.screenerFinancialMetric,
        screenerModal: screener.screenerModal,
        screenerResult: screener.screenerResult,
        screenerCustom: screener.screenerCustom,
        removeScreenerCustomResult: screener.removeCustomScreenerResult,
        screenerPostResult: screener.screenerPostResult
    };
});
var screenerEffects = {
    getScreenerFavorites: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_FAVORITES, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerFavorites */ .Z.getScreenerFavorites();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get list of favorites screener failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getScreenerPreset: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_PRESET, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerMetrics */ .Z.getScreenerMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get list of screener preset failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    addFavorite: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.ADD_FAVORITE_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var screenerID, screenerType, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        screenerID = param.screenerID, screenerType = param.screenerType;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].addScreenerFavorite */ .Z.addScreenerFavorite(screenerID, screenerType);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to add screener favorite failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    removeFavorite: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.REMOVE_FAVORITE_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var screenerID, screenerType, response, data, removedID;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        screenerID = param.screenerID, screenerType = param.screenerType;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].removeScreenerFavorite */ .Z.removeScreenerFavorite(screenerID, screenerType);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to remove screener favorite failed");
                    case 7:
                        data = response.data;
                        removedID = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, data), {
                            data: screenerID
                        });
                        return _ctx.abrupt("return", removedID);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getScreenerUniverse: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_UNIVERSE, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerUniverse */ .Z.getScreenerUniverse();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get screener universe is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getScreenerFinancialMetric: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_FINANCIAL, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerFinancial */ .Z.getScreenerFinancial();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get financial metric is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    postScreener: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.SAVE_OR_RUN_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
            var fromForm, payload, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        fromForm = _param.fromForm, payload = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
                            "fromForm"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postScreenerListResult */ .Z.postScreenerListResult(payload);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt save or run screener is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, data), {
                            fromForm: fromForm
                        }));
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    getScreener: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var screenerID, type, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        screenerID = param.screenerID, type = param.type;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getLoadPresetScreener */ .Z.getLoadPresetScreener(screenerID, type);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get screener data is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getScreenerCustom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_CUSTOM, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getScreenerCustom */ .Z.getScreenerCustom();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt get custom screener is failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    removeScreenerCustom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.REMOVE_SCREENER_CUSTOM, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var id, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_3__/* ["default"].removeScreenerCustom */ .Z.removeScreenerCustom(id);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to remove custom screener is failed");
                    case 7:
                        data = response.data;
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].SCREENER_TEMPLATE_DELETED */ .Z.SCREENER_TEMPLATE_DELETED, constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", data);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    setIsFormActive: function(state, action) {
        state.screenerUtils.isFormActive = action.payload;
    },
    setIsFormEditMode: function(state, action) {
        state.screenerUtils.isFormEditMode = action.payload;
    },
    setIsFormCreateMode: function(state, action) {
        state.screenerUtils.isFormCreateMode = action.payload;
    },
    setIsModalPresetScreenerActive: function(state, action) {
        state.screenerUtils.isModalPresetScreenerActive = action.payload;
    },
    setIsModalFinancialMetricActive: function(state, action) {
        state.screenerUtils.isModalFinancialMetricActive = action.payload;
    },
    setIsModalAddColumnActive: function(state, action) {
        state.screenerUtils.isModalAddColumnActive = action.payload;
    },
    setActiveScreener: function(state, action) {
        state.activeScreener = action.payload;
    },
    setScreenerModal: function(state, action) {
        var _payload = action.payload, screenerType = _payload.screenerType, id = _payload.id, name = _payload.name;
        if (screenerType === "preset") {
            state.screenerModal.presetModal = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerModal.presetModal), {
                id: id,
                name: name
            });
            state.screenerModal.presetModal.name = name;
        } else if (screenerType === "financial") {
            state.screenerModal.financialModal = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerModal.financialModal), {
                id: id,
                name: name
            });
            state.screenerModal.financialModal.name = name;
        } else if (screenerType === "column") {
            state.screenerModal.addColumnModal = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerModal.addColumnModal), {
                id: id,
                name: name
            });
        }
    },
    resetFormState: function(state) {
        state.screenerUtils.isFormActive = false;
        state.screenerUtils.isFormEditMode = false;
        state.screenerUtils.isFormCreateMode = false;
        state.screenerResult.data = {};
        state.screenerPostResult.data = {};
        state.screenerUtils.screenerAction = null;
        state.screenerUtils.isEmptyResult = false;
    },
    addNewColumn: function(state) {
        state.screenerUtils.isFormActive = false;
        state.screenerUtils.isFormEditMode = false;
        state.screenerUtils.isFormCreateMode = false;
    },
    updateScreenerResult: function(state, action) {
        var _payload = action.payload, screenerAction = _payload.screenerAction, screener = _payload.screener;
        if (screenerAction === "get") {
            state.screenerResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerResult.data, screener);
        }
        if (screenerAction === "post") {
            state.screenerPostResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerPostResult.data, screener);
        }
    },
    resetAddColumnModal: function(state) {
        state.screenerModal.addColumnModal = {
            id: null,
            name: null
        };
    }
};
var extraReducer = function(builder) {
    builder.addCase(screenerEffects.getScreenerFavorites.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerFavorites.isError = true;
        } else {
            state.screenerFavorites.data = data;
            state.screenerFavorites.message = message;
        }
        state.screenerFavorites.isLoading = false;
    }).addCase(screenerEffects.getScreenerFavorites.pending, function(state) {
        state.screenerFavorites.isLoading = true;
    }).addCase(screenerEffects.getScreenerFavorites.rejected, function(state, action) {
        state.screenerFavorites.isError = action.payload.isError;
        state.screenerFavorites.isLoading = false;
    }).addCase(screenerEffects.getScreenerPreset.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerPreset.isError = true;
        } else {
            state.screenerPreset.data = data;
            state.screenerPreset.message = message;
        }
        state.screenerPreset.isLoading = false;
    }).addCase(screenerEffects.getScreenerPreset.pending, function(state) {
        state.screenerPreset.isLoading = true;
    }).addCase(screenerEffects.getScreenerPreset.rejected, function(state, action) {
        state.screenerPreset.isError = action.payload.isError;
        state.screenerPreset.isLoading = false;
    }).addCase(screenerEffects.addFavorite.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        var _screenerFavorites = state.screenerFavorites, baseFavorite = _screenerFavorites.data;
        if (!data) {
            state.addFavoriteScreenerResult.isError = true;
        } else {
            var result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(baseFavorite).concat([
                data
            ]);
            state.screenerFavorites.data = result;
            state.addFavoriteScreenerResult.message = message;
        }
        state.addFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.addFavorite.pending, function(state) {
        state.addFavoriteScreenerResult.isLoading = true;
    }).addCase(screenerEffects.addFavorite.rejected, function(state, action) {
        state.addFavoriteScreenerResult.isError = action.payload.isError;
        state.addFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.removeFavorite.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, obsoleteData = _payload.data;
        var _screenerFavorites = state.screenerFavorites, baseFavorite = _screenerFavorites.data;
        if (!obsoleteData) {
            state.removeFavoriteScreenerResult.isError = true;
        } else {
            var IDRemove = obsoleteData;
            var result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(baseFavorite).filter(function(favoritesScreener) {
                return favoritesScreener.id !== IDRemove;
            });
            state.screenerFavorites.data = result;
            state.removeFavoriteScreenerResult.message = message;
        }
        state.removeFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.removeFavorite.pending, function(state) {
        state.removeFavoriteScreenerResult.isLoading = true;
    }).addCase(screenerEffects.removeFavorite.rejected, function(state, action) {
        state.removeFavoriteScreenerResult.isError = action.payload.isError;
        state.removeFavoriteScreenerResult.isLoading = false;
    }).addCase(screenerEffects.getScreenerUniverse.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerUniverse.isError = true;
        } else {
            state.screenerUniverse.data = data;
            state.screenerUniverse.message = message;
        }
        state.screenerUniverse.isLoading = false;
    }).addCase(screenerEffects.getScreenerUniverse.pending, function(state) {
        state.screenerUniverse.isLoading = true;
    }).addCase(screenerEffects.getScreenerUniverse.rejected, function(state, action) {
        state.screenerUniverse.isError = action.payload.isError;
        state.screenerUniverse.isLoading = false;
    }).addCase(screenerEffects.getScreenerFinancialMetric.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerFinancialMetric.isError = true;
        } else {
            state.screenerFinancialMetric.data = data;
            state.screenerFinancialMetric.message = message;
        }
        state.screenerFinancialMetric.isLoading = false;
    }).addCase(screenerEffects.getScreenerFinancialMetric.pending, function(state) {
        state.screenerFinancialMetric.isLoading = true;
    }).addCase(screenerEffects.getScreenerFinancialMetric.rejected, function(state, action) {
        state.screenerFinancialMetric.isError = action.payload.isError;
        state.screenerFinancialMetric.isLoading = false;
    }).addCase(screenerEffects.postScreener.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, fromForm = _payload.fromForm;
        var arg = action.meta.arg;
        if (!data) {
            state.screenerPostResult.isError = true;
        } else {
            state.screenerPostResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerPostResult.data, data);
            // Sync ScreenerForm state after submitting form
            // use case for `rules`, etc.
            if (fromForm) {
                var screenerid = data.screenerid, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(data, [
                    "screenerid"
                ]);
                state.screenerResult.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerResult.data, rest), {
                    screenerid: arg.save === "1" ? screenerid : state.screenerResult.data.screenerid
                });
            }
            state.screenerPostResult.message = message;
            state.screenerUtils.isFormCreateMode = false;
        }
        state.screenerPostResult.isLoading = false;
    }).addCase(screenerEffects.postScreener.pending, function(state) {
        state.screenerPostResult.isLoading = true;
        state.screenerUtils.screenerAction = "post";
        state.screenerUtils.isEmptyResult = false;
    }).addCase(screenerEffects.postScreener.rejected, function(state, action) {
        state.screenerPostResult.isError = action.payload.isError;
        state.screenerPostResult.isLoading = false;
        state.screenerUtils.isEmptyResult = true;
    }).addCase(screenerEffects.getScreener.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerResult.isError = true;
        } else {
            var screenerid = data.screenerid, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(data, [
                "screenerid"
            ]);
            state.screenerResult.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerResult.data, rest), {
                screenerid: rest.isguru ? 0 : screenerid
            });
            state.screenerPostResult.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.screenerPostResult.data, rest), {
                screenerid: screenerid
            });
            state.screenerResult.message = message;
        }
        state.screenerResult.isLoading = false;
    }).addCase(screenerEffects.getScreener.pending, function(state) {
        state.screenerResult.isLoading = true;
        state.screenerPostResult.data = {};
        state.screenerUtils.screenerAction = "get";
        state.screenerUtils.isEmptyResult = false;
    }).addCase(screenerEffects.getScreener.rejected, function(state, action) {
        state.screenerResult.isError = action.payload.isError;
        state.screenerResult.isLoading = false;
        state.screenerUtils.isEmptyResult = true;
    }).addCase(screenerEffects.getScreenerCustom.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.screenerCustom.isError = true;
        } else {
            state.screenerCustom.data = data;
            state.screenerCustom.message = message;
        }
        state.screenerCustom.isLoading = false;
    }).addCase(screenerEffects.getScreenerCustom.pending, function(state) {
        state.screenerCustom.isLoading = true;
    }).addCase(screenerEffects.getScreenerCustom.rejected, function(state, action) {
        state.screenerCustom.isError = action.payload.isError;
        state.screenerCustom.isLoading = false;
        state.screenerUtils.isEmptyResult = true;
    }).addCase(screenerEffects.removeScreenerCustom.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data;
        if (!data) {
            state.removeCustomScreenerResult.isError = true;
        } else {
            state.removeCustomScreenerResult.data = data;
            state.removeCustomScreenerResult.message = message;
        }
        state.removeCustomScreenerResult.isLoading = false;
    }).addCase(screenerEffects.removeScreenerCustom.pending, function(state) {
        state.removeCustomScreenerResult.isLoading = true;
    }).addCase(screenerEffects.removeScreenerCustom.rejected, function(state, action) {
        state.removeCustomScreenerResult.isError = action.payload.isError;
        state.removeCustomScreenerResult.isLoading = false;
    });
};
var screenerSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
    name: "screener",
    initialState: initialState,
    // for non-async reducer logic
    reducers: reducers,
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ __webpack_exports__["ZP"] = (screenerSlice);


/***/ }),

/***/ 17712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": function() { return /* binding */ valuationEffects; },
/* harmony export */   "FA": function() { return /* binding */ valuationSelectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25516);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41208);
/* harmony import */ var lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17065);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44590);









// action types
var CONTEXT = "@feature/valuation";
var actionType = {
    GET_VALUATION_METRICS: "".concat(CONTEXT, "/GET_VALUATION_METRICS"),
    GET_COMPANY_SYMBOL: "".concat(CONTEXT, "/GET_COMPANY_SYMBOL"),
    GET_DEFAULT_VALUATION_METRIC: "".concat(CONTEXT, "/GET_DEFAULT_VALUATION_METRIC"),
    GET_VALUATION_EPS: "".concat(CONTEXT, "/GET_VALUATION_EPS"),
    GET_VALUATION_GROWTH: "".concat(CONTEXT, "/GET_VALUATION_GROWTH"),
    GET_VALUATION_MULTIPLE: "".concat(CONTEXT, "/GET_VALUATION_MULTIPLE"),
    RUN_VALUATION: "".concat(CONTEXT, "/RUN_VALUATION"),
    CREATE_VALUATION_TEMPLATE: "".concat(CONTEXT, "/CREATE_VALUATION_TEMPLATE"),
    GET_VALUATION_TEMPLATE_DETAIL: "".concat(CONTEXT, "/GET_VALUATION_TEMPLATE_DETAIL"),
    UPDATE_VALUATION_TEMPLATE_DETAIL: "".concat(CONTEXT, "/UPDATE_VALUATION_TEMPLATE_DETAIL"),
    DELETE_VALUATION_TEMPLATE_DETAIL: "".concat(CONTEXT, "/DELETE_VALUATION_TEMPLATE_DETAIL")
};
var initialState = {
    valuationSymbol: {
        id: "",
        symbol: ""
    },
    valuationMetricOptions: {
        message: "",
        data: {},
        isError: false,
        isLoading: false
    },
    valuationEPS: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    valuationGROWTH: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    valuationMULTIPLE: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    valuationDefaultMetric: {
        message: "",
        data: [],
        isError: false,
        isLoading: false
    },
    valuationResult: {
        data: {
            consensus_high: "",
            consensus_low: "",
            consensus_medium: "",
            country: "",
            current_price: "",
            exchange: "",
            margin_safety: "",
            symbol: "",
            symbol_2: "",
            symbol_3: "",
            target_price: ""
        },
        message: "",
        isError: false,
        isLoading: false
    },
    valuationCreateTemplateResult: {
        message: "",
        isError: false,
        isLoading: false,
        data: {}
    },
    valuationUpdateTemplateResult: {
        message: "",
        isError: false,
        isLoading: false,
        data: []
    },
    valuationDeleteTemplateResult: {
        message: "",
        isError: false,
        isLoading: false,
        data: []
    },
    valuationTemplateDetail: {
        message: "",
        isError: false,
        isLoading: false,
        data: {}
    },
    companySymbol: {
        data: {},
        isError: false,
        isLoading: false,
        message: ""
    },
    metric: {
        comp_id: "",
        item: []
    },
    note: "",
    isMobileView: false,
    valuationMetricKeyword: ""
};
var valuationState = function(state) {
    return state.valuation;
};
var valuationSelectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(valuationState, function(valuation) {
    return {
        valuationSymbol: valuation.valuationSymbol,
        valuationMetricOptions: valuation.valuationMetricOptions,
        valuationDefaultMetric: valuation.valuationDefaultMetric,
        valuationEPS: valuation.valuationEPS,
        valuationGROWTH: valuation.valuationGROWTH,
        valuationMULTIPLE: valuation.valuationMULTIPLE,
        valuationResult: valuation.valuationResult,
        valuationCreateTemplateResult: valuation.valuationCreateTemplateResult,
        valuationUpdateTemplateResult: valuation.valuationUpdateTemplateResult,
        valuationDeleteTemplateResult: valuation.valuationDeleteTemplateResult,
        valuationDetail: valuation.valuationTemplateDetail,
        companySymbols: valuation.companySymbol,
        metric: valuation.metric,
        note: valuation.note,
        isMobileView: valuation.isMobileView,
        valuationMetricKeyword: valuation.valuationMetricKeyword
    };
});
var valuationEffects = {
    getValuationMetrics: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_METRICS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationMetrics */ .Z.getValuationMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get valuation metrics failed");
                case 6:
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getCompanySymbol: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_COMPANY_SYMBOL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(query) {
            var response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getSearchCompany */ .Z.getSearchCompany(query);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get company symbol is failed");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(query) {
            return _ref.apply(this, arguments);
        };
    }()),
    getDefaultValuationMetric: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_DEFAULT_VALUATION_METRIC, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationMetricsDefault */ .Z.getValuationMetricsDefault({
                            symbol: symbol
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get default metric is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getValuationEPS: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_EPS, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, metricID, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, metricID = param.metricID;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationMetricPerID */ .Z.getValuationMetricPerID(symbol, metricID);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get metric EPS is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getValuationGROWTH: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_GROWTH, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, metricID, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, metricID = param.metricID;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationMetricPerID */ .Z.getValuationMetricPerID(symbol, metricID);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get metric GROWTH is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getValuationMULTIPLE: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_MULTIPLE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, metricID, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, metricID = param.metricID;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationMetricPerID */ .Z.getValuationMetricPerID(symbol, metricID);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get metric MULTIPLE is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    createValuation: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.RUN_VALUATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, eps_value, growth_value, multiple_value, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, eps_value = param.eps_value, growth_value = param.growth_value, multiple_value = param.multiple_value;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postValuationResult */ .Z.postValuationResult({
                            symbol: symbol,
                            eps_value: eps_value,
                            growth_value: growth_value,
                            multiple_value: multiple_value
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to create valuation is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    createValuationTemplete: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.CREATE_VALUATION_TEMPLATE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var payload, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        payload = param.payload;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postValuationTemplateAdd */ .Z.postValuationTemplateAdd(payload);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to create valuation template is failed");
                    case 7:
                        data = response.data;
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(data.message, constants_successMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", data);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getValuationDetailTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_TEMPLATE_DETAIL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateID) {
            var response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getValuationTemplateLoad */ .Z.getValuationTemplateLoad(templateID);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get valuation detail is failed");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(templateID) {
            return _ref.apply(this, arguments);
        };
    }()),
    updateValuationDetailTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.UPDATE_VALUATION_TEMPLATE_DETAIL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var payload, templateID, response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        payload = param.payload, templateID = param.templateID;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postValuationTemplateSave */ .Z.postValuationTemplateSave(templateID, payload);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to update valuation detail is failed");
                    case 7:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    deleteValuationDetailTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.DELETE_VALUATION_TEMPLATE_DETAIL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateID) {
            var response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_3__/* ["default"].postDeleteValuationTemplate */ .Z.postDeleteValuationTemplate(templateID);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to delete valuation detail is failed");
                    case 6:
                        data = response.data;
                        return _ctx.abrupt("return", data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(templateID) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    setValuationSymbol: function(state, action) {
        var _payload = action.payload, id = _payload.id, symbol = _payload.symbol;
        state.valuationSymbol = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationSymbol), {
            id: id,
            symbol: symbol
        });
    },
    setValuationMetric: function(state, action) {
        var _payload = action.payload, compID = _payload.comp_id, item = _payload.item;
        state.metric = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.metric), {
            comp_id: compID,
            item: item
        });
    },
    setValuationNote: function(state, action) {
        state.note = action.payload;
    },
    setValuationResult: function(state, action) {
        state.valuationResult = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationResult), {
            data: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationResult.data, action.payload),
            isError: false,
            isLoading: false,
            message: ""
        });
    },
    resetValuationSymbol: function(state) {
        state.valuationSymbol = {
            id: "",
            symbol: ""
        };
    },
    resetValuationResult: function(state) {
        state.valuationResult = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationResult), {
            data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationResult.data), {
                consensus_high: "",
                consensus_low: "",
                consensus_medium: "",
                country: "",
                current_price: "",
                exchange: "",
                margin_safety: "",
                symbol: "",
                symbol_2: "",
                symbol_3: "",
                target_price: ""
            }),
            isError: false,
            isLoading: false,
            message: ""
        });
    },
    resetValuationDetail: function(state) {
        state.valuationTemplateDetail = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationTemplateDetail), {
            data: {},
            isError: false,
            isLoading: false,
            message: ""
        });
    },
    resetTemplateResult: function(state) {
        state.valuationCreateTemplateResult = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationCreateTemplateResult), {
            data: {},
            isError: false,
            isLoading: false,
            message: ""
        });
    },
    setIsMobileView: function(state, action) {
        state.isMobileView = action.payload;
    },
    setValuationMetricKeyword: function(state, action) {
        state.valuationMetricKeyword = action.payload;
    }
};
var extraReducer = function(builder) {
    builder.addCase(valuationEffects.getValuationMetrics.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationMetricOptions.isError = isError;
            state.valuationMetricOptions.message = message;
        } else {
            state.valuationMetricOptions.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationMetricOptions.data, data);
            state.valuationMetricOptions.message = message;
        }
        state.valuationMetricOptions.isLoading = false;
    }).addCase(valuationEffects.getValuationMetrics.pending, function(state) {
        state.valuationMetricOptions.isLoading = true;
    }).addCase(valuationEffects.getValuationMetrics.rejected, function(state, action) {
        state.valuationMetricOptions.isError = action.payload.isError;
        state.valuationMetricOptions.isLoading = false;
    }).addCase(valuationEffects.getCompanySymbol.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.companySymbol.isError = isError;
            state.companySymbol.message = message;
        } else {
            state.companySymbol.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.companySymbol.data, data);
            state.companySymbol.message = message;
        }
        state.companySymbol.isLoading = false;
    }).addCase(valuationEffects.getCompanySymbol.pending, function(state) {
        state.companySymbol.isLoading = true;
    }).addCase(valuationEffects.getCompanySymbol.rejected, function(state, action) {
        state.companySymbol.isError = action.payload.isError;
        state.companySymbol.isLoading = false;
    }).addCase(valuationEffects.getDefaultValuationMetric.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationDefaultMetric.isError = isError;
            state.valuationDefaultMetric.message = message;
        } else {
            state.valuationDefaultMetric.data = data;
            state.valuationDefaultMetric.message = message;
        }
        state.valuationDefaultMetric.isLoading = false;
    }).addCase(valuationEffects.getDefaultValuationMetric.pending, function(state) {
        state.valuationDefaultMetric.isLoading = true;
    }).addCase(valuationEffects.getDefaultValuationMetric.rejected, function(state, action) {
        state.valuationDefaultMetric.isError = action.payload.isError;
        state.valuationDefaultMetric.isLoading = false;
    }).addCase(valuationEffects.getValuationEPS.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationEPS.isError = isError;
            state.valuationEPS.message = message;
        } else {
            state.valuationEPS.data = data;
            state.valuationEPS.message = message;
        }
        state.valuationEPS.isLoading = false;
    }).addCase(valuationEffects.getValuationEPS.pending, function(state) {
        state.valuationEPS.isLoading = true;
    }).addCase(valuationEffects.getValuationEPS.rejected, function(state, action) {
        state.valuationEPS.isError = action.payload.isError;
        state.valuationEPS.isLoading = false;
    }).addCase(valuationEffects.getValuationGROWTH.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationGROWTH.isError = isError;
            state.valuationGROWTH.message = message;
        } else {
            state.valuationGROWTH.data = data;
            state.valuationGROWTH.message = message;
        }
        state.valuationGROWTH.isLoading = false;
    }).addCase(valuationEffects.getValuationGROWTH.pending, function(state) {
        state.valuationGROWTH.isLoading = true;
    }).addCase(valuationEffects.getValuationGROWTH.rejected, function(state, action) {
        state.valuationGROWTH.isError = action.payload.isError;
        state.valuationGROWTH.isLoading = false;
    }).addCase(valuationEffects.getValuationMULTIPLE.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationMULTIPLE.isError = isError;
            state.valuationMULTIPLE.message = message;
        } else {
            state.valuationMULTIPLE.data = data;
            state.valuationMULTIPLE.message = message;
        }
        state.valuationMULTIPLE.isLoading = false;
    }).addCase(valuationEffects.getValuationMULTIPLE.pending, function(state) {
        state.valuationMULTIPLE.isLoading = true;
    }).addCase(valuationEffects.getValuationMULTIPLE.rejected, function(state, action) {
        state.valuationMULTIPLE.isError = action.payload.isError;
        state.valuationMULTIPLE.isLoading = false;
    }).addCase(valuationEffects.createValuation.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationResult.isError = isError;
            state.valuationResult.message = message;
        } else {
            state.valuationResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationResult.data, data);
            state.valuationResult.message = message;
        }
        state.valuationResult.isLoading = false;
    }).addCase(valuationEffects.createValuation.pending, function(state) {
        state.valuationResult.isLoading = true;
    }).addCase(valuationEffects.createValuation.rejected, function(state, action) {
        state.valuationResult.isError = action.payload.isError;
        state.valuationResult.isLoading = false;
    }).addCase(valuationEffects.createValuationTemplete.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationCreateTemplateResult.isError = isError;
            state.valuationCreateTemplateResult.message = message;
        } else {
            state.valuationCreateTemplateResult.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationCreateTemplateResult.data, data);
            state.valuationCreateTemplateResult.message = message;
            valuationEffects.getValuationDetailTemplate(data.id);
        }
        state.valuationCreateTemplateResult.isLoading = false;
    }).addCase(valuationEffects.createValuationTemplete.pending, function(state) {
        state.valuationCreateTemplateResult.isLoading = true;
    }).addCase(valuationEffects.createValuationTemplete.rejected, function(state, action) {
        state.valuationCreateTemplateResult.isError = action.payload.isError;
        state.valuationCreateTemplateResult.isLoading = false;
    }).addCase(valuationEffects.getValuationDetailTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationTemplateDetail.isError = isError;
            state.valuationTemplateDetail.message = message;
        } else {
            state.valuationTemplateDetail.data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.valuationTemplateDetail.data, data);
            state.valuationTemplateDetail.message = message;
        }
        state.valuationTemplateDetail.isLoading = false;
    }).addCase(valuationEffects.getValuationDetailTemplate.pending, function(state) {
        state.valuationTemplateDetail.isLoading = true;
    }).addCase(valuationEffects.getValuationDetailTemplate.rejected, function(state, action) {
        state.valuationTemplateDetail.isError = action.payload.isError;
        state.valuationTemplateDetail.isLoading = false;
    }).addCase(valuationEffects.updateValuationDetailTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationUpdateTemplateResult.isError = isError;
            state.valuationUpdateTemplateResult.message = message;
        } else {
            state.valuationUpdateTemplateResult.data = data;
            state.valuationUpdateTemplateResult.message = message;
        }
        state.valuationUpdateTemplateResult.isLoading = false;
    }).addCase(valuationEffects.updateValuationDetailTemplate.pending, function(state) {
        state.valuationUpdateTemplateResult.isLoading = true;
    }).addCase(valuationEffects.updateValuationDetailTemplate.rejected, function(state, action) {
        state.valuationUpdateTemplateResult.isError = action.payload.isError;
        state.valuationUpdateTemplateResult.isLoading = false;
    }).addCase(valuationEffects.deleteValuationDetailTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, message = _payload.message, data = _payload.data, isError = _payload.isError;
        if (isError) {
            state.valuationDeleteTemplateResult.isError = isError;
            state.valuationDeleteTemplateResult.message = message;
        } else {
            state.valuationDeleteTemplateResult.data = data;
            state.valuationDeleteTemplateResult.message = message;
        }
        state.valuationDeleteTemplateResult.isLoading = false;
    }).addCase(valuationEffects.deleteValuationDetailTemplate.pending, function(state) {
        state.valuationDeleteTemplateResult.isLoading = true;
    }).addCase(valuationEffects.deleteValuationDetailTemplate.rejected, function(state, action) {
        state.valuationDeleteTemplateResult.isError = action.payload.isError;
        state.valuationDeleteTemplateResult.isLoading = false;
    });
};
var valuationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "valuation",
    initialState: initialState,
    // for non-async reducer logic
    reducers: reducers,
    // for async reducer logic
    extraReducers: extraReducer
});
/* harmony default export */ __webpack_exports__["ZP"] = (valuationSlice);


/***/ }),

/***/ 67266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CJ": function() { return /* binding */ thunks; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6430);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63762);








// utils

// constants
var SLICE_NAME = "collection";
// initial state
var initialState = {
    available: [],
    isDropdownOpen: false,
    isFormOpen: false,
    isCollectionLoading: false,
    error: null,
    needRefresh: false,
    selectedForModify: null,
    modalVisible: "none"
};
var reducers = {
    handleSetDropdown: function(draft, action) {
        draft.isDropdownOpen = action.payload.isOpen;
    },
    handleSetFormOpen: function(draft, action) {
        draft.isFormOpen = action.payload.isOpen;
    },
    handleSelectForModify: function(draft, action) {
        draft.selectedForModify = draft.available[action.payload.selectedIndex];
        draft.modalVisible = action.payload.modalType;
        draft.isDropdownOpen = false;
    }
};
var thunks = {
    createCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/CREATE_NEW_COMPANY_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var name, desc, response, _data, error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, desc = param.desc;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].createNewWatchlist */ .Z.createNewWatchlist(name, desc);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to add watchlist failed!");
                    case 6:
                        _data = response.data, error = _data.error_type, data = _data.data;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                            messageType: "success",
                            content: "New watchlist group is added",
                            alertType: "plain"
                        });
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    fetchSavedCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/FETCH_SAVED_COMPANY_WATCHLIST"), (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, error;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getAllWatchlist */ .Z.getAllWatchlist();
                case 2:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Attempt to get saved watchlist failed!");
                case 5:
                    _data = response.data, data = _data.data, error = _data.error_type;
                    if (!error) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error(error);
                case 8:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    editCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/EDIT_SELECTED_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var name, desc, id, response, _data, error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, desc = param.desc, id = param.id;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].updateWatchlist */ .Z.updateWatchlist(id, name, desc);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to update saved watchlist failed!");
                    case 6:
                        _data = response.data, error = _data.error_type, data = _data.data;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                            messageType: "success",
                            content: "Your stock watchlist is updated",
                            alertType: "plain"
                        });
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    deleteCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/DELETE_SELECTED_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var id, response, _data, error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].deleteWatchlistById */ .Z.deleteWatchlistById(id);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to delete saved watchlist failed!");
                    case 6:
                        _data = response.data, error = _data.error_type, data = _data.data, message = _data.message;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                            messageType: "success",
                            content: message,
                            alertType: "plain"
                        });
                        return _ctx.abrupt("return", {
                            data: data,
                            id: id
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    // fetchSavedCompanyWatchlist
    builder.addCase(thunks.fetchSavedCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
        draft.needRefresh = false;
    }).addCase(thunks.fetchSavedCompanyWatchlist.fulfilled, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.available = action.payload.data;
    }).addCase(thunks.fetchSavedCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    })// createCompanyWatchlist
    .addCase(thunks.createCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
    }).addCase(thunks.createCompanyWatchlist.fulfilled, function(draft, action) {
        var newWatchlist = action.payload.data;
        if (newWatchlist) {
            draft.available.push(newWatchlist);
        }
        draft.isCollectionLoading = false;
        draft.needRefresh = false;
        draft.isFormOpen = false;
    }).addCase(thunks.createCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    })// editCompanyWatchlist
    .addCase(thunks.editCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
    }).addCase(thunks.editCompanyWatchlist.fulfilled, function(draft) {
        draft.isCollectionLoading = false;
        draft.selectedForModify = null;
        draft.modalVisible = "none";
        draft.needRefresh = true;
    }).addCase(thunks.editCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    })// deleteCompanyWatchlist
    .addCase(thunks.deleteCompanyWatchlist.pending, function(draft) {
        draft.isCollectionLoading = true;
    }).addCase(thunks.deleteCompanyWatchlist.fulfilled, function(draft, action) {
        var id = action.payload.id;
        var newList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(draft.available);
        var idx = newList.findIndex(function(item) {
            return Number(item.watchlist_id) === Number(id);
        });
        if (idx > -1) {
            newList.splice(idx, 1);
            draft.available = newList;
        }
        draft.isCollectionLoading = false;
        draft.selectedForModify = null;
        draft.modalVisible = "none";
    // draft.needRefresh = true;
    }).addCase(thunks.deleteCompanyWatchlist.rejected, function(draft, action) {
        draft.isCollectionLoading = false;
        draft.error = action.error;
    });
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, function(state) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.collection), {
        activeWatchlistId: state.root.activeWatchlistId,
        activeWatchlistName: state.root.activeWatchlistName
    });
});
var collectionSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (collectionSlice);


/***/ }),

/***/ 66960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CJ": function() { return /* binding */ thunks; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15056);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6430);
/* harmony import */ var _Table_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85833);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63762);






// other slice


// utils

// constants
var SLICE_NAME = "deleteCompanyModal";
// initial state
var initialState = {
    error: null,
    isLoading: false,
    isModalVisible: false,
    selected: undefined
};
var reducers = {
    handleDeleteCompanyClick: function(draft, action) {
        draft.isModalVisible = true;
        draft.selected = action.payload;
    },
    handleModalCancel: function(draft) {
        draft.isModalVisible = false;
        draft.selected = null;
    }
};
var thunks = {
    handleConfirmRemoveCompany: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/CONFIRM_REMOVE_COMPANY"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var companyid, watchlistid, dispatch, response, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        companyid = param.companyid, watchlistid = param.watchlistid, dispatch = param1.dispatch;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postUnfollowCompany */ .Z.postUnfollowCompany(watchlistid, companyid);
                    case 3:
                        response = _ctx.sent;
                        error = response.data.error;
                        if (!error) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(error);
                    case 7:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                            content: "Stock is removed",
                            messageType: "success",
                            alertType: "plain"
                        });
                        dispatch(_Table_slice__WEBPACK_IMPORTED_MODULE_3__/* .thunks.fetchCompanyWatchlist */ .CJ.fetchCompanyWatchlist({
                            watchlistid: watchlistid
                        }));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    builder// delete
    .addCase(thunks.handleConfirmRemoveCompany.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.handleConfirmRemoveCompany.fulfilled, function(draft) {
        draft.isLoading = false;
        draft.isModalVisible = false;
        draft.selected = null;
    }).addCase(thunks.handleConfirmRemoveCompany.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.isModalVisible = false;
        draft.selected = null;
        draft.error = action.error;
    });
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, function(state) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.watchlistTable.deleteModal), {
        activeWatchlistid: state.root.activeWatchlistId
    });
});
var deleteCompanyModalSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (deleteCompanyModalSlice);


/***/ }),

/***/ 13795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ FinancialMetric_slice; },
  "xv": function() { return /* binding */ listMetricsSelector; },
  "wl": function() { return /* binding */ slice_selectors; },
  "CJ": function() { return /* binding */ thunks; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
;// CONCATENATED MODULE: ./src/lib/api/metric.ts

var request = (0,requestExodus/* default */.Z)();
var getFinancialMetric = function() {
    return request.get("/watchlist/metric");
};
/* harmony default export */ var metric = ({
    getFinancialMetric: getFinancialMetric
});

// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/features/watchlist/selectors.ts
var selectors = __webpack_require__(63762);
// EXTERNAL MODULE: ./src/features/watchlist/WatchlistTable/Table/slice.ts
var slice = __webpack_require__(85833);
;// CONCATENATED MODULE: ./src/features/watchlist/WatchlistTable/FinancialMetric/slice.ts










// utils

// local slices

// destructure
var tableActions = slice/* default.actions */.ZP.actions;
// constants
var SLICE_NAME = "financialMetrics";
var THUNK_CONTEXT = "feature/watchlist/financialMetrics";
// initial state
var initialState = {
    error: null,
    isLoading: false,
    isModalOpen: false,
    list: [],
    menu: [
        [],
        [],
        []
    ],
    selectedColumnId: {
        0: null,
        1: null
    }
};
var reducers = {
    toggleModalVisibility: function(draft, action) {
        var isOpen = action.payload.visibility || !draft.isModalOpen;
        draft.isModalOpen = isOpen;
    },
    handleMenuClick: function(draft, action) {
        var _payload = action.payload, columnIndex = _payload.columnIndex, childs = _payload.childs, id = _payload.id;
        // update the selected column id per column index
        draft.selectedColumnId[columnIndex] = id;
        //  reset the child columns first
        draft.menu[columnIndex + 1] = [];
        if (columnIndex === 0) {
            draft.menu[columnIndex + 2] = [];
        }
        // then re-fill up the child column
        draft.menu[columnIndex + 1] = childs;
    }
};
var thunks = {
    fetchMetrics: (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(THUNK_CONTEXT, "/FETCH_METRICS"), (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, body;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return metric.getFinancialMetric();
                case 2:
                    response = _ctx.sent;
                    body = response.data;
                    if (!body.error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(body.error);
                case 6:
                    return _ctx.abrupt("return", {
                        data: body.data
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    addMetrics: (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(THUNK_CONTEXT, "/ADD_METRICS"), function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var fitem, watchlistid, name, dispatch, response, _data, data, error, message, result, ref, _data1, data1, message1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        fitem = param.fitem, watchlistid = param.watchlistid, name = param.name, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return watchlist/* default.addFinancialMetrics */.Z.addFinancialMetrics(watchlistid, fitem);
                    case 4:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error, message = _data.message;
                        if (!error) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error(error);
                    case 8:
                        (0,AlertMessage/* default */.Z)({
                            content: message,
                            messageType: "success",
                            alertType: "plain"
                        });
                        result = {
                            column: {
                                dataIndex: data.item_id.toString(),
                                title: data.item_name,
                                key: data.item_id.toString()
                            },
                            results: data.results
                        };
                        dispatch(tableActions.addColumn(result));
                        _ctx.next = 18;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        ref = (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.response) || {}, _data1 = ref.data, data1 = _data1 === void 0 ? {} : _data1;
                        message1 = (data1 === null || data1 === void 0 ? void 0 : data1.message) || "";
                        if (message1.toLowerCase().includes("duplicate")) {
                            (0,AlertErrorMessage/* default */.Z)("Column '".concat(name, "' already exist"), errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        }
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    builder// fetch financial metrics
    .addCase(thunks.fetchMetrics.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.fetchMetrics.fulfilled, function(draft, action) {
        draft.isLoading = false;
        draft.list = action.payload.data;
        draft.menu[0] = action.payload.data;
    }).addCase(thunks.fetchMetrics.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    })// add financial metrics to watchlist
    .addCase(thunks.addMetrics.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.addMetrics.fulfilled, function(draft) {
        draft.isLoading = false;
        draft.isModalOpen = false;
    }).addCase(thunks.addMetrics.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    });
};
// selectors
var slice_selectors = (0,es/* createSelector */.P1)(selectors/* default */.ZP, function(state) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.watchlistTable.financialMetrics), {
        activeWatchlistid: state.root.activeWatchlistId
    });
});
var listMetricsSelector = (0,es/* createSelector */.P1)(function(state) {
    return state.watchlist.watchlistTable.financialMetrics.list;
}, function(state) {
    return state;
});
var financialMetricSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var FinancialMetric_slice = (financialMetricSlice);


/***/ }),

/***/ 78086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CJ": function() { return /* binding */ thunks; },
/* harmony export */   "_7": function() { return /* binding */ suggestionSelector; }
/* harmony export */ });
/* unused harmony export selectors */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68697);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1349);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var _Table_slice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85833);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63762);









// utils

// constants
var SLICE_NAME = "table";
// initial state
var initialState = {
    error: null,
    isLoading: false,
    suggestions: []
};
var reducers = {
    clearSearch: function(state) {
        state.suggestions = [];
        return state;
    }
};
var thunks = {
    fetchCompanySuggestions: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/FETCH_COMPANY_SUGGESTIONS"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
            var params, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _param);
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearchCompany */ .Z.getSearchCompany(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to fetch suggestion company failed");
                    case 6:
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data === null || data === void 0 ? void 0 : data.companies
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    handleSuggestionsSelected: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/ADD_SUGGESTIONS_TO_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var companyid, watchlistid, dispatch, response, _data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        companyid = param.companyid, watchlistid = param.watchlistid, dispatch = param1.dispatch;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postFollowCompany */ .Z.postFollowCompany(watchlistid, companyid);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to follow company failed");
                    case 6:
                        _data = response.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        dispatch(_Table_slice__WEBPACK_IMPORTED_MODULE_3__/* .thunks.fetchCompanyWatchlist */ .CJ.fetchCompanyWatchlist({
                            watchlistid: watchlistid
                        }));
                        return _ctx.abrupt("return", {
                            data: response.data.data
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    builder// handle save to company
    .addCase(thunks.handleSuggestionsSelected.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.handleSuggestionsSelected.fulfilled, function(draft) {
        draft.isLoading = false;
    }).addCase(thunks.handleSuggestionsSelected.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    })// Extra reducers for fetch suggestions
    .addCase(thunks.fetchCompanySuggestions.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.fetchCompanySuggestions.fulfilled, function(draft, action) {
        draft.isLoading = false;
        draft.suggestions = action.payload.data;
    }).addCase(thunks.fetchCompanySuggestions.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    });
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, function(state) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, state.watchlistTable.companySuggestions), {
        activeWatchlistid: state.root.activeWatchlistId
    });
});
var suggestionSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSelector */ .P1)(function(state) {
    return state.watchlist.watchlistTable.companySuggestions.suggestions;
}, function(state) {
    return state;
});
var companySuggestionsSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (companySuggestionsSlice);


/***/ }),

/***/ 85833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CJ": function() { return /* binding */ thunks; },
/* harmony export */   "GY": function() { return /* binding */ dataSourceSelector; },
/* harmony export */   "_P": function() { return /* binding */ loadingTableSelector; },
/* harmony export */   "wl": function() { return /* binding */ selectors; },
/* harmony export */   "yV": function() { return /* binding */ columnSelector; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68697);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41208);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62974);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6430);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63762);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26857);
/* eslint-disable @typescript-eslint/ban-types */ /* eslint-disable camelcase */ 









// utils

// Utils

// constants
var SLICE_NAME = "table";
// initial state
var initialState = {
    error: null,
    isLoading: false,
    columns: [],
    fitems: {},
    headers: [],
    symbols: {}
};
var reducers = {
    addColumn: function(draft, action) {
        draft.columns.push(action.payload.column);
    },
    updateColumns: function(draft, action) {
        draft.columns = action.payload.columns;
    }
};
var thunks = {
    fetchCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/FETCH_COMPANY_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var watchlistid, params, response, body, _data, headerCustom, result, customHeader, customColumn, companyDataSource, customHeaderObject, symbols, datasource;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistid = param.watchlistid;
                        params = {
                            setfincol: 1
                        };
                        _ctx.next = 4;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getDetailWatchlist */ .Z.getDetailWatchlist(watchlistid, params);
                    case 4:
                        response = _ctx.sent;
                        body = response.data;
                        if (!body.error) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error(body.error);
                    case 8:
                        _data = body.data, headerCustom = _data.header_custom, result = _data.result;
                        customHeader = _utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].mapCustomHeader */ .Z.mapCustomHeader(headerCustom);
                        customColumn = customHeader.map(_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].mapCustomColumnFromHeader */ .Z.mapCustomColumnFromHeader);
                        companyDataSource = result.map(_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].mapCompanyDataSource */ .Z.mapCompanyDataSource);
                        customHeaderObject = customHeader.reduce(_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].customHeaderObjectReducer */ .Z.customHeaderObjectReducer, {});
                        symbols = _utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].generateSymbols */ .Z.generateSymbols(companyDataSource, customHeaderObject);
                        datasource = Object.keys(symbols).map(function(key) {
                            return symbols[key];
                        });
                        return _ctx.abrupt("return", {
                            datasource: datasource,
                            symbols: symbols,
                            customColumn: customColumn
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    fetchFinancialItemValues: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/FETCH_FINANCIAL_ITEM_VALUES"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var watchlistid, fitemids, datasourceResponse, datasources;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistid = param.watchlistid, fitemids = param.fitemids;
                        _ctx.next = 3;
                        return Promise.all(fitemids.map(function(id) {
                            return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getFinancialValues */ .Z.getFinancialValues(watchlistid, id);
                        }));
                    case 3:
                        datasourceResponse = _ctx.sent;
                        datasources = datasourceResponse.map(function(response) {
                            var _data = response.data, data = _data.data, error = _data.error;
                            if (error) {
                                throw new Error(error);
                            }
                            return data;
                        });
                        return _ctx.abrupt("return", {
                            datasources: datasources
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    removeColumn: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/REMOVE_FINANCIAL_COLUMN"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var watchlistid, fitemid, response, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistid = param.watchlistid, fitemid = param.fitemid;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].removeFinancialMetrics */ .Z.removeFinancialMetrics(watchlistid, fitemid);
                    case 3:
                        response = _ctx.sent;
                        error = response.data.error;
                        if (!error) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(error);
                    case 7:
                        (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            content: constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].FINANCIAL_COLUMN_DELETED */ .Z.FINANCIAL_COLUMN_DELETED,
                            alertType: "plain",
                            messageType: "success"
                        });
                        return _ctx.abrupt("return", {
                            fitemid: fitemid
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    reorderColumn: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)("".concat(SLICE_NAME, "/REORDER_FINANCIAL_COLUMN"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var column, watchlistid, columnIndex, response, _data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        column = param.column, watchlistid = param.watchlistid;
                        columnIndex = column.map(function(col) {
                            return col.dataIndex;
                        }).join();
                        _ctx.next = 4;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].reorderFinancialValues */ .Z.reorderFinancialValues(watchlistid, columnIndex);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to reorder financial column failed");
                    case 7:
                        _data = response.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(error);
                    case 10:
                        return _ctx.abrupt("return", {
                            column: column
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Thunk reducers
var extraReducers = function(builder) {
    builder// fetch company watchlist
    .addCase(thunks.fetchCompanyWatchlist.pending, function(draft) {
        draft.isLoading = true;
    // Reset symbols state
    // draft.symbols = {};
    }).addCase(thunks.fetchCompanyWatchlist.fulfilled, function(draft, action) {
        var _payload = action.payload, customColumn = _payload.customColumn, symbols = _payload.symbols;
        draft.isLoading = false;
        draft.symbols = symbols;
        draft.columns = customColumn;
    }).addCase(thunks.fetchCompanyWatchlist.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    })// fetch company watchlist
    .addCase(thunks.fetchFinancialItemValues.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.fetchFinancialItemValues.fulfilled, function(draft, action) {
        var datasources = action.payload.datasources;
        datasources.forEach(function(param) {
            var item_id = param.item_id, results = param.results;
            results.forEach(function(result) {
                var symbol = result.symbol, value = result.value;
                draft.symbols[symbol] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, draft.symbols[symbol]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, item_id, utils_number__WEBPACK_IMPORTED_MODULE_3__/* ["default"].numberFormatter */ .ZP.numberFormatter({
                    num: value,
                    fixed: 2
                })));
            });
        });
        draft.isLoading = false;
    }).addCase(thunks.fetchFinancialItemValues.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    }).addCase(thunks.removeColumn.fulfilled, function(draft, action) {
        draft.columns = draft.columns.filter(function(param) {
            var key = param.key;
            return key !== action.payload.fitemid;
        });
    }).addCase(thunks.reorderColumn.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(thunks.reorderColumn.fulfilled, function(draft, action) {
        var column = action.payload.column;
        draft.columns = column;
    }).addCase(thunks.reorderColumn.rejected, function(draft, action) {
        // do something if error
        draft.isLoading = false;
        draft.error = action.error;
    });
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, function(state) {
    var table = state.watchlistTable.table;
    var datasource = Object.keys(table.symbols).map(function(key) {
        return table.symbols[key];
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, table), {
        datasource: datasource,
        activeWatchlistid: state.root.activeWatchlistId
    });
});
var loadingTableSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(function(state) {
    return state.watchlist.watchlistTable.table.isLoading;
}, function(state) {
    return state;
});
var columnSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(function(state) {
    return state.watchlist.watchlistTable.table.columns;
}, function(state) {
    return state;
});
var dataSourceSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_11__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_12__/* .tableSelector */ .ki, function(state) {
    var datasource = Object.keys(state.symbols).map(function(key) {
        return state.symbols[key];
    });
    return datasource;
});
var tableSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (tableSlice);


/***/ }),

/***/ 26857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable eqeqeq */ /* eslint-disable no-param-reassign */ 



function getChangeDirection(change) {
    if (change > 0) {
        return "up";
    }
    if (change < 0) {
        return "down";
    }
    return "neutral";
}
function mapCustomHeader(customHeaders) {
    return customHeaders.map(function(header) {
        return {
            key: header.item_id,
            name: header.value,
            isLoading: false,
            value: {
                itemid: parseInt(header.item_id, 10),
                itemname: header.value,
                results: null
            }
        };
    });
}
var mapCustomColumnFromHeader = function(header) {
    return {
        dataIndex: header.key,
        key: header.key,
        title: header.name,
        className: "table-dragable-column"
    };
};
var mapCompanyDataSource = function(item) {
    return {
        key: item.id,
        price: {
            id: item.id,
            change: numeral__WEBPACK_IMPORTED_MODULE_0___default()(Number(item.change)).format("0,0.00"),
            changeDirection: getChangeDirection(item.change),
            percentage: numeral__WEBPACK_IMPORTED_MODULE_0___default()(Number(item.percent)).format("0,0.00"),
            price: numeral__WEBPACK_IMPORTED_MODULE_0___default()(Number(item.last)).format("0,0[.]00"),
            last: item.last,
            formatted_price: item.formatted_price
        },
        symbol: {
            id: item.id,
            name: item.name,
            symbol: item.symbol,
            uma: item.uma,
            notation: item.notation,
            corp_action: item.corp_action,
            tradeable: item.tradeable,
            status: item.status,
            type: item.type
        },
        notation: item.notation,
        uma: item.uma
    };
};
var customHeaderObjectReducer = function(prev, current) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current.key, null));
};
function generateSymbols(companyDataSources, customHeaderObject) {
    var symbols = companyDataSources.reduce(function(prev, current) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, current.symbol.symbol, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, current, customHeaderObject)));
    }, {});
    return symbols;
}
function tableSorter(ax, bx) {
    var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "numeric";
    if (type == "string") {
        if (ax < bx) return -1;
        if (ax > bx) return 1;
        return 0;
    }
    ax = String(ax);
    bx = String(bx);
    if (ax == "-" || ax == "n/a") return -1;
    if (bx == "-" || bx == "n/a") return 1;
    ax = ax.replace(/,/g, "");
    bx = bx.replace(/,/g, "");
    ax = ax.replace("%", "");
    bx = bx.replace("%", "");
    ax = ax.replace("+", "");
    bx = bx.replace("+", "");
    if (ax.indexOf("(") > -1) {
        ax = ax.replace("(", "-");
        ax = ax.replace(")", "");
    }
    if (bx.indexOf("(") > -1) {
        bx = bx.replace("(", "-");
        bx = bx.replace(")", "");
    }
    if (ax.indexOf("b") > -1 || ax.indexOf("B") > -1) {
        ax = parseFloat(ax) * 1000000000;
    } else if (ax.indexOf("m") > -1 || ax.indexOf("M") > -1) {
        ax = parseFloat(ax) * 1000000;
    } else if (ax.indexOf("k") > -1 || ax.indexOf("K") > -1) {
        ax = parseFloat(ax) * 1000;
    } else {
        ax = parseFloat(ax);
    }
    if (bx.indexOf("b") > -1 || bx.indexOf("B") > -1) {
        bx = parseFloat(bx) * 1000000000;
    } else if (bx.indexOf("m") > -1 || bx.indexOf("M") > -1) {
        bx = parseFloat(bx) * 1000000;
    } else if (bx.indexOf("k") > -1 || bx.indexOf("K") > -1) {
        bx = parseFloat(bx) * 1000;
    } else {
        bx = parseFloat(bx);
    }
    if (ax < bx) return -1;
    if (ax > bx) return 1;
    return 0;
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    getChangeDirection: getChangeDirection,
    mapCustomHeader: mapCustomHeader,
    mapCustomColumnFromHeader: mapCustomColumnFromHeader,
    mapCompanyDataSource: mapCompanyDataSource,
    customHeaderObjectReducer: customHeaderObjectReducer,
    generateSymbols: generateSymbols,
    tableSorter: tableSorter
});


/***/ }),

/***/ 63762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AW": function() { return /* binding */ activeWlSelector; },
/* harmony export */   "PY": function() { return /* binding */ activeWlNameSelector; },
/* harmony export */   "ki": function() { return /* binding */ tableSelector; }
/* harmony export */ });
/* unused harmony export collectionSelector */
var rootSelector = function(state) {
    return state.watchlist;
};
var collectionSelector = function(state) {
    return state.watchlist.collection;
};
var tableSelector = function(state) {
    return state.watchlist.watchlistTable.table;
};
var activeWlSelector = function(state) {
    return state.watchlist.root.activeWatchlistId;
};
var activeWlNameSelector = function(state) {
    return state.watchlist.root.activeWatchlistName;
};
/* harmony default export */ __webpack_exports__["ZP"] = (rootSelector);


/***/ }),

/***/ 25612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fO": function() { return /* binding */ activeWatchlistIdSelector; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export activeWatchlistNameSelector */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21671);
/* harmony import */ var _selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63762);
/* harmony import */ var _Collection_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67266);






// constants
var SLICE_NAME = "root";
// initial state
var initialState = {
    activeWatchlistId: null,
    activeWatchlistName: "All Watchlist",
    connectionStatus: "Normal"
};
var reducers = {
    handleChangeActiveWatchlist: function(draft, action) {
        draft.activeWatchlistId = action.payload.selected;
        draft.activeWatchlistName = action.payload.name;
    }
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, function(state) {
    var ref, ref1;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.root), {
        isExpand: ((ref = state.watchlistTable.table.columns) === null || ref === void 0 ? void 0 : ref.length) > 5,
        isComposed: ((ref1 = state.watchlistTable.table.columns) === null || ref1 === void 0 ? void 0 : ref1.length) < 2
    });
});
var activeWatchlistIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_3__/* .activeWlSelector */ .AW, function(state) {
    return state;
});
var activeWatchlistNameSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(_selectors__WEBPACK_IMPORTED_MODULE_3__/* .activeWlNameSelector */ .PY, function(state) {
    return state;
});
var extraReducers = function(builder) {
    builder.addCase(_Collection_slice__WEBPACK_IMPORTED_MODULE_1__/* .thunks.editCompanyWatchlist.fulfilled */ .CJ.editCompanyWatchlist.fulfilled, function(state, action) {
        var data = action.payload.data;
        if (data) {
            var id = data.watchlist_id, name = data.name;
            if (state.activeWatchlistId === id) {
                state.activeWatchlistName = name;
            }
        }
    }).addCase(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_0__/* .effects.logout.fulfilled */ .Sz.logout.fulfilled, function(state) {
        // reset active watchlist
        state.activeWatchlistId = null;
        state.activeWatchlistName = "All Watchlist";
    });
};
var rootSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    initialState: initialState,
    name: SLICE_NAME,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (rootSlice);


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 80341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .sysmsg-alert {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 0;\n\n    .anticon {\n      display: none;\n    }\n\n    & > div {\n      background: transparent;\n      padding: 0;\n    }\n\n    & > div > div > span > {\n      .message-success {\n        background: #e1f6e5;\n        color: ",
        ";\n      }\n\n      .message-error {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .message-warning {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .message-info {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-default {\n        border-radius: 5px;\n        padding: 10px 15px;\n      }\n\n      .alert-snackbar {\n        font-family: var(--font-bold);\n        font-weight: 600;\n        text-align: left;\n        line-height: 1.15;\n        font-size: 12px;\n        border-radius: 2px;\n        padding: 13px 16px;\n        max-width: 317px;\n\n        span {\n          margin: 0 12px;\n        }\n      }\n\n      .alert-plain,\n      .alert-plain-default {\n        font-family: var(--font-regular);\n        font-size: 14px;\n        border-radius: 2px;\n        padding: 8px 10px;\n        line-height: 16.1px;\n        max-width: 300px;\n      }\n\n      .alert-plain.message-success {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-plain.message-error {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-plain.message-success {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-plain.message-error {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      .alert-snackbar-dark {\n        font-family: var(--font-bold);\n        font-weight: 600;\n        text-align: left;\n        line-height: 1.15;\n        font-size: 12px;\n        border-radius: 2px;\n        padding: 13px 16px;\n        max-width: 317px;\n\n        span {\n          margin: 0 12px;\n        }\n\n        background: #3B3B3B;\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var alertStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.black */ .$_.black, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.alertRed */ .$_.alertRed, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.black */ .$_.black, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.alertOrange */ .$_.alertOrange, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.black */ .$_.black, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.alertBlue */ .$_.alertBlue, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.black */ .$_.black, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.valencia */ .$_.valencia, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.valencia */ .$_.valencia, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
/* harmony default export */ __webpack_exports__["Z"] = (alertStyles);


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 93775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_MainApp; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/global/Scripts/google.js
/* eslint-disable react/no-danger */ 




var Google = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
        condition: app/* STAGE */.or !== "development",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
            children: app/* GTM_ID */.Ax ? // eslint-disable-next-line @next/next/next-script-for-ga
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-tag-manager",
                strategy: "afterInteractive",
                children: "\n                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl+'&ra='+Date.now();f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer', '".concat(app/* GTM_ID */.Ax, "');\n              ")
            }) : null
        })
    });
};
/* harmony default export */ var google = (Google);

// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(28858);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/lib/api/friends.ts
var friends = __webpack_require__(63699);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
// EXTERNAL MODULE: ./src/features/discover-people/constants.ts
var constants = __webpack_require__(34566);
// EXTERNAL MODULE: ./src/features/discover-people/helper.ts
var helper = __webpack_require__(58603);
;// CONCATENATED MODULE: ./src/features/discover-people/slice.ts






// alert
// import handleErrorMessageAPI from 'global/AlertErrorMessage';
// import SUCCESS_MESSAGE from 'constants/successMessage';
// API Endpoints Related Modules



// feature constants


// initial state
var initialState = {
    error: null,
    isLoading: true,
    isLastPage: false,
    keyword: "",
    list: [],
    filter: constants/* DISCOVER_FILTERS.0.value */.DY[0].value,
    page: 1
};
var discoverPeopleSelector = function(state) {
    return state.discoverPeople;
};
// Selectors
var selectors = (0,reselect_es/* createSelector */.P1)(discoverPeopleSelector, function(discoverPeople) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, discoverPeople), {
        // select methods
        getAllIds: function() {
            return discoverPeople.list.map(function(user) {
                return user.id;
            });
        },
        getUserByIndex: function(index) {
            return discoverPeople.list[index] || [];
        }
    });
});
// Reducer
var reducers = {
    changeType: function(state, action) {
        state.filter = action.payload;
    },
    resetData: function(state) {
        state.keyword = "";
        state.list = [];
        state.filter = state.filter ? state.filter : constants/* DISCOVER_FILTERS.0.value */.DY[0].value;
    }
};
// effects
var effects = {
    // Search users
    searchUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(helper/* actionType.SEARCH_USER */.At.SEARCH_USER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var keyword, _page, page, response, _data, data, message, composedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyword = param.keyword, _page = param.page, page = _page === void 0 ? 1 : _page;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return search/* default.getSearchPeople */.Z.getSearchPeople(keyword, page);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Cannot perform request");
                    case 7:
                        _data = response.data, data = _data.data, message = _data.message;
                        composedData = (0,helper/* normalizeData */.Fi)(data, helper/* actionType.SEARCH_USER */.At.SEARCH_USER);
                        return _ctx.abrupt("return", {
                            data: composedData,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // toggle follower
    toggleFollowUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(helper/* actionType.TOGGLE_FOLLOW_USER */.At.TOGGLE_FOLLOW_USER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var userid, _isFollowed, isFollowed, index, targetAPI, response, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        userid = param.userid, _isFollowed = param.isFollowed, isFollowed = _isFollowed === void 0 ? false : _isFollowed, index = param.index;
                        _ctx.prev = 1;
                        if (!(typeof index !== "number")) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("index must be a number");
                    case 4:
                        if (userid) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("userid is required");
                    case 6:
                        targetAPI = watchlist/* default.postFollowUser */.Z.postFollowUser;
                        if (isFollowed) {
                            targetAPI = watchlist/* default.postUnfollowUser */.Z.postUnfollowUser;
                        }
                        _ctx.next = 10;
                        return targetAPI(userid);
                    case 10:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error("Cannot perform request");
                    case 13:
                        message = response.data.message;
                        return _ctx.abrupt("return", {
                            message: message
                        });
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    17
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Friends suggestions
    getFriendSuggestions: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(helper/* actionType.FETCH_SUGGESTIONS */.At.FETCH_SUGGESTIONS, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _page, page, _limit, limit, config, response, _data, data, _$error, message, normalized, more;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _page = param.page, page = _page === void 0 ? 1 : _page, _limit = param.limit, limit = _limit === void 0 ? constants/* SUGGESTIONS_PERPAGE */.FT : _limit;
                        _ctx.prev = 1;
                        config = {
                            limit: limit,
                            page: page
                        };
                        _ctx.next = 5;
                        return friends/* default.getSuggestFriends */.Z.getSuggestFriends(config);
                    case 5:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!(!response.data || _$error)) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("failed to fetch friends suggestions");
                    case 9:
                        normalized = (0,helper/* normalizeData */.Fi)(data, helper/* actionType.FETCH_SUGGESTIONS */.At.FETCH_SUGGESTIONS);
                        more = normalized.length >= 30;
                        return _ctx.abrupt("return", {
                            data: normalized,
                            message: message,
                            more: more
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Contact
    getFriendSuggestionsContact: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(helper/* actionType.FETCH_CONTACT */.At.FETCH_CONTACT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _page, page, _limit, limit, response, _data, found, _$error, message, normalized, more;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _page = param.page, page = _page === void 0 ? 1 : _page, _limit = param.limit, limit = _limit === void 0 ? constants/* SUGGESTIONS_PERPAGE */.FT : _limit;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return friends/* default.getSuggestFriendsContacts */.Z.getSuggestFriendsContacts(limit, page);
                    case 4:
                        response = _ctx.sent;
                        _data = response.data, found = _data.data.found, _$error = _data.error, message = _data.message;
                        if (!(!response.data || _$error)) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("failed to fetch friends suggestions");
                    case 8:
                        normalized = (0,helper/* normalizeData */.Fi)(found, helper/* actionType.FETCH_CONTACT */.At.FETCH_CONTACT);
                        more = normalized.length >= 30;
                        return _ctx.abrupt("return", {
                            data: normalized,
                            message: message,
                            more: more
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Extra Reducer
var extraReducers = function(builder) {
    // Search by keyword
    builder.addCase(effects.searchUser.pending, function(state, action) {
        state.isLoading = true;
        state.keyword = action.meta.arg.keyword;
    }).addCase(effects.searchUser.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (error) {
            state.error = error;
        } else {
            state.list = data;
        }
        state.isLoading = false;
    }).addCase(effects.searchUser.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    })// Discover Friends Suggestions
    .addCase(effects.toggleFollowUser.pending, function(state, action) {
        var index = action.meta.arg.index;
        state.list[index].isLoading = true;
    }).addCase(effects.toggleFollowUser.fulfilled, function(state, action) {
        var error = action.payload.error;
        if (error) {
            state.error = error;
        } else {
            var _arg = action.meta.arg, index = _arg.index, isFollowed = _arg.isFollowed;
            state.list[index].isFollowed = !isFollowed;
            state.list[index].isLoading = false;
        }
        state.isLoading = false;
    }).addCase(effects.toggleFollowUser.rejected, function(state, action) {
        var index = action.meta.arg.index;
        state.list[index].isLoading = false;
        state.error = action.error;
    })// Discover Friends Suggestions
    .addCase(effects.getFriendSuggestions.pending, function(state, action) {
        state.isLoading = true;
        state.page = action.meta.arg.page;
        // reset
        if (action.meta.arg.page === 1) {
            state.list = initialState.list;
            state.isLastPage = false;
        }
    }).addCase(effects.getFriendSuggestions.fulfilled, function(state, action) {
        var error = action.payload.error;
        if (error) {
            state.error = error;
        } else if (action.payload.data.length > 0) {
            var _list;
            (_list = state.list).push.apply(_list, (0,_to_consumable_array/* default */.Z)(action.payload.data));
        } else {
            state.isLastPage = true;
        }
        state.isLoading = false;
    }).addCase(effects.getFriendSuggestions.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    })// Discover contact Suggestions
    .addCase(effects.getFriendSuggestionsContact.pending, function(state, action) {
        state.isLoading = true;
        state.page = action.meta.arg.page;
        // reset
        if (action.meta.arg.page === 1) {
            state.list = initialState.list;
            state.isLastPage = false;
        }
    }).addCase(effects.getFriendSuggestionsContact.fulfilled, function(state, action) {
        var error = action.payload.error;
        if (error) {
            state.error = error;
        } else if (action.payload.data.length > 0) {
            var _list;
            (_list = state.list).push.apply(_list, (0,_to_consumable_array/* default */.Z)(action.payload.data));
        } else {
            state.isLastPage = true;
        }
        state.isLoading = false;
    }).addCase(effects.getFriendSuggestionsContact.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    });
};
// Slice
var discoverPeopleSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "discoverPeople",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var slice = (discoverPeopleSlice);

;// CONCATENATED MODULE: ./src/features/discover-people/reducer.ts

var discoverPeopleReducer = slice.reducer;
/* harmony default export */ var reducer = (discoverPeopleReducer);

// EXTERNAL MODULE: ./src/features/edit-profile/slice.ts
var edit_profile_slice = __webpack_require__(40927);
;// CONCATENATED MODULE: ./src/features/edit-profile/reducer.ts

var editProfileReducer = edit_profile_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var edit_profile_reducer = (editProfileReducer);

// EXTERNAL MODULE: ./src/features/onboarding/DiscoverPeople/slice.ts
var DiscoverPeople_slice = __webpack_require__(36203);
// EXTERNAL MODULE: ./src/features/onboarding/DiscoverStock/slice.js
var DiscoverStock_slice = __webpack_require__(9073);
// EXTERNAL MODULE: ./src/features/onboarding/UploadProfilePicture/slice.ts
var UploadProfilePicture_slice = __webpack_require__(12229);
;// CONCATENATED MODULE: ./src/features/onboarding/reducer.js




var onboardingReducer = (0,redux/* combineReducers */.UY)({
    discoverStock: DiscoverStock_slice/* default.reducer */.ZP.reducer,
    uploadImageAvatar: UploadProfilePicture_slice/* default.reducer */.ZP.reducer,
    discoverPeople: DiscoverPeople_slice/* default.reducer */.ZP.reducer
});
/* harmony default export */ var onboarding_reducer = (onboardingReducer);

// EXTERNAL MODULE: ./src/features/register/GoogleOauth/slice.ts
var GoogleOauth_slice = __webpack_require__(84405);
// EXTERNAL MODULE: ./src/features/register/EmailRegister/slice.ts
var EmailRegister_slice = __webpack_require__(94970);
// EXTERNAL MODULE: ./src/features/register/FacebookOauth/slice.ts
var FacebookOauth_slice = __webpack_require__(2915);
// EXTERNAL MODULE: ./src/features/register/slice.ts
var register_slice = __webpack_require__(7952);
;// CONCATENATED MODULE: ./src/features/register/reducer.ts





// Create the register reducer
var registerReducer = (0,redux/* combineReducers */.UY)({
    emailRegister: EmailRegister_slice/* default.reducer */.ZP.reducer,
    googleOauth: GoogleOauth_slice/* default.reducer */.ZP.reducer,
    facebookOauth: FacebookOauth_slice/* default.reducer */.ZP.reducer,
    root: register_slice/* default.reducer */.ZP.reducer
});
/* harmony default export */ var register_reducer = (registerReducer);

// EXTERNAL MODULE: ./src/features/reset-password/slice.js
var reset_password_slice = __webpack_require__(7021);
;// CONCATENATED MODULE: ./src/features/reset-password/reducer.js

var resetPasswordReducer = reset_password_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var reset_password_reducer = (resetPasswordReducer);

// EXTERNAL MODULE: ./src/features/user/slice.ts
var user_slice = __webpack_require__(52827);
;// CONCATENATED MODULE: ./src/features/user/reducer.ts

var userProfileReducer = user_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var user_reducer = (userProfileReducer);

// EXTERNAL MODULE: ./src/features/watchlist/Collection/slice.ts
var Collection_slice = __webpack_require__(67266);
// EXTERNAL MODULE: ./src/features/watchlist/slice.ts
var watchlist_slice = __webpack_require__(25612);
// EXTERNAL MODULE: ./src/features/watchlist/WatchlistTable/SearchSymbol/slice.ts
var SearchSymbol_slice = __webpack_require__(78086);
// EXTERNAL MODULE: ./src/features/watchlist/WatchlistTable/DeleteCompanyModal/slice.ts
var DeleteCompanyModal_slice = __webpack_require__(66960);
// EXTERNAL MODULE: ./src/features/watchlist/WatchlistTable/FinancialMetric/slice.ts + 1 modules
var FinancialMetric_slice = __webpack_require__(13795);
// EXTERNAL MODULE: ./src/features/watchlist/WatchlistTable/Table/slice.ts
var Table_slice = __webpack_require__(85833);
;// CONCATENATED MODULE: ./src/features/watchlist/WatchlistTable/reducer.ts

// slices




var watchlistTableReducer = (0,redux/* combineReducers */.UY)({
    companySuggestions: SearchSymbol_slice/* default.reducer */.ZP.reducer,
    deleteModal: DeleteCompanyModal_slice/* default.reducer */.ZP.reducer,
    financialMetrics: FinancialMetric_slice/* default.reducer */.ZP.reducer,
    table: Table_slice/* default.reducer */.ZP.reducer
});
/* harmony default export */ var WatchlistTable_reducer = (watchlistTableReducer);

;// CONCATENATED MODULE: ./src/features/watchlist/reducer.ts

// slices



var watchlistFeatureReducer = (0,redux/* combineReducers */.UY)({
    root: watchlist_slice/* default.reducer */.ZP.reducer,
    collection: Collection_slice/* default.reducer */.ZP.reducer,
    // combined
    watchlistTable: WatchlistTable_reducer
});
/* harmony default export */ var watchlist_reducer = (watchlistFeatureReducer);

// EXTERNAL MODULE: ./src/features/calendar/slice.ts + 1 modules
var calendar_slice = __webpack_require__(39246);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/lib/api/stream.ts
var stream = __webpack_require__(51679);
// EXTERNAL MODULE: ./src/lib/api/securities.ts
var securities = __webpack_require__(65906);
;// CONCATENATED MODULE: ./src/features/stream/slice.js
/* eslint-disable consistent-return */ 




// api


// initial state
var slice_initialState = {
    stream: {
        list: [],
        isLoading: false,
        error: null,
        message: ""
    },
    trendingUser: {
        list: [],
        isLoading: false,
        error: null,
        message: ""
    },
    registrationStatus: {
        data: {
            status: 0
        },
        list: [],
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selectors -------------------------------------------------------------------
var slice_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.stream;
}, function(state) {
    return {
        stream: {
            list: state.stream.list,
            isLoading: state.stream.isLoading,
            error: state.stream.error,
            message: state.stream.message
        },
        trendingUser: {
            list: state.trendingUser.list,
            isLoading: state.trendingUser.isLoading,
            error: state.trendingUser.error,
            message: state.trendingUser.message
        },
        registrationStatus: {
            data: state.registrationStatus.data,
            isLoading: state.registrationStatus.isLoading,
            error: state.registrationStatus.error,
            message: state.registrationStatus.message
        }
    };
});
// Actions ---------------------------------------------------------------------
// types
var CONTEXT = "@features/stream";
var actionType = {
    GET_STREAM: "".concat(CONTEXT, "/stream/get"),
    GET_REGISTRATION_STATUS: "".concat(CONTEXT, "/registration_status/get")
};
// effects
var slice_effects = {
    getStream: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_STREAM, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return stream/* default.getStream */.Z.getStream(2, {
                        category: "all",
                        clean: 1
                    });
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to fetch stream failed");
                case 6:
                    _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        message: message,
                        error: _$error
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0.message
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // Left as it was because it should be checked after OA is fully integrated with stream page
    // But the widget itself has migrated to zustand
    getRegistrationStatus: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_REGISTRATION_STATUS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return securities/* default.getOAStatus */.Z.getOAStatus();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to fetch oa status failed");
                case 6:
                    _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        message: message,
                        error: _$error
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    })))
};
var _obj;
// Extra Reducer ---------------------------------------------------------------
var slice_extraReducers = (_obj = {}, (0,_define_property/* default */.Z)(_obj, es6/* HYDRATE */.ju, function(draft, action) {
    draft.ihsg = action.payload.ihsg;
    draft.trendingStocks = action.payload.trendingStocks;
    draft.stream = action.payload.stream;
    draft.trendingUser = action.payload.trendingUser;
}), // Get Stream ----------------------------------------------------------------
(0,_define_property/* default */.Z)(_obj, slice_effects.getStream.pending, function(state) {
    state.stream.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, slice_effects.getStream.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.stream.error = error;
    } else {
        state.stream.list = data;
    }
    state.stream.message = message;
    state.stream.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, slice_effects.getStream.rejected, function(state, action) {
    state.stream.error = action.payload.error;
    state.stream.isLoading = false;
}), // Get get trending user -----------------------------------------------------
(0,_define_property/* default */.Z)(_obj, slice_effects.getRegistrationStatus.pending, function(state) {
    state.registrationStatus.isLoading = true;
}), (0,_define_property/* default */.Z)(_obj, slice_effects.getRegistrationStatus.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.registrationStatus.error = error;
    } else {
        state.registrationStatus.data = data;
    }
    state.registrationStatus.message = message;
    state.registrationStatus.isLoading = false;
}), (0,_define_property/* default */.Z)(_obj, slice_effects.getRegistrationStatus.rejected, function(state, action) {
    state.registrationStatus.error = action.payload.error;
    state.registrationStatus.isLoading = false;
}), _obj);
// Slice -----------------------------------------------------------------------
var streamSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "stream",
    initialState: slice_initialState,
    extraReducers: slice_extraReducers
});
/* harmony default export */ var stream_slice = (streamSlice);

// EXTERNAL MODULE: ./src/features/company/slice.ts
var company_slice = __webpack_require__(90636);
;// CONCATENATED MODULE: ./src/features/company/reducer.ts

var companyProfileReducer = company_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var company_reducer = (companyProfileReducer);

// EXTERNAL MODULE: ./src/features/catalog/slice.ts + 1 modules
var catalog_slice = __webpack_require__(52892);
;// CONCATENATED MODULE: ./src/features/catalog/reducer.ts

var catalogReducer = catalog_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var catalog_reducer = (catalogReducer);

// EXTERNAL MODULE: ./src/features/post-detail/slice.ts
var post_detail_slice = __webpack_require__(28563);
;// CONCATENATED MODULE: ./src/features/post-detail/reducer.ts

var postDetailReducer = post_detail_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var post_detail_reducer = (postDetailReducer);

// EXTERNAL MODULE: ./src/lib/api/chartbit.ts
var chartbit = __webpack_require__(47514);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
;// CONCATENATED MODULE: ./src/features/chartbit/slice.ts





// APIs


// Initial state
var chartbit_slice_initialState = {
    templates: [],
    loadedTemplate: {},
    initialData: {},
    isLoading: false,
    error: null,
    message: ""
};
// selectors
var chartbitSelector = function(state) {
    return state.chartbit;
};
var chartbit_slice_selectors = (0,reselect_es/* createSelector */.P1)(chartbitSelector, function(chartbit) {
    return (0,_object_spread/* default */.Z)({}, chartbit);
});
// Action types
var slice_CONTEXT = "@feature/chartbit";
var slice_actionType = {
    GET_TEMPLATES: "".concat(slice_CONTEXT, "/GET_TEMPLATE"),
    SAVE_TEMPLATE: "".concat(slice_CONTEXT, "/SAVE_TEMPLATE"),
    DELETE_TEMPLATE: "".concat(slice_CONTEXT, "/DELETE_TEMPLATE"),
    LOAD_TEMPLATE: "".concat(slice_CONTEXT, "/LOAD_TEMPLATE"),
    GET_INITIAL_DATA: "".concat(slice_CONTEXT, "/GET_INITIAL_DATA")
};
// Side effects
var chartbit_slice_effects = {
    getTemplates: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(slice_actionType.GET_TEMPLATES, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return chartbit/* default.getChartTemplate */.Z.getChartTemplate();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get chart template failed");
                case 6:
                    _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    (0,logger/* default */.ZP)(_ctx.t0, {
                        event: slice_actionType.GET_TEMPLATES,
                        place: "chartbit/slice"
                    });
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    saveTemplate: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(slice_actionType.SAVE_TEMPLATE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var name, content, response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, content = param.content;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return chartbit/* default.saveChartTemplate */.Z.saveChartTemplate(name, content);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to save chart template failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: slice_actionType.SAVE_TEMPLATE,
                            place: "chartbit/slice"
                        });
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    deleteTemplate: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(slice_actionType.DELETE_TEMPLATE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(templateId) {
            var response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return chartbit/* default.deleteChartTemplate */.Z.deleteChartTemplate(templateId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to delete chart template failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            templateId: templateId
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: slice_actionType.DELETE_TEMPLATE,
                            place: "chartbit/slice"
                        });
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(templateId) {
            return _ref.apply(this, arguments);
        };
    }()),
    loadTemplate: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(slice_actionType.LOAD_TEMPLATE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var symbol, templateId, response, _data, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, templateId = param.templateId;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return chartbit/* default.loadChartTemplate */.Z.loadChartTemplate(templateId, symbol);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to load template failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            templateId: templateId
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: slice_actionType.LOAD_TEMPLATE,
                            place: "chartbit/slice"
                        });
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var slice_reducers = {};
var chartbit_slice_extraReducers = function(builder) {
    builder.addCase(chartbit_slice_effects.getTemplates.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(chartbit_slice_effects.getTemplates.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.templates = data;
            state.error = null;
        }
        state.isLoading = false;
        state.message = message;
    })// Save templates doesn't affects reducer, thus we don't need to add the case here
    .addCase(chartbit_slice_effects.deleteTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, templateId = _payload.templateId;
        if (error) {
            state.error = error;
        } else {
            var newTemplates = (0,_to_consumable_array/* default */.Z)(state.templates);
            var templateIdx = newTemplates.findIndex(function(param) {
                var id = param.id;
                return id === templateId;
            });
            if (templateIdx > -1) {
                newTemplates.splice(templateIdx, 1);
                state.templates = newTemplates;
            }
        }
        state.message = message;
    }).addCase(chartbit_slice_effects.loadTemplate.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, templateId = _payload.templateId, data = _payload.data;
        if (error) {
            state.error = error;
        } else {
            state.loadedTemplate[templateId] = data;
        }
        state.message = message;
    });
};
var chartbitSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "chartbit",
    initialState: chartbit_slice_initialState,
    reducers: slice_reducers,
    extraReducers: chartbit_slice_extraReducers
});
/* harmony default export */ var chartbit_slice = (chartbitSlice);

;// CONCATENATED MODULE: ./src/features/chartbit/reducer.ts

var chartbitReducer = chartbit_slice.reducer;
/* harmony default export */ var chartbit_reducer = (chartbitReducer);

// EXTERNAL MODULE: ./src/features/screener/slice.ts
var screener_slice = __webpack_require__(15183);
// EXTERNAL MODULE: ./src/features/research/slice.ts
var research_slice = __webpack_require__(39910);
// EXTERNAL MODULE: ./src/features/earnings/slice.ts + 1 modules
var earnings_slice = __webpack_require__(79695);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
;// CONCATENATED MODULE: ./src/global/TradingModal/slice.ts


// initial state
var TradingModal_slice_initialState = {
    visible: false,
    symbol: null,
    price: null,
    orderType: trading/* ORDER_TYPE.BUY */.Jm.BUY
};
var TradingModal_slice_reducers = {
    showModal: function(draft, action) {
        draft.visible = true;
        draft.symbol = action.payload.symbol;
        draft.price = action.payload.price;
        draft.orderType = action.payload.type;
    },
    resetModal: function(draft) {
        draft.visible = false;
        draft.symbol = null;
        draft.orderType = trading/* ORDER_TYPE.BUY */.Jm.BUY;
    },
    setOrderType: function(draft, action) {
        draft.orderType = action.payload;
    }
};
// Selectors
var TradingModal_slice_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return {
        visible: state.orderbookModal.visible,
        symbol: state.orderbookModal.symbol,
        price: state.orderbookModal.price,
        orderType: state.orderbookModal.orderType
    };
}, function(state) {
    return state;
});
// Slice
var rootSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "@orderbook/trading-modal",
    initialState: TradingModal_slice_initialState,
    reducers: TradingModal_slice_reducers,
    extraReducers: {}
});
/* harmony default export */ var TradingModal_slice = (rootSlice);

// EXTERNAL MODULE: ./src/global/Moderation/slice.ts
var Moderation_slice = __webpack_require__(98170);
;// CONCATENATED MODULE: ./src/global/Moderation/reducer.ts

var moderationReducer = Moderation_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var Moderation_reducer = (moderationReducer);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/BandarDetector/slice.ts
var BandarDetector_slice = __webpack_require__(46881);
// EXTERNAL MODULE: ./src/lib/api/company.ts
var company = __webpack_require__(1349);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Hotlist/slice.js






// Auth Related Modules

// Actions
var Hotlist_slice_CONTEXT = "@side-widget/hotlist";
var Hotlist_slice_actionType = {
    GET_HOTLIST: "".concat(Hotlist_slice_CONTEXT, "/GET_HOTLIST")
};
// hotlist type
var HOTLIST_TYPE = {
    TOP_GAINER: "topGainer",
    TOP_LOSER: "topLoser",
    MOST_ACTIVE: "mostActive"
};
var slice_obj;
// hotlist api
var HOTLIST_API = (slice_obj = {}, (0,_define_property/* default */.Z)(slice_obj, HOTLIST_TYPE.TOP_GAINER, company/* default.getTopGainer */.Z.getTopGainer), (0,_define_property/* default */.Z)(slice_obj, HOTLIST_TYPE.TOP_LOSER, company/* default.getTopLoser */.Z.getTopLoser), (0,_define_property/* default */.Z)(slice_obj, HOTLIST_TYPE.MOST_ACTIVE, company/* default.getMostActive */.Z.getMostActive), slice_obj);
// initial state
var Hotlist_slice_initialState = {
    topGainer: {
        data: [],
        isLoading: false,
        error: null
    },
    topLoser: {
        data: [],
        isLoading: false,
        error: null
    },
    mostActive: {
        data: [],
        isLoading: false,
        error: null
    }
};
// Selectors
var Hotlist_slice_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    var _hotlist = state.mainLayout.hotlist, topGainer = _hotlist.topGainer, topLoser = _hotlist.topLoser, mostActive = _hotlist.mostActive;
    return {
        // all
        topGainer: topGainer,
        topLoser: topLoser,
        mostActive: mostActive,
        // top gainer
        topGainerError: topGainer.error,
        topGainerData: topGainer.data,
        topGainerLoading: topGainer.isLoading,
        // top loser
        topLoserError: topLoser.error,
        topLoserData: topLoser.data,
        topLoserLoading: topLoser.isLoading,
        // most active
        mostActiveError: mostActive.error,
        mostActiveData: mostActive.data,
        mostActiveLoading: mostActive.isLoading
    };
}, function(state) {
    return state;
});
// Reducer
var Hotlist_slice_reducers = {};
// effects
var Hotlist_slice_effects = {
    // login
    getHotlist: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(Hotlist_slice_actionType.GET_HOTLIST, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _type, type, targetAPI, response, _data, data, _$error, message, normalized;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _type = param.type, type = _type === void 0 ? HOTLIST_TYPE.TOP_GAINER : _type;
                        _ctx.prev = 1;
                        targetAPI = HOTLIST_API[type] || HOTLIST_API[HOTLIST_TYPE.TOP_GAINER];
                        _ctx.next = 5;
                        return targetAPI();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Error when changing password, no data recevied");
                    case 8:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error(_$error);
                    case 11:
                        normalized = data.map(function(item) {
                            var change = item.change;
                            var changeIndicator = change[0];
                            var changeValue = change;
                            var changeFlow = "neutral";
                            if (changeIndicator === "+") {
                                changeFlow = "up";
                                changeValue = change.substring(1);
                            } else if (changeIndicator === "-") {
                                changeFlow = "down";
                            } else {
                                changeFlow = "neutral";
                            }
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                changeFlow: changeFlow,
                                changeIndicator: changeIndicator,
                                changeValue: changeValue
                            });
                        });
                        return _ctx.abrupt("return", {
                            data: normalized,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var _obj1;
// Extra / Async Reducer
var Hotlist_slice_extraReducers = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, Hotlist_slice_effects.getHotlist.pending, function(state, action) {
    var type = action.meta.arg.type;
    state[type].error = null;
    state[type].isLoading = true;
}), (0,_define_property/* default */.Z)(_obj1, Hotlist_slice_effects.getHotlist.fulfilled, function(state, action) {
    var type = action.meta.arg.type;
    state[type].data = action.payload.data;
    state[type].error = null;
    state[type].isLoading = true;
    state[type].message = action.payload.message;
}), (0,_define_property/* default */.Z)(_obj1, Hotlist_slice_effects.getHotlist.rejected, function(state, action) {
    var type = action.meta.arg.type;
    state[type].error = action.error;
    state[type].isLoading = true;
}), _obj1);
// Slice
var hotlistSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "hotlist",
    initialState: Hotlist_slice_initialState,
    reducers: Hotlist_slice_reducers,
    extraReducers: Hotlist_slice_extraReducers
});
/* harmony default export */ var Hotlist_slice = (hotlistSlice);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/slice.ts
var PriceAlert_slice = __webpack_require__(16835);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Valuation/slice.ts
var Valuation_slice = __webpack_require__(9139);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/ListWatchlist/slice.ts
var ListWatchlist_slice = __webpack_require__(31390);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/CompanyWatchlist/slice.ts
var CompanyWatchlist_slice = __webpack_require__(6767);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/slice.ts
var Orderbook_slice = __webpack_require__(83231);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/slice.ts
var Watchlist_slice = __webpack_require__(78626);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/reducer.ts





var sideWidgetReducer = (0,redux/* combineReducers */.UY)({
    orderbook: Orderbook_slice/* default.reducer */.ZP.reducer,
    listWatchlist: ListWatchlist_slice/* default.reducer */.ZP.reducer,
    company: CompanyWatchlist_slice/* default.reducer */.ZP.reducer,
    root: Watchlist_slice/* default.reducer */.ZP.reducer
});
/* harmony default export */ var Watchlist_reducer = (sideWidgetReducer);

// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
;// CONCATENATED MODULE: ./src/global/MainLayout/reducer.js







var reducer_sideWidgetReducer = (0,redux/* combineReducers */.UY)({
    hotlist: Hotlist_slice.reducer,
    priceAlert: PriceAlert_slice/* default.reducer */.ZP.reducer,
    valuation: Valuation_slice/* default.reducer */.ZP.reducer,
    root: MainLayout_slice/* default.reducer */.ZP.reducer,
    bandarDetector: BandarDetector_slice/* default.reducer */.ZP.reducer,
    watchlist: Watchlist_reducer
});
/* harmony default export */ var MainLayout_reducer = (reducer_sideWidgetReducer);

// EXTERNAL MODULE: ./src/global/StreamWidget/slice/index.tsx + 2 modules
var StreamWidget_slice = __webpack_require__(47225);
// EXTERNAL MODULE: ./src/global/StreamConversation/slice.ts
var StreamConversation_slice = __webpack_require__(61048);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/lib/entities/watchlist/index.ts
var entities_watchlist = __webpack_require__(14675);
;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/slice.js






// External slice

// APIs

// Initial state
var SuggestedPeopleWidget_slice_initialState = {
    list: [],
    isLoading: true,
    message: "",
    error: null,
    toggleFollow: {
        data: {},
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selector
var SuggestedPeopleWidget_slice_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.suggestedPeople;
}, function(suggestedPeople) {
    return {
        list: suggestedPeople.list,
        isLoading: suggestedPeople.isLoading,
        error: suggestedPeople.error,
        toggleFollow: suggestedPeople.toggleFollow
    };
});
// Action type
var SuggestedPeopleWidget_slice_CONTEXT = "@global/suggestedPeople";
var SuggestedPeopleWidget_slice_actionType = {
    GET_SUGGESTED_PEOPLE: "".concat(SuggestedPeopleWidget_slice_CONTEXT, "/GET_SUGGESTED_PEOPLE"),
    FOLLOW_USER: "".concat(SuggestedPeopleWidget_slice_CONTEXT, "/FOLLOW_USER")
};
var SuggestedPeopleWidget_slice_effects = {
    getSuggestedPeople: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(SuggestedPeopleWidget_slice_actionType.GET_SUGGESTED_PEOPLE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_param) {
            var page, limit, rest, response, _data, _$error, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        page = _param.page, limit = _param.limit, rest = (0,_object_without_properties/* default */.Z)(_param, [
                            "page",
                            "limit"
                        ]);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return friends/* default.getSuggestFriends */.Z.getSuggestFriends((0,_object_spread/* default */.Z)({
                            page: page,
                            limit: limit
                        }, rest));
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get suggested people failed!");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }())
};
var SuggestedPeopleWidget_slice_reducers = {
    removeSugggestion: function(state, action) {
        var index = action.payload;
        state.list.splice(index, 1);
    }
};
var SuggestedPeopleWidget_slice_obj;
var SuggestedPeopleWidget_slice_extraReducers = (SuggestedPeopleWidget_slice_obj = {}, (0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, SuggestedPeopleWidget_slice_effects.getSuggestedPeople.pending, function(state) {
    state.isLoading = true;
    state.error = null;
}), (0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, SuggestedPeopleWidget_slice_effects.getSuggestedPeople.fulfilled, function(state, action) {
    var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
    if (error) {
        state.error = error;
    } else {
        state.list = data;
        state.error = null;
    }
    state.isLoading = false;
    state.message = message;
}), (0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, SuggestedPeopleWidget_slice_effects.getSuggestedPeople.rejected, function(state, action) {
    state.error = action.payload.error;
    state.isLoading = false;
}), // handle follow/unfollow user from watchlist slice
(0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, entities_watchlist/* effects.followUser.pending */.Sz.followUser.pending, function(state) {
    state.toggleFollow.isLoading = true;
    state.toggleFollow.error = null;
}), (0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, entities_watchlist/* effects.followUser.fulfilled */.Sz.followUser.fulfilled, function(state, action) {
    var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, userid = _payload.userid, type = _payload.type;
    if (error) {
        state.toggleFollow.error = error;
    } else {
        state.toggleFollow.data = data;
        var userDataIndex = state.list.findIndex(// eslint-disable-next-line eqeqeq
        function(user) {
            return user.user.userid == userid;
        });
        if (userDataIndex > -1) {
            // set to true if 'FOLLOW', set false if otherwise
            state.list[userDataIndex].user.follow = type === "FOLLOW";
        }
    }
    state.toggleFollow.isLoading = false;
    state.toggleFollow.message = message;
}), (0,_define_property/* default */.Z)(SuggestedPeopleWidget_slice_obj, entities_watchlist/* effects.followUser.rejected */.Sz.followUser.rejected, function(state, action) {
    state.toggleFollow.error = action.payload.error;
    state.toggleFollow.isLoading = false;
}), SuggestedPeopleWidget_slice_obj);
var suggestedPeopleSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "suggestedPeople",
    reducers: SuggestedPeopleWidget_slice_reducers,
    extraReducers: SuggestedPeopleWidget_slice_extraReducers,
    initialState: SuggestedPeopleWidget_slice_initialState
});
/* harmony default export */ var SuggestedPeopleWidget_slice = (suggestedPeopleSlice);

;// CONCATENATED MODULE: ./src/global/SuggestedPeopleWidget/reducer.js

var suggestedPeopleReducer = SuggestedPeopleWidget_slice.reducer;
/* harmony default export */ var SuggestedPeopleWidget_reducer = (suggestedPeopleReducer);

// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/lib/api/user.ts
var user = __webpack_require__(1955);
// EXTERNAL MODULE: ./src/global/TrendingPeopleWidget/constants.ts
var TrendingPeopleWidget_constants = __webpack_require__(63600);
;// CONCATENATED MODULE: ./src/global/TrendingPeopleWidget/slice.js







// api

// feature constants

// initial state
var TrendingPeopleWidget_slice_initialState = {
    fetchStatus: TrendingPeopleWidget_constants/* FETCH_STATUS.IDLE */.e_.IDLE,
    list: [],
    message: "",
    timeRange: TrendingPeopleWidget_constants/* FILTER_CHOICE.0 */.n0[0],
    listChoice: TrendingPeopleWidget_constants/* LIST_CHOICE.TRENDING */.t6.TRENDING
};
// Selectors -------------------------------------------------------------------
var TrendingPeopleWidget_slice_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.trendingPeople;
}, function(state) {
    return {
        fetchStatus: state.fetchStatus,
        list: state.list,
        timeRange: state.timeRange,
        listChoice: state.listChoice,
        // following states
        getUserByIndex: function(index) {
            return state.list[index] || null;
        }
    };
});
// Actions ---------------------------------------------------------------------
// types
var TrendingPeopleWidget_slice_CONTEXT = "@global/trendingPeople";
var TrendingPeopleWidget_slice_actionType = {
    FOLLOW_USER: "".concat(TrendingPeopleWidget_slice_CONTEXT, "/FOLLOW_USER"),
    GET_TRENDING_PEOPLE: "".concat(TrendingPeopleWidget_slice_CONTEXT, "/GET_TRENDING_PEOPLE"),
    GET_SUGGESTED_PEOPLE: "".concat(TrendingPeopleWidget_slice_CONTEXT, "/GET_SUGGESTED_PEOPLE")
};
// effects
var TrendingPeopleWidget_slice_effects = {
    followUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(TrendingPeopleWidget_slice_actionType.FOLLOW_USER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var userid, _type, type, dispatch, followUser, _payload, _$error, message, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        userid = param.userid, _type = param.type, type = _type === void 0 ? "FOLLOW" : _type, dispatch = param1.dispatch;
                        _ctx.prev = 1;
                        if (userid) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("User id is empty!");
                    case 4:
                        _ctx.next = 6;
                        return dispatch(entities_watchlist/* effects.followUser */.Sz.followUser({
                            userid: userid,
                            type: type
                        }));
                    case 6:
                        followUser = _ctx.sent;
                        _payload = followUser.payload, _$error = _payload.error, message = _payload.message, data = _payload.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            userid: userid
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    getTrendingPeople: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(TrendingPeopleWidget_slice_actionType.GET_TRENDING_PEOPLE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _timeRange, timeRange, response, _data, data, message, composedData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _timeRange = param.timeRange, timeRange = _timeRange === void 0 ? TrendingPeopleWidget_slice_initialState.timeRange : _timeRange;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return user/* default.getTrendingUser */.Z.getTrendingUser(timeRange.value);
                    case 4:
                        response = _ctx.sent;
                        if (!(!response || response.data && response.data.error)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error(response.data.error);
                    case 7:
                        _data = response.data, data = _data.data, message = _data.message;
                        composedData = data.map(function(user) {
                            return {
                                avatar: "".concat(api/* AVATAR_URL */.q$, "/").concat(user.avatar.thumb),
                                followers: parseInt(user.statistics.follower_count, 10),
                                id: user.id,
                                isFollowed: user.is_followed,
                                official: user.is_verified,
                                username: user.username,
                                // for interactions
                                followingStatus: TrendingPeopleWidget_constants/* FETCH_STATUS.IDLE */.e_.IDLE
                            };
                        });
                        return _ctx.abrupt("return", {
                            data: composedData,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getSuggestedPeople: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(TrendingPeopleWidget_slice_actionType.GET_SUGGESTED_PEOPLE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, response, _data, data, message, composedData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return friends/* default.getSuggestFriends */.Z.getSuggestFriends({
                        page: 1,
                        limit: 5,
                        filter: "FILTER_STREAM"
                    });
                case 4:
                    response = _ctx.sent;
                    if (!(!response.data || (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.error))) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("Attempt to get suggested people failed!");
                case 7:
                    _data = response.data, data = _data.data, message = _data.message;
                    composedData = data.map(function(user) {
                        return {
                            avatar: "".concat(api/* AVATAR_URL */.q$, "/").concat(user.user.user_avatar),
                            id: user.user.id,
                            isFollowed: user.followed === 1,
                            official: user.type === "OFFICIAL",
                            username: user.user.username,
                            followingStatus: TrendingPeopleWidget_constants/* FETCH_STATUS.IDLE */.e_.IDLE,
                            // key to differ list suggested people and trending
                            reason: user.reason
                        };
                    });
                    return _ctx.abrupt("return", {
                        data: composedData,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    })))
};
// state management
var TrendingPeopleWidget_slice_reducers = {
    changeTimeRange: function(draft, action) {
        draft.timeRange = action.payload.timeRange;
    },
    changeListChoice: function(state, action) {
        state.listChoice = action.payload.listChoice;
    }
};
var TrendingPeopleWidget_slice_obj;
// Async / Extra Reducer
var TrendingPeopleWidget_slice_extraReducers = (TrendingPeopleWidget_slice_obj = {}, // follow user
(0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.followUser.pending, function(draft, action) {
    var index = action.meta.arg.index;
    draft.list[index].followingStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.PENDING */.e_.PENDING;
    draft.message = null;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.followUser.fulfilled, function(draft, action) {
    var _arg = action.meta.arg, index = _arg.index, type = _arg.type;
    draft.list[index].followingStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.RESOLVED */.e_.RESOLVED;
    draft.list[index].isFollowed = type === "FOLLOW";
    draft.message = action.payload.message;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.followUser.rejected, function(draft, action) {
    var index = action.meta.arg.index;
    draft.list[index].followingStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.REJECTED */.e_.REJECTED;
    draft.error = action.error;
}), // trending people
(0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getTrendingPeople.pending, function(draft, action) {
    draft.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.PENDING */.e_.PENDING;
    draft.timeRange = action.meta.arg.timeRange;
    draft.message = null;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getTrendingPeople.fulfilled, function(draft, action) {
    draft.list = action.payload.data;
    draft.message = action.payload.message;
    draft.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.RESOLVED */.e_.RESOLVED;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getTrendingPeople.rejected, function(draft, action) {
    draft.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.REJECTED */.e_.REJECTED;
    draft.message = action.error;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getSuggestedPeople.pending, function(state) {
    state.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.PENDING */.e_.PENDING;
    state.message = null;
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getSuggestedPeople.fulfilled, function(state, action) {
    var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
    if (error) {
        state.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.REJECTED */.e_.REJECTED;
    } else {
        state.list = data;
        state.message = message;
        state.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.RESOLVED */.e_.RESOLVED;
    }
}), (0,_define_property/* default */.Z)(TrendingPeopleWidget_slice_obj, TrendingPeopleWidget_slice_effects.getSuggestedPeople.rejected, function(draft, action) {
    draft.fetchStatus = TrendingPeopleWidget_constants/* FETCH_STATUS.REJECTED */.e_.REJECTED;
    draft.message = action.error;
}), TrendingPeopleWidget_slice_obj);
// Slice
var trendingPeopleSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "trendingPeople",
    initialState: TrendingPeopleWidget_slice_initialState,
    reducers: TrendingPeopleWidget_slice_reducers,
    extraReducers: TrendingPeopleWidget_slice_extraReducers
});
/* harmony default export */ var TrendingPeopleWidget_slice = (trendingPeopleSlice);

;// CONCATENATED MODULE: ./src/global/TrendingPeopleWidget/reducer.js

var trendingPeopleReducer = TrendingPeopleWidget_slice.reducer;
/* harmony default export */ var TrendingPeopleWidget_reducer = (trendingPeopleReducer);

// EXTERNAL MODULE: ./src/global/WebSocket/slice.ts
var WebSocket_slice = __webpack_require__(23985);
;// CONCATENATED MODULE: ./src/global/WebSocket/reducer.ts

var websocketReducer = WebSocket_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var WebSocket_reducer = (websocketReducer);

// EXTERNAL MODULE: ./src/global/WebSocketV2/slice.ts + 1 modules
var WebSocketV2_slice = __webpack_require__(66250);
;// CONCATENATED MODULE: ./src/global/WebSocketV2/reducer.ts

var reducer_websocketReducer = WebSocketV2_slice/* default.reducer */.ZP.reducer;
/* harmony default export */ var WebSocketV2_reducer = (reducer_websocketReducer);

// EXTERNAL MODULE: ./src/global/Header/Search/slice.ts + 1 modules
var Search_slice = __webpack_require__(59016);
// EXTERNAL MODULE: ./src/lib/api/notification.ts
var notification = __webpack_require__(99368);
;// CONCATENATED MODULE: ./src/lib/models/notification/index.js
var schema = {
    count: {
        company: 0,
        stream: 0,
        other: 0
    },
    content: {
        company: [],
        stream: [],
        other: [],
        tipping: []
    }
};
/* harmony default export */ var models_notification = (schema);

// EXTERNAL MODULE: ./src/utils/notification.ts
var utils_notification = __webpack_require__(25178);
;// CONCATENATED MODULE: ./src/lib/entities/notification/slice.ts
/* eslint-disable no-unused-vars */ /* eslint-disable no-undef */ /* eslint-disable eqeqeq */ /* eslint-disable import/no-named-as-default-member */ /* eslint-disable camelcase */ 







// Action type
var notification_slice_CONTEXT = "@global/notification";
var notification_slice_actionType = {
    GET_UNREAD_NOTIFICATION_DATA: "".concat(notification_slice_CONTEXT, "/GET_UNREAD_NOTIFICATION_DATA"),
    GET_NOTIFICATION_DATA: "".concat(notification_slice_CONTEXT, "/GET_NOTIFICATION_DATA"),
    GET_PREVIOUS_NOTIFICATION_DATA: "".concat(notification_slice_CONTEXT, "/GET_PREVIOUS_NOTIFICATION_DATA"),
    GET_NOTIFICATION_DATA_GROUPED_BY_TYPE: "".concat(notification_slice_CONTEXT, "/GET_NOTIFICATION_DATA_GROUPED_BY_TYPE"),
    MARK_AS_READ_NOTIFICATION_DATA: "".concat(notification_slice_CONTEXT, "/MARK_AS_READ_NOTIFICATION_DATA")
};
// Initial state
var notification_slice_initialState = {
    error: null,
    isLoading: false,
    isLoadingMore: false,
    broadcast: models_notification,
    unread: 0,
    isReading: false,
    notificationStacks: [],
    lastId: null,
    isActivityChanged: false,
    isMentionChanged: false,
    isReportChanged: false,
    isTippingChanged: false
};
// Selectors
var notificationSelector = function(state) {
    return state.notification;
};
var notification_slice_selectors = (0,reselect_es/* createSelector */.P1)(notificationSelector, function(notificationState) {
    return (0,_object_spread/* default */.Z)({}, notificationState);
});
// Effects
var notification_slice_effects = {
    getNotificationData: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(notification_slice_actionType.GET_NOTIFICATION_DATA, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return notification/* getNotification */.v6();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to fetch notification data is failed");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error
                    });
                case 9:
                    return _ctx.abrupt("return", data);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    getNotificationDataGroupedByType: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(notification_slice_actionType.GET_NOTIFICATION_DATA_GROUPED_BY_TYPE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
            var _group, group, queues, results, normalizedResults;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _group = params.group, group = _group === void 0 ? [] : _group;
                        queues = group.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(type) {
                                var response, _data, data, _$error;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return notification/* getNotification */.v6(type);
                                        case 2:
                                            response = _ctx.sent;
                                            if (response.data) {
                                                _ctx.next = 5;
                                                break;
                                            }
                                            throw new Error("Attempt to fetch notification data is failed");
                                        case 5:
                                            _data = response.data, data = _data.data, _$error = _data.error;
                                            if (!_$error) {
                                                _ctx.next = 8;
                                                break;
                                            }
                                            return _ctx.abrupt("return", {
                                                error: _$error
                                            });
                                        case 8:
                                            return _ctx.abrupt("return", data.result);
                                        case 9:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(type) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        _ctx.next = 5;
                        return Promise.all(queues);
                    case 5:
                        results = _ctx.sent;
                        normalizedResults = results.flat();
                        return _ctx.abrupt("return", {
                            result: normalizedResults
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    markAsRead: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(notification_slice_actionType.MARK_AS_READ_NOTIFICATION_DATA, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
            var _type, type, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _type = params.type, type = _type === void 0 ? [] : _type;
                        _ctx.next = 4;
                        return notification/* markAsRead */.zJ(type);
                    case 4:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data ? response.data : null);
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    getUnreadNotificationNumber: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(notification_slice_actionType.GET_UNREAD_NOTIFICATION_DATA, // @ts-ignore
    (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, _$error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return notification/* getUnreadNotificationNumber */.O7();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to fetch notification data is failed");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error
                    });
                case 9:
                    return _ctx.abrupt("return", data);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    getPreviousNotificationData: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(notification_slice_actionType.GET_PREVIOUS_NOTIFICATION_DATA, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
            var limit, _types, types, lastId, response, _data, data, _$error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        limit = params.limit, _types = params.types, types = _types === void 0 ? [] : _types, lastId = params.lastId;
                        _ctx.next = 4;
                        return notification/* getNotification */.v6(types, limit, lastId);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to fetch notification data is failed");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", data);
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var notification_slice_reducers = {
    setUnreadNotificationNumber: function setUnreadNotificationNumber(draft, action) {
        draft.unread = action.payload;
    },
    // @deprecated | Not used in the project
    appendNotificationDataFromSocket: function appendNotificationDataFromSocket(draft, action) {
        var _payload = action.payload, notificationType = _payload.notificationType, index = _payload.index, data = _payload.data;
        if (index) {
            draft.broadcast.content[notificationType][index] = data;
        } else {
            draft.broadcast.content[notificationType].push(data);
        }
        draft.unread += 1;
        switch(notificationType){
            case "other":
                draft.isActivityChanged = true;
                break;
            case "stream":
                draft.isMentionChanged = true;
                break;
            case "company":
                draft.isReportChanged = true;
                break;
            case "tipping":
                draft.isTippingChanged = true;
                break;
            default:
                break;
        }
    },
    // @deprecated | Not used in the project
    removeNotificationMarkers: function removeNotificationMarkers(draft, action) {
        switch(action.payload){
            case "notification":
                draft.isActivityChanged = false;
                draft.isMentionChanged = false;
                draft.isReportChanged = false;
                draft.isTippingChanged = false;
                break;
            case "activity":
                draft.isActivityChanged = false;
                break;
            case "mention":
                draft.isMentionChanged = false;
                break;
            case "report":
                draft.isReportChanged = false;
                break;
            case "tipping":
                draft.isTippingChanged = false;
                break;
            default:
                break;
        }
    },
    // @deprecated | Not used in the project
    emptyUnreadNotificationData: function emptyUnreadNotificationData(draft) {
        draft.unread = 0;
    },
    // @deprecated | Not used in the project
    markAsReadNotificationItem: function markAsReadNotificationItem(draft, action) {
        var indexCompany = draft.broadcast.content.company.findIndex(function(item) {
            return item.id === action.payload;
        });
        var indexActivity = draft.broadcast.content.other.findIndex(function(item) {
            return item.id === action.payload;
        });
        var indexStream = draft.broadcast.content.stream.findIndex(function(item) {
            return item.id === action.payload;
        });
        var indexTipping = draft.broadcast.content.tipping.findIndex(function(item) {
            return item.id === action.payload;
        });
        // Notifiction ID is inside company (report) section
        if (indexCompany > -1) {
            draft.broadcast.content.company[indexCompany].status = 1;
        }
        // Notifiction ID is inside activity (other) section
        if (indexActivity > -1) {
            draft.broadcast.content.other[indexActivity].status = 1;
        }
        // Notifiction ID is inside stream (mention) section
        if (indexStream > -1) {
            draft.broadcast.content.stream[indexStream].status = 1;
        }
        // Notification ID is inside tipping section
        if (indexTipping > -1) {
            draft.broadcast.content.tipping[indexTipping].status = 1;
        }
    },
    // @deprecated | Not used in the project
    pushStackNotificationData: function pushStackNotificationData(draft, action) {
        draft.notificationStacks = [
            action.payload
        ];
    }
};
// Extra reducers
var notification_slice_extraReducers = function(builder) {
    // Get notification data
    builder.addCase(notification_slice_effects.getNotificationData.pending, function(state) {
        state.isLoading = true;
    }).addCase(notification_slice_effects.getNotificationData.fulfilled, function(state, action) {
        if (action.payload.error) {
            state.error = action.payload.error;
        } else {
            state.broadcast = (0,utils_notification/* normalizeNotification */.WE)(action.payload.result);
            state.unread = action.payload.unread;
            state.isLoading = false;
            // handle last id
            var result = action.payload.result;
            if (result && result.length > 0) {
                state.lastId = result[result.length - 1].id;
            }
        }
    }).addCase(notification_slice_effects.getNotificationData.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.payload;
    })// Get previous notification data
    .addCase(notification_slice_effects.getPreviousNotificationData.pending, function(state) {
        state.isLoadingMore = true;
    }).addCase(notification_slice_effects.getPreviousNotificationData.fulfilled, function(state, action) {
        if (action.payload.error) {
            state.error = action.payload.error;
        } else {
            var disorganizedContent = (0,utils_notification/* disorganizeNormalizedNotification */.QV)(state.broadcast.content);
            var results = (0,_to_consumable_array/* default */.Z)(disorganizedContent).concat((0,_to_consumable_array/* default */.Z)(action.payload.result));
            state.isLoadingMore = false;
            state.broadcast = (0,utils_notification/* normalizeNotification */.WE)(results);
        }
    }).addCase(notification_slice_effects.getPreviousNotificationData.rejected, function(state, action) {
        var error = action.payload.error;
        state.isLoadingMore = false;
        state.error = error;
    })// Get notification data grouped by type
    .addCase(notification_slice_effects.getNotificationDataGroupedByType.pending, function(state) {
        state.isLoading = true;
    }).addCase(notification_slice_effects.getNotificationDataGroupedByType.fulfilled, function(state, action) {
        if (action.payload.error) {
            state.error = action.payload.error;
        } else {
            var disorganizedContent = (0,utils_notification/* disorganizeNormalizedNotification */.QV)(state.broadcast.content);
            var results = (0,_to_consumable_array/* default */.Z)(disorganizedContent).concat((0,_to_consumable_array/* default */.Z)(action.payload.result));
            // handle last id
            var result = action.payload.result;
            if (result && result.length > 0) {
                state.lastId = result[result.length - 1].id;
            }
            state.isLoading = false;
            state.broadcast = (0,utils_notification/* normalizeNotification */.WE)(results);
        }
    }).addCase(notification_slice_effects.getNotificationDataGroupedByType.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.payload.error;
    })// Mark as read
    .addCase(notification_slice_effects.markAsRead.pending, function(state) {
        state.isReading = true;
    }).addCase(notification_slice_effects.markAsRead.fulfilled, function(state, action) {
        state.isReading = !action.payload.data;
        state.unread = 0;
    }).addCase(notification_slice_effects.markAsRead.rejected, function(state, action) {
        state.isReading = false;
        state.error = action.payload.error;
    })// Get unread notification number
    .addCase(notification_slice_effects.getUnreadNotificationNumber.fulfilled, function(state, action) {
        state.unread = action.payload.unread;
    }).addCase(notification_slice_effects.getUnreadNotificationNumber.rejected, function(state, action) {
        state.error = action.payload;
    });
};
// Slice
var notificationSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "notification",
    initialState: notification_slice_initialState,
    reducers: notification_slice_reducers,
    extraReducers: notification_slice_extraReducers
});
/* harmony default export */ var notification_slice = (notificationSlice);

// EXTERNAL MODULE: ./src/features/valuation/slice.ts
var valuation_slice = __webpack_require__(17712);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/slice.ts
var SearchCompany_slice = __webpack_require__(33908);
// EXTERNAL MODULE: ./src/lib/entities/livestream.ts + 1 modules
var livestream = __webpack_require__(61942);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/user/trending.js

var trending_schema = {
    followers: "",
    id: "",
    isFollowed: 0,
    official: 0,
    reputation: "",
    tren_controversial: "",
    tren_trending: "",
    user_avatar: "",
    user_avatar_medium: "",
    user_avatar_thumb: "",
    user_features: "",
    username: ""
};
var propTypes = {
    followers: prop_types.string,
    id: prop_types.string,
    isFollowed: prop_types.number,
    official: prop_types.number,
    reputation: prop_types.string,
    tren_controversial: prop_types.string,
    tren_trending: prop_types.string,
    user_avatar: prop_types.string,
    user_avatar_medium: prop_types.string,
    user_avatar_thumb: prop_types.string,
    user_features: prop_types.string,
    username: prop_types.string
};
/* harmony default export */ var trending = ({
    schema: trending_schema,
    propTypes: propTypes
});

;// CONCATENATED MODULE: ./src/lib/entities/trendingUser.js






// api


// model

// initial state
var trendingUser_initialState = {
    selected: trending.schema,
    list: [],
    isLoading: false,
    error: null,
    message: ""
};
// Selectors -------------------------------------------------------------------
var trendingUser_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return {
        selected: state.user.trending.selected,
        list: state.user.trending.list,
        isLoading: state.user.trending.isLoading,
        error: state.user.trending.error,
        message: state.user.trending.message
    };
}, function(state) {
    return state;
});
// Actions ---------------------------------------------------------------------
// types
var trendingUser_CONTEXT = "@redux/user";
var trendingUser_actionType = {
    FETCH_TRENDING: "".concat(trendingUser_CONTEXT, "/FETCH_TRENDING")
};
// effects
var trendingUser_effects = {
    // getTrendinguser -------------------------------------------------------------------
    getTrendingUser: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(trendingUser_actionType.FETCH_TRENDING, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message, _$error, sanitizedData;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return user/* default.getTrendingUser */.Z.getTrendingUser({
                        timeRange: "1W"
                    });
                case 3:
                    response = _ctx.sent;
                    if (!response.data) {
                        _ctx.next = 10;
                        break;
                    }
                    _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                    if (!_$error) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        message: message,
                        error: _$error
                    });
                case 8:
                    sanitizedData = data.map(function(user) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
                            // Concat User avatar url with base avatar URL
                            user_avatar: "".concat(api/* AVATAR_URL */.q$, "/").concat(user.user_avatar),
                            user_avatar_medium: "".concat(api/* AVATAR_URL */.q$, "/").concat(user.user_avatar_medium),
                            user_avatar_thumb: "".concat(api/* AVATAR_URL */.q$, "/").concat(user.user_avatar_thumb)
                        });
                    });
                    return _ctx.abrupt("return", {
                        data: sanitizedData,
                        message: message
                    });
                case 10:
                    throw new Error("Attempt to fetch Trending user Failed");
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    })))
};
// Reducer ---------------------------------------------------------------------
var trendingUser_reducers = {};
var trendingUser_obj;
// Extra Reducer ---------------------------------------------------------------
var trendingUser_extraReducers = (trendingUser_obj = {}, // Get Trending User ---------------------------------------------------------
(0,_define_property/* default */.Z)(trendingUser_obj, trendingUser_effects.getTrendingUser.pending, function(state) {
    state.isLoading = true;
}), (0,_define_property/* default */.Z)(trendingUser_obj, trendingUser_effects.getTrendingUser.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.error = error;
    } else {
        state.list = data;
    }
    state.message = message;
    state.isLoading = false;
}), (0,_define_property/* default */.Z)(trendingUser_obj, trendingUser_effects.getTrendingUser.rejected, function(state, action) {
    state.error = action.payload.error;
    state.message = action.payload.message;
    state.isLoading = false;
}), trendingUser_obj);
// Slice -----------------------------------------------------------------------
var trendingSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "trending",
    initialState: trendingUser_initialState,
    reducers: trendingUser_reducers,
    extraReducers: trendingUser_extraReducers
});
/* harmony default export */ var trendingUser = (trendingSlice);

// EXTERNAL MODULE: ./src/lib/entities/onboarding.ts
var onboarding = __webpack_require__(21939);
// EXTERNAL MODULE: ./src/lib/entities/company.ts + 1 modules
var entities_company = __webpack_require__(74645);
// EXTERNAL MODULE: ./src/lib/api/general.js
var general = __webpack_require__(69042);
;// CONCATENATED MODULE: ./src/lib/entities/general.js






// APIs

// Initial State
var general_initialState = {
    searchGif: {
        data: [],
        totalCount: 0,
        isLoading: false,
        error: null,
        message: ""
    },
    trendingGif: {
        data: [],
        totalCount: 0,
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selectors
var general_selectors = (0,reselect_es/* createSelector */.P1)(function(state) {
    return state.entities.general;
}, function(general) {
    return {
        searchGif: general.searchGif,
        trendingGif: general.trendingGif
    };
});
// Action type
var general_CONTEXT = "@redux/general";
var general_actionType = {
    GET_SEARCH_GIF: "".concat(general_CONTEXT, "/GET_SEARCH_GIF"),
    GET_TRENDING_GIF: "".concat(general_CONTEXT, "/GET_TRENDING_GIF"),
    LOAD_MORE_SEARCH_GIF: "".concat(general_CONTEXT, "/LOAD_MORE_SEARCH_GIF"),
    LOAD_MORE_TRENDING_GIF: "".concat(general_CONTEXT, "/LOAD_MORE_TRENDING_GIF")
};
var general_effects = {
    // search gif
    getSearchGif: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(general_actionType.GET_SEARCH_GIF, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var offset, response, _data, data, _meta, message, _$error, _pagination, totalCount, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        offset = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 0;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return general/* default.getSearchGif */.Z.getSearchGif(keyword, offset);
                    case 4:
                        response = _ctx.sent;
                        if (!(response.status >= 400)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Bad response from server");
                    case 7:
                        _data = response.data, data = _data.data, _meta = _data.meta, message = _meta.msg, _$error = _meta.error_code, _pagination = _data.pagination, totalCount = _pagination.total_count;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            totalCount: totalCount
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    loadMoreSearchGif: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(general_actionType.LOAD_MORE_SEARCH_GIF, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var offset, response, _data, data, _meta, message, _$error, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        offset = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 0;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return general/* default.getSearchGif */.Z.getSearchGif(keyword, offset);
                    case 4:
                        response = _ctx.sent;
                        if (!(response.status >= 400)) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Bad response from server");
                    case 7:
                        _data = response.data, data = _data.data, _meta = _data.meta, message = _meta.msg, _$error = _meta.error_code;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0.message
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    // trending gif
    getTrendingGif: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(general_actionType.GET_TRENDING_GIF, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var offset, response, _data, data, _meta, message, _$error, _pagination, totalCount, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    offset = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 0;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return general/* default.getTrendingGif */.Z.getTrendingGif(offset);
                case 4:
                    response = _ctx.sent;
                    if (!(response.status >= 400)) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("Bad response from server");
                case 7:
                    _data = response.data, data = _data.data, _meta = _data.meta, message = _meta.msg, _$error = _meta.error_code, _pagination = _data.pagination, totalCount = _pagination.total_count;
                    if (!_$error) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        message: message,
                        error: _$error
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message,
                        totalCount: totalCount
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0.message
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                13
            ]
        ]);
    }))),
    loadMoreTrendingGif: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(general_actionType.LOAD_MORE_TRENDING_GIF, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var offset, response, _data, data, _meta, message, _$error, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    offset = _args.length > 0 && _args[0] !== void 0 ? _args[0] : 0;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return general/* default.getTrendingGif */.Z.getTrendingGif(offset);
                case 4:
                    response = _ctx.sent;
                    if (!(response.status >= 400)) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("Bad response from server");
                case 7:
                    _data = response.data, data = _data.data, _meta = _data.meta, message = _meta.msg, _$error = _meta.error_code;
                    if (!_$error) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        message: message,
                        error: _$error
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0.message
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                13
            ]
        ]);
    })))
};
// Reducers
var general_reducers = {
    clearSearchGif: function(state) {
        state.searchGif = general_initialState.searchGif;
    }
};
var general_obj;
// Extra reducers
var general_extraReducers = (general_obj = {}, // search gif
(0,_define_property/* default */.Z)(general_obj, general_effects.getSearchGif.pending, function(state) {
    state.searchGif.isLoading = true;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.getSearchGif.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, totalCount = _payload.totalCount;
    if (error) {
        state.searchGif.error = error;
    } else {
        state.searchGif.data = data;
    }
    state.searchGif.totalCount = totalCount;
    state.searchGif.message = message;
    state.searchGif.isLoading = false;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.getSearchGif.rejected, function(state, action) {
    state.searchGif.error = action.payload.error;
    state.searchGif.isLoading = false;
}), // load more search gif
(0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreSearchGif.pending, function(state) {
    state.searchGif.isLoading = true;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreSearchGif.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.searchGif.error = error;
    } else {
        var currentData = state.searchGif.data.map(function(i) {
            return (0,_object_spread/* default */.Z)({}, i);
        });
        state.searchGif.data = (0,_to_consumable_array/* default */.Z)(currentData).concat((0,_to_consumable_array/* default */.Z)(data));
    }
    state.searchGif.message = message;
    state.searchGif.isLoading = false;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreSearchGif.rejected, function(state, action) {
    state.searchGif.error = action.payload.error;
    state.searchGif.isLoading = false;
}), // trending gif
(0,_define_property/* default */.Z)(general_obj, general_effects.getTrendingGif.pending, function(state) {
    state.trendingGif.isLoading = true;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.getTrendingGif.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, totalCount = _payload.totalCount;
    if (error) {
        state.trendingGif.error = error;
    } else {
        state.trendingGif.data = data;
    }
    state.trendingGif.totalCount = totalCount;
    state.trendingGif.message = message;
    state.trendingGif.isLoading = false;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.getTrendingGif.rejected, function(state, action) {
    state.trendingGif.error = action.payload.error;
    state.trendingGif.isLoading = false;
}), // load more trending gif
(0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreTrendingGif.pending, function(state) {
    state.trendingGif.isLoading = true;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreTrendingGif.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
    if (error) {
        state.trendingGif.error = error;
    } else {
        var currentData = state.trendingGif.data.map(function(i) {
            return (0,_object_spread/* default */.Z)({}, i);
        });
        state.trendingGif.data = (0,_to_consumable_array/* default */.Z)(currentData).concat((0,_to_consumable_array/* default */.Z)(data));
    }
    state.trendingGif.message = message;
    state.trendingGif.isLoading = false;
}), (0,_define_property/* default */.Z)(general_obj, general_effects.loadMoreTrendingGif.rejected, function(state, action) {
    state.trendingGif.error = action.payload.error;
    state.trendingGif.isLoading = false;
}), general_obj);
var generalSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "general",
    initialState: general_initialState,
    reducers: general_reducers,
    extraReducers: general_extraReducers
});
/* harmony default export */ var entities_general = (generalSlice);

// EXTERNAL MODULE: ./src/lib/entities/user.js
var entities_user = __webpack_require__(16992);
// EXTERNAL MODULE: ./src/lib/entities/stream.ts
var entities_stream = __webpack_require__(25641);
// EXTERNAL MODULE: ./src/lib/entities/moderation.js
var moderation = __webpack_require__(56214);
// EXTERNAL MODULE: ./src/lib/entities/tipping.js
var tipping = __webpack_require__(98585);
// EXTERNAL MODULE: ./src/lib/entities/comparison.ts + 1 modules
var comparison = __webpack_require__(60913);
// EXTERNAL MODULE: ./src/lib/entities/fundachart.ts
var fundachart = __webpack_require__(4822);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var chat_slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/lib/entities/shop.ts + 1 modules
var shop = __webpack_require__(11733);
;// CONCATENATED MODULE: ./src/lib/entities/index.js
















var entitiesReducer = (0,redux/* combineReducers */.UY)({
    chat: chat_slice/* default.reducer */.ZP.reducer,
    credentials: credentials/* default.reducer */.ZP.reducer,
    profile: profile/* default.reducer */.ZP.reducer,
    trending: trendingUser.reducer,
    onboarding: onboarding/* default.reducer */.ZP.reducer,
    company: entities_company/* default.reducer */.ZP.reducer,
    general: entities_general.reducer,
    user: entities_user/* default.reducer */.ZP.reducer,
    stream: entities_stream/* default.reducer */.ZP.reducer,
    moderation: moderation/* default.reducer */.ZP.reducer,
    tipping: tipping/* default.reducer */.ZP.reducer,
    watchlist: entities_watchlist/* default.reducer */.ZP.reducer,
    comparison: comparison/* default.reducer */.ZP.reducer,
    fundachart: fundachart/* default.reducer */.ZP.reducer,
    shop: shop/* default.reducer */.ZP.reducer
});
/* harmony default export */ var entities = (entitiesReducer);

;// CONCATENATED MODULE: ./src/lib/rootReducer.ts

// import reducers -------------------------------------------------------------
// feature specific reducers

















// globally used component reducers













// entities reducers

// combile each reducer
var rootReducer = (0,redux/* combineReducers */.UY)({
    // features
    discoverPeople: reducer,
    editProfile: edit_profile_reducer,
    onboarding: onboarding_reducer,
    register: register_reducer,
    resetPassword: reset_password_reducer,
    userProfile: user_reducer,
    watchlist: watchlist_reducer,
    companyProfile: company_reducer,
    catalog: catalog_reducer,
    postDetail: post_detail_reducer,
    mainLayout: MainLayout_reducer,
    moderation: Moderation_reducer,
    trendingPeople: TrendingPeopleWidget_reducer,
    suggestedPeople: SuggestedPeopleWidget_reducer,
    research: research_slice/* default.reducer */.ZP.reducer,
    calendar: calendar_slice/* default.reducer */.ZP.reducer,
    earnings: earnings_slice/* default.reducer */.ZP.reducer,
    websocket: WebSocket_reducer,
    websocketV2: WebSocketV2_reducer,
    chartbit: chartbit_reducer,
    orderbookModal: TradingModal_slice.reducer,
    valuation: valuation_slice/* default.reducer */.ZP.reducer,
    screener: screener_slice/* default.reducer */.ZP.reducer,
    liveStream: livestream/* default.reducer */.ZP.reducer,
    searchCompany: SearchCompany_slice/* default.reducer */.ZP.reducer,
    // globally used components
    stream: stream_slice.reducer,
    search: Search_slice/* default.reducer */.ZP.reducer,
    notification: notification_slice.reducer,
    streamConversation: StreamConversation_slice/* default.reducer */.ZP.reducer,
    streamWidget: StreamWidget_slice/* default.reducer */.ZP.reducer,
    // entities
    entities: entities
});
/* harmony default export */ var lib_rootReducer = (rootReducer);

;// CONCATENATED MODULE: ./src/lib/store.js
/* eslint-disable no-underscore-dangle */ 

// import reducers

// devtools config definitions
var devToolsConfig = {
    name: "Stockbit Web-App"
};
var withDevtools =  false ? 0 : false;
// Config store
var makeStore = function() {
    return (0,redux_toolkit_esm/* configureStore */.xC)({
        reducer: lib_rootReducer,
        devTools: withDevtools,
        middleware: function(getDefaultMiddleware) {
            return getDefaultMiddleware({
                serializableCheck: {
                    // Ignore these action types
                    ignoredActions: [
                        "@redux/websocket/INIT_CONFIG",
                        "@redux/websocket/UPDATE_CONFIG",
                        "@redux/websocket/ADD_SOCKET_DATA", 
                    ]
                }
            });
        }
    });
};
var store = makeStore();
var wrapper = (0,es6/* createWrapper */.KV)(makeStore, {
    debug: true
});
/* harmony default export */ var lib_store = ((/* unused pure expression or super */ null && (store)));

// EXTERNAL MODULE: ./src/config/theme.ts
var theme = __webpack_require__(30079);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/GlobalStyles/alert.ts
var GlobalStyles_alert = __webpack_require__(80341);
;// CONCATENATED MODULE: ./src/global/GlobalStyles/tooltip.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .tooltip-overlay-green {\n    cursor: pointer;\n    .ant-tooltip-arrow-content {\n      background: ",
        ";\n    }\n    .ant-tooltip-inner { \n      border-radius: 4px;\n    }\n  }\n\n  .tooltip-overlay-dark {\n    cursor: pointer;\n    .ant-tooltip-arrow-content {\n      background: ",
        ";\n    }\n    .ant-tooltip-inner { \n      background: ",
        ";\n      border-radius: 4px;\n    }\n  }\n\n  .tooltip-overlay-red {\n    cursor: pointer;\n    .ant-tooltip-arrow-content {\n      background: ",
        ";\n    }\n    .ant-tooltip-inner { \n      background: ",
        ";\n      border-radius: 4px;\n    }\n  }\n\n  .tooltip-overlay-transparent {\n    cursor: pointer;\n    padding-top: 0 !important;\n    .ant-tooltip-arrow-content {\n      display: none;\n      background: transparent;\n      box-shadow: unset;\n\n      ::before {\n        transparent;\n      }\n    }\n    \n    .ant-tooltip-inner { \n      background: transparent;\n      border-radius: 4px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var tooltipStyles = (0,styled_components_browser_esm.css)(_templateObject(), ui/* color.primary */.$_.primary, ui/* color.highempahis */.$_.highempahis, ui/* color.highempahis */.$_.highempahis, ui/* color.sunsetOrange */.$_.sunsetOrange, ui/* color.sunsetOrange */.$_.sunsetOrange);
/* harmony default export */ var tooltip = (tooltipStyles);

;// CONCATENATED MODULE: ./src/global/GlobalStyles/layout.ts

function layout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .chat-page-layout-container {\n    padding-top: 60px !important;\n    margin-top: unset !important;\n    padding-right: 0px !important;\n\n    @media ",
        " {\n      padding-top: 120px !important;\n    }\n\n    @media ",
        " {\n      max-width: 1300px;\n    }\n  }\n"
    ]);
    layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var layoutPageContainerStyles = (0,styled_components_browser_esm.css)(layout_templateObject(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
/* harmony default export */ var layout = (layoutPageContainerStyles);

;// CONCATENATED MODULE: ./src/global/GlobalStyles/index.js

function GlobalStyles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* Wave Color */\n  html {\n    --antd-wave-shadow-color: ",
        ";\n  }\n\n  body {\n    background-color: #f5f5f5;\n    font-family: var(--regular-font);\n    font-size: 14px;\n    height: auto;\n    font-variant: normal;\n    -webkit-font-feature-settings: normal;\n    font-feature-settings: normal;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  b,\n  strong {\n    font-family: var(--bold-font);\n    font-weight: normal;\n  }\n\n  /* ANTD Modal */\n  /* .ant-modal-mask {\n    z-index: 1031;\n  }\n\n  .ant-modal-wrap {\n    z-index: 1040;\n  } */\n\n  /* Antd Popover */\n  .ant-popover-inner-content {\n    padding: 0;\n  }\n  .ant-popover-inner {\n    box-shadow: none;\n    border: none;\n  }\n  .ant-popover-arrow {\n    display: none;\n  }\n\n  /* Antd DatePicker */\n  .ant-picker-panel-container {\n    border: 1px solid ",
        ";\n  }\n\n  .ant-picker-decade-panel,\n  .ant-picker-year-panel,\n  .ant-picker-quarter-panel,\n  .ant-picker-month-panel,\n  .ant-picker-week-panel,\n  .ant-picker-date-panel,\n  .ant-picker-time-panel {\n    width: 230px;\n  }\n\n  .ant-picker-content {\n    table-layout: auto;\n    width: 100% !important;\n  }\n\n  .ant-picker-header-view {\n    font-size: 12px;\n    font-family: var(--font-bold);\n\n    button {\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  }\n  .ant-picker-cell-in-view {\n    font-family: var(--font-bold);\n  }\n  .ant-picker-footer {\n    display: block !important;\n  }\n  .ant-picker-today-btn {\n    font-size: 12px;\n    color: ",
        ";\n    font-family: var(--font-bold);\n    display: block !important;\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n  .ant-picker-dropdown {\n    font-size: 10px !important;\n  }\n  .ant-picker-cell {\n    padding: 2px 0;\n  }\n\n  .ant-picker-cell-in-view.ant-picker-cell-today\n    .ant-picker-cell-inner::before {\n    border: none !important;\n  }\n  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n    background: #00ab6b !important;\n    color: white !important;\n  }\n  .ant-picker-content th {\n    font-weight: bold;\n  }\n  .ant-picker-cell-in-view.ant-picker-cell-today\n    .ant-picker-cell-inner::before {\n    border-color: ",
        ";\n  }\n  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n    color: unset;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    background: #00ab6b !important;\n    color: white !important;\n  }\n  .ant-picker-cell:hover:not(.ant-picker-cell-selected) .ant-picker-cell-inner {\n    background: ",
        " !important;\n    margin: -1px;\n  }\n\n  /* Antd Dropdown */\n  .ant-dropdown {\n    li {\n      height: 28px !important;\n      line-height: 28px !important;\n      padding: 0 10px !important;\n    }\n  }\n  .ant-dropdown-menu {\n    border: none;\n    border-radius: 0;\n    box-shadow: 0 0 10px ",
        ";\n    padding: 0px;\n  }\n\n  .ant-dropdown-menu-item,\n  .ant-dropdown-menu-submenu-title {\n    padding: 5px;\n\n    p {\n      color: ",
        ";\n    }\n\n    &:hover,\n    &.ant-dropdown-menu-item-active {\n      p {\n        color: ",
        ";\n      }\n    }\n\n    &:first-child {\n      border-radius: 3px 3px 0 0;\n    }\n\n    &:last-child {\n      border-radius: 0 0 3px 3px;\n    }\n  }\n\n  /* Antd Select */\n  .ant-select-item {\n    font-family: 'ProximaNovaRg';\n  }\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset;\n  }\n  .ant-select-dropdown {\n    box-shadow: none;\n    border: 1px solid ",
        ";\n    border-radius: 3px;\n\n    div[aria-selected='true'] {\n      font-family: var(--bold-font);\n    }\n  }\n\n  /* Antd tag a */\n  a:hover {\n    color: ",
        ";\n  }\n\n  /* Antd autocomplete */\n  .ant-select-focused .ant-select-selector,\n  .ant-select-selector:focus,\n  .ant-select-selector:active,\n  .ant-select-selector:hover,\n  .ant-select-open .ant-select-selector {\n    border-color: ",
        " !important;\n    box-shadow: none !important;\n    outline: none !important;\n  }\n\n  /* Antd modal */\n  .ant-modal-mask {\n    background-color: rgba(18, 18, 18, 0.5);\n  }\n\n  /* Antd Message */\n  .ant-message {\n    z-index: 999999; // TOP OF LAYER\n  }\n\n  .ant-btn-primary[disabled] {\n    background: #616161 !important;\n    color: #cbcbcb;\n    border: none;\n\n    &:hover > p {\n      color: #cbcbcb;\n    }\n  }\n\n  body.disabled-popover-animation .ant-popover {\n    animation-duration: 0s !important;\n  }\n\n  body.no-scroll {\n    overflow: hidden;\n    width: 100% !important;\n  }\n"
    ]);
    GlobalStyles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :root {\n    --font-regular: 'ProximaNovaRg', sans-serif;\n    --font-bold: 'ProximaNovaBd', sans-serif;\n  }\n\n  @keyframes placeHolderShimmer {\n    0% {\n      background-position: -468px 0;\n    }\n    100% {\n      background-position: 468px 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n    ",
        "\n\n    :root {\n      --regular-font: \"ProximaNovaRg\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n      --bold-font: \"ProximaNovaBd\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n      --light-font: \"ProximaNovaLt\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    }\n\n    ::-webkit-scrollbar {\n      width: 4px;\n      height: 5px;\n    }\n    ::-webkit-scrollbar-button {\n      width: 0px;\n      height: 0px;\n    }\n    ::-webkit-scrollbar-thumb {\n      background: ",
        ";\n      border: 0px none ",
        ";\n      border-radius: 0;\n    }\n    ::-webkit-scrollbar-thumb:hover {\n      background: ",
        ";\n    }\n    ::-webkit-scrollbar-thumb:active {\n      background: ",
        ";\n    }\n    ::-webkit-scrollbar-track {\n      background: white;\n      border: 0px none ",
        ";\n      border-radius: 0;\n    }\n    ::-webkit-scrollbar-track:hover {\n      background: ",
        ";\n    }\n    ::-webkit-scrollbar-track:active {\n      background: ",
        ';\n    }\n    ::-webkit-scrollbar-corner {\n      background: transparent;\n    }\n\n    .hide {\n      display: none;\n    }\n\n    .stop-scrolling {\n      height: 100%;\n      overflow: hidden;\n    }\n\n    /* Hide crisp chat */\n    #crisp-chatbox > div > a {\n      display: none !important;\n\n      &[data-visible="true"] {\n        display: block !important;\n      }\n    }\n\n    /* Hide google recaptcha */\n    .grecaptcha-badge {\n      opacity: 0;\n      visibility: hidden;\n    }\n\n    select {\n      appearance: none;\n      cursor: pointer;\n      padding-right : 20px;\n      min-width : 48px;\n      :focus {\n        outline: 0;\n      }\n      background: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IiB2aWV3Qm94PSIwIDAgMjU1IDI1NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjU1IDI1NTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxnIGlkPSJhcnJvdy1kcm9wLWRvd24iPgoJCTxwb2x5Z29uIHBvaW50cz0iMCw2My43NSAxMjcuNSwxOTEuMjUgMjU1LDYzLjc1ICAgIiBmaWxsPSIjNmI2YjZiIi8+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==")\n        calc(100% - 8px) center/8px auto no-repeat #fff !important;\n    }\n\n    .sysmsg-content {\n      align-items: center;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      padding: 0;\n\n      & > div {\n        background: transparent;\n        padding: 0;\n      }\n\n      & > div > div > span {\n        & > .alert-green,\n        & > .alert-red,\n        & > .alert-blue,\n        & > .alert-orange {\n          border-radius: 5px;\n          padding: 10px 15px;\n        }\n      }\n\n      & > div > div > span > .alert-green {\n        background: #e1f6e5;\n        color: ',
        ";\n      }\n      \n      & > div > div > span > .alert-red {\n        background: ",
        ";\n        color: ",
        ";\n      }\n      \n      & > div > div > span > .alert-orange {\n        background: ",
        ";\n        color: ",
        ";\n      }\n      \n      & > div > div > span > .alert-blue {\n        background: ",
        ";\n        color: ",
        ";\n      }\n\n      & > div > div > span > .snackbar-green {\n        font-size: 12px;\n        border-radius: 2px;\n        padding: 13px 16px;\n        font-family: var(--font-bold);\n        background: #e1f6e5;\n\n        span {\n          margin: 0 12px;\n        }\n      }\n\n      & > div > div > span > .plain-green {\n        font-size: 14px;\n        border-radius: 2px;\n        padding: 8px 10px;\n        font-family: var(--font-regular);\n        background: ",
        ";\n        color: ",
        ";\n        line-height: 16.1px;\n      }\n    }\n\n    .modal-conversation {\n      z-index: 50 !important;\n      @media ",
        " {\n        z-index: 1000 !important;\n      }\n    }\n    \n    input:-webkit-autofill {\n      -webkit-box-shadow: 0 0 0 1000px #fff inset!important;\n      box-shadow: 0 0 0 1000px #fff inset!important;\n    }\n\n    .panel-avatar {\n      width: 30px;\n      height: 30px;\n      border: solid 1px #c0c0c0;\n      border-radius: 50%;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    }\n  \n    // FLOATING CHAT NOTIFICATION\n    .float-chat-notification {\n      min-height: 76px;\n      cursor: pointer;\n      padding: 15px !important;\n      font-family: ProximaNovaRg;\n      \n      :last-child {\n        margin-bottom: 0;\n      }\n      \n      & div > div > div {\n        margin-left: 60px !important;\n      }\n\n      & .ant-notification-close-icon {\n        font-size: 10px;\n      }\n\n      & .ant-notification-notice {\n        margin-bottom: unset;\n      }\n\n      & .ant-notification-notice-message {\n        font-size: 14px;\n        font-weight: 700;\n        margin-bottom: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      & .ant-notification-notice-description {\n        font-size: 14px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      & .ant-notification-notice-close {\n        top: 10px;\n      }\n    }\n\n    // FLOATIN ALERT NOTIFICATION\n    .float-alert-notification {\n      padding: 0;\n      border: 1px solid #dadada;\n\n      :last-child {\n        margin-bottom: 0;\n      }\n\n      .ant-notification-notice-icon {\n        left: 0;\n        top: 0;\n        margin-left: 0;\n        height: 100%;\n        \n        img {\n          width: 100%;\n          height: 100%\n        }\n      }\n\n      & .ant-notification-notice-message {\n        font-size: 14px;\n        font-weight: 700;\n        font-family: var(--font-bold);\n        margin-bottom: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding-top: 15px;\n        margin-left: 85px;\n      }\n\n      & .ant-notification-notice-description {\n        padding-bottom: 15px;\n        margin-left: 85px;\n        line-height: normal;\n      }\n\n      & .ant-notification-notice-close {\n        top: 16px;\n        right: 16px;\n        font-size: 12px;\n      }\n    }\n\n    // FLOATIN GENERAL NOTIFICATION\n    .float-general-notification {\n      cursor: pointer;\n      padding: 15px !important;\n      font-family: ProximaNovaRg;\n      \n      :last-child {\n        margin-bottom: 0;\n      }\n      \n      & div > div > div {\n        margin-left: 60px !important;\n      }\n\n      & .ant-notification-close-icon {\n        font-size: 10px;\n      }\n\n      & .ant-notification-notice {\n        margin-bottom: unset;\n      }\n\n      & .ant-notification-notice-message {\n        font-size: 14px;\n        font-weight: 700;\n        margin-bottom: 0;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      & .ant-notification-notice-description {\n        font-size: 14px;\n        overflow: hidden;\n      }\n\n      & .ant-notification-notice-close {\n        top: 10px;\n      }\n    }\n\n    .reverse {\n      transform: rotate(180deg);\n    }\n\n    .button-unstyled {\n      background: transparent;\n      border: none;\n      cursor: pointer;\n\n      &.full-button {\n        display: block;\n        width: 100%;\n      }\n    }\n\n    /* FUNDACHART */\n    .fundachart-custom-tooltip {\n      height: 16px;\n      border: 1px solid #dadada;\n      position: absolute;\n      font-size: 11px;\n      display: flex;\n      align-items: center;\n      padding: 1px 5px 0 5px;\n      background-color: #FFF;\n    }\n\n    .fundachart-custom-tooltip:before {\n      content: ' ';\n      right: 100%;\n      top: 50%;\n      height: 0;\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border: solid transparent;\n      border-color: rgba(218, 218, 218, 0);\n      border-right-color: #dadada;\n      border-width: 9px;\n      margin-top: -9px;\n    }\n\n    .fundachart-custom-tooltip:after {\n      content: ' ';\n      right: 100%;\n      top: 50%;\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none;\n      border: solid transparent;\n      border-color: rgba(255, 255, 255, 0);\n      border-right-color: #fff;\n      border-width: 8px;\n      margin-top: -8px;\n    }\n\n    .orderbook-text-cell {\n      color: #333333;\n      font-family: ProximaNovaRg;\n      font-size: 12px;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      line-height: 16px;\n      text-align: right;\n      padding: 8px 0px;\n\n      &.up {\n        color: #00ab6b;\n      }\n\n      &.down {\n        color: #ee4a49;\n      }\n\n      &.notchange {\n        color: #979134;\n      }\n\n      &.frequency {\n        color: #8277F8;\n      }\n\n      &.lot {\n        font-size: 11px;\n      }\n\n      &.title {\n        font-family: ProximaNovaBd;\n        -webkit-font-smoothing: antialiased;\n        font-smoothing: antialiased;\n        line-height: 16px;\n        padding: 8px 0px;\n      }\n    }\n\n    .orderbook-text-summary {\n      color: #333333;\n      font-family: ProximaNovaBd;\n      font-size: 12px;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      -webkit-font-smoothing: antialiased;\n      font-smoothing: antialiased;\n      line-height: 16px;\n      text-align: center;\n      padding: 8px 0px;\n\n      &.center {\n        text-align: center;\n      }\n\n      &.lot {\n        font-size: 11px;\n      }\n    }\n\n    .orderbook-que-bid,\n    .orderbook-que-off {\n      position: relative;\n    }\n\n    .table-live-price {\n      font-size: 12px;\n      font-family: ProximaNovaRg;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      line-height: 16px;\n      margin: 12px 8px;\n      table-layout: fixed;\n      width: calc(100% - calc(2 * 8px));\n\n      td {\n        padding: 4px 0px;\n        text-align: right;\n        white-space: nowrap;\n        color: #333333;\n\n        &.up {\n          color: #00ab6b;\n        }\n  \n        &.down {\n          color: #ee4a49;\n        }\n  \n        &.notchange {\n          color: #979134;\n        }\n      }\n\n      td:first-child {\n        padding-left: 0px;\n        text-align: left;\n      }\n\n      td:nth-child(3) {\n        text-align: left;\n      }\n\n      td:nth-child(5) {\n        text-align: left;\n      }\n\n      td:last-child {\n        padding-right: 0px;\n      }\n\n      tr:first-child {\n        td {\n          padding-top: 0px;\n        }\n      }\n\n      tr:last-child {\n        td {\n          padding-bottom: 0px;\n        }\n      }\n    }\n\n    .orderbook-last-price {\n      font-size: 12.5px;\n      font-family: ProximaNovaRg;\n      font-variant: normal;\n      -webkit-font-feature-settings: normal;\n      font-feature-settings: normal;\n      line-height: 21px;\n\n      &.up {\n        color: #00ab6b;\n      }\n\n      &.down {\n        color: #ee4a49;\n      }\n\n      &.notchange {\n        color: #979134;\n      }\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n\n    .intercom-unread-count {\n      backface-visibility: hidden;\n      background: #fc576b;\n      border-radius: 10px;\n      box-shadow: none;\n      box-sizing: border-box;\n      color: #fff;\n      font-size: 12px;\n      height: 20px;\n      line-height: 20px;\n      min-width: 20px;\n      opacity: 0;\n      padding: 0 4px;\n      position: absolute;\n      left: -5px;\n      text-align: center;\n      top: 5px;\n      transform: scale(0.5);\n      transform-origin: center;\n      transition: opacity 0.15s ease, transform 0.15s ease;\n      font-family: sans-serif;\n\n      @media screen and (max-width: 720px) {\n          left: 3px;\n      }\n      \n      &.active {\n        opacity: 1;\n        transform: scale(1);\n      }\n    }\n\n    .price-cell {\n      width: max-content;\n      \n      &.min {\n        min-width: 135px;\n      }\n\n      &.mid {\n        min-width: 156px;\n      }\n\n      &.full {\n        min-width: max-content;\n      }\n    }\n\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var hexOpacity = ui/* utils.hexOpacity */.P6.hexOpacity;
var overideAntdCSS = (0,styled_components_browser_esm.css)(GlobalStyles_templateObject(), ui/* color.primary */.$_.primary, ui/* color.gainsboro */.$_.gainsboro, ui/* color.gainsboro */.$_.gainsboro, ui/* color.primary */.$_.primary, ui/* color.primary */.$_.primary, ui/* color.primary */.$_.primary, ui/* color.light */.$_.light, ui/* color.primary */.$_.primary, ui/* color.gainsboro */.$_.gainsboro, "".concat(ui/* color.downgray */.$_.downgray).concat(hexOpacity(35)), ui/* color.black */.$_.black + hexOpacity(60), ui/* color.primary */.$_.primary, ui/* color.gainsboro */.$_.gainsboro, ui/* color.primary */.$_.primary, ui/* color.gainsboro */.$_.gainsboro);
var variables = (0,styled_components_browser_esm.css)(_templateObject1());
var GlobalStyles = (0,styled_components_browser_esm.createGlobalStyle)(_templateObject2(), overideAntdCSS, variables, ui/* color.gainsboro */.$_.gainsboro, ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.dimgray */.$_.dimgray, ui/* color.dimgray */.$_.dimgray, ui/* color.light */.$_.light, ui/* color.gainsboro */.$_.gainsboro, ui/* color.gainsboro */.$_.gainsboro, ui/* color.black */.$_.black, ui/* color.alertRed */.$_.alertRed, ui/* color.black */.$_.black, ui/* color.alertOrange */.$_.alertOrange, ui/* color.black */.$_.black, ui/* color.alertBlue */.$_.alertBlue, ui/* color.black */.$_.black, ui/* color.primary */.$_.primary, ui/* color.light */.$_.light, ui/* device.tablet */.Uh.tablet, GlobalStyles_alert/* default */.Z, tooltip, layout);
/* harmony default export */ var global_GlobalStyles = (GlobalStyles);

;// CONCATENATED MODULE: ./src/global/Scripts/TikTokPixel.js
/* eslint-disable react/no-danger */ 

var tiktokKey = "C5SDQNK247CAE4T40JG0";
var TikTokPixel = function() {
    if (!tiktokKey) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            dangerouslySetInnerHTML: {
                __html: '\n            !function (w, d, t) {\n              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};\n            \n              ttq.load(\''.concat(tiktokKey, "');\n              ttq.page();\n            }(window, document, 'ttq');\n          ")
            }
        })
    });
};
/* harmony default export */ var Scripts_TikTokPixel = (TikTokPixel);

// EXTERNAL MODULE: ./src/global/SupportButton/index.tsx
var SupportButton = __webpack_require__(84468);
// EXTERNAL MODULE: ./src/global/Datafeed/index.tsx + 1 modules
var Datafeed = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/websocket_pb.js + 5 modules
var websocket_pb = __webpack_require__(4384);
// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
// EXTERNAL MODULE: ./src/global/Securities/websocket/store/securities.store.tsx
var securities_store = __webpack_require__(28840);
// EXTERNAL MODULE: ./src/global/Securities/websocket/SecuritiesContext.tsx
var SecuritiesContext = __webpack_require__(46895);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var OrderTable_store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/typings/auth.ts
var auth = __webpack_require__(97718);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/global/Securities/websocket/constants.ts
var websocket_constants = __webpack_require__(93313);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/hooks/useUnauthorized.ts








function useUnauthorized() {
    var router = (0,next_router.useRouter)();
    var resetUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.resetUIValue;
    });
    var handleLogoutSecurities = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isSecuritiesPage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                    case 2:
                        isSecuritiesPage = /securities\/.+/i.test(router.asPath);
                        if (!isSecuritiesPage) {
                            _ctx.next = 8;
                            break;
                        }
                        OrderTable_store/* default.getState */.Z.getState().resetOrderTableStore();
                        resetUIValue(auth/* LoginType.Securities */.B.Securities);
                        _ctx.next = 8;
                        return router.push("/stream");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLogoutSecurities() {
            return _ref.apply(this, arguments);
        };
    }();
    var checkUnauthorized = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(URL, token) {
            var httpsUrl, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        httpsUrl = URL.replace("wss://", "https://");
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return fetch(httpsUrl, {
                            method: "GET",
                            headers: {
                                Authorization: "Bearer ".concat(token)
                            }
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.ok) {
                            _ctx.next = 10;
                            break;
                        }
                        if (!(response.status === websocket_constants/* ERROR_CODE.UNAUTHORIZED */.Bq.UNAUTHORIZED)) {
                            _ctx.next = 9;
                            break;
                        }
                        handleLogoutSecurities();
                        return _ctx.abrupt("return", true);
                    case 9:
                        throw new Error(response.statusText);
                    case 10:
                        return _ctx.abrupt("return", false);
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", false);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function checkUnauthorized(URL, token) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        checkUnauthorized: checkUnauthorized
    };
};

// EXTERNAL MODULE: ./src/global/Securities/websocket/utils.ts
var utils = __webpack_require__(46238);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/SecuritiesProvider.tsx














var WS_URL = "wss://gen-websocket.lab.stockbit.com/v1";
var SecuritiesProvider = function(props) {
    var ref, ref1;
    var children = props.children, isLoggedIn = props.isLoggedIn, _heartbeatInterval = props.heartbeatInterval, heartbeatInterval = _heartbeatInterval === void 0 ? websocket_constants/* HEARTBEAT_INTERVAL */.al : _heartbeatInterval;
    var actionsRef = (0,react.useRef)({});
    var isLoggedInRef = (0,react.useRef)(false);
    var lastPing = (0,react.useRef)(Date.now());
    var lastPong = (0,react.useRef)(Date.now());
    var reconnectCounterRef = (0,react.useRef)(1);
    var reconnectIntervalRef = (0,react.useRef)();
    var socketRef = (0,react.useRef)();
    var ref2 = (0,react.useState)(), authToken = ref2[0], setAuthToken = ref2[1];
    var ref3 = (0,securities_store/* useSecuritiesStore */.$A)(function(state) {
        return {
            channel: state.channel,
            isReconnectionFailed: state.isReconnectionFailed,
            setChannel: state.setChannel,
            setIsReconnectionFailed: state.setIsReconnectionFailed,
            setIsSocketOnline: state.setIsSocketOnline
        };
    }), channel = ref3.channel, isReconnectionFailed = ref3.isReconnectionFailed, setChannel = ref3.setChannel, setIsReconnectionFailed = ref3.setIsReconnectionFailed, setIsSocketOnline = ref3.setIsSocketOnline;
    var checkUnauthorized = useUnauthorized().checkUnauthorized;
    var setCookie = (0,react.useCallback)(function(value) {
        if (!(0,app/* isClient */.C5)()) return;
        document.cookie = (0,utils/* generateWSCookie */.y_)(value);
    }, [
        (0,app/* isClient */.C5)()
    ]);
    var setAction = function(channelKey, callbackFn) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            draft[channelKey] = callbackFn;
        });
    };
    var removeAction = function(channelKey) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            if (draft === null || draft === void 0 ? void 0 : draft[channelKey]) {
                delete draft[channelKey];
            }
        });
    };
    var isWebsocketNotReady = (0,react.useCallback)(function() {
        var currentSocket = socketRef.current;
        if (!currentSocket && (currentSocket === null || currentSocket === void 0 ? void 0 : currentSocket.readyState) !== WebSocket.OPEN || !currentSocket || (currentSocket === null || currentSocket === void 0 ? void 0 : currentSocket.readyState) === WebSocket.CONNECTING) {
            return true;
        }
        return false;
    }, [
        (ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.readyState
    ]);
    var getSecuritiesAccessToken = (0,react.useCallback)(function() {
        if ((0,app/* isClient */.C5)()) {
            var securitiesToken = securitiesLocalStorage/* default.getSecuritiesToken */.Z.getSecuritiesToken();
            return {
                key: securitiesToken.securitiesAccessToken
            };
        }
        return {
            key: undefined
        };
    }, []);
    var sendPingHeartbeat = (0,react.useCallback)(function() {
        if (isWebsocketNotReady()) return;
        var pingRequest = (0,utils/* createPingPayload */.c$)();
        var bufferPing = new websocket_pb/* WebsocketRequest */.vC({
            requests: [
                pingRequest
            ]
        }).toBinary();
        socketRef.current.send(bufferPing);
        lastPing.current = Date.now();
    }, []);
    var combinedChannel = (0,react.useMemo)(function() {
        var resultArray = Object.values(channel);
        return resultArray;
    }, [
        channel
    ]);
    var sendMessageChannel = (0,react.useCallback)(function(channelRequests) {
        if (isWebsocketNotReady() || !socketRef.current || channelRequests.length === 0) {
            return;
        }
        var buffer = new websocket_pb/* WebsocketRequest */.vC({
            requests: channelRequests
        }).toBinary();
        socketRef.current.send(buffer);
    }, []);
    var handleSendChannel = (0,react.useCallback)(lodash_debounce_default()(sendMessageChannel, 100), []);
    var handleMessage = (0,react.useCallback)(function(message) {
        var dataRaw = websocket_pb/* WebsocketResponse.fromBinary */.XC.fromBinary(new Uint8Array(message.data));
        var response = dataRaw.response;
        var messageCase = response.case, value = response.value;
        console.log("DEBUG::  messageCase, value", messageCase, value);
        if (messageCase === "ping") {
            lastPong.current = Date.now();
        }
        var channelAction = actionsRef.current[messageCase];
        if (channelAction) {
            channelAction(value);
        }
    }, []);
    var handleHeartbeatMessage = function() {
        setTimeout(function() {
            return sendPingHeartbeat();
        }, heartbeatInterval);
    };
    var handleAuth = function() {
        if (!socketRef.current) return;
        removeAction("ping");
        setAction("ping", handleHeartbeatMessage);
        sendPingHeartbeat();
        setIsSocketOnline(true);
        socketRef.current.addEventListener("message", handleMessage);
        if (reconnectIntervalRef.current) {
            clearInterval(reconnectIntervalRef.current);
            reconnectIntervalRef.current = undefined;
            reconnectCounterRef.current = 1;
            setIsReconnectionFailed(false);
        }
    };
    var handleReconnectionFailed = (0,react.useCallback)(function() {
        if (reconnectIntervalRef.current) {
            clearInterval(reconnectIntervalRef.current);
        }
        reconnectIntervalRef.current = setInterval(function() {
            // eslint-disable-next-line no-use-before-define
            restartSocket();
        }, websocket_constants/* RECONNECT_INTERVAL */.aG);
    }, [
        isReconnectionFailed
    ]);
    var handleReconnection = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, isErrorUnauthorized;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = getSecuritiesAccessToken().key;
                        _ctx.next = 3;
                        return checkUnauthorized(WS_URL, key);
                    case 3:
                        isErrorUnauthorized = _ctx.sent;
                        setIsSocketOnline(false);
                        if (!(!isLoggedInRef.current || isErrorUnauthorized)) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        if (reconnectCounterRef.current < websocket_constants/* MAX_RECONNECT_ATTEMPTS */.pm) {
                            // eslint-disable-next-line no-use-before-define
                            restartSocket();
                        } else if (!isReconnectionFailed) {
                            setIsReconnectionFailed(true);
                            handleReconnectionFailed();
                        }
                        reconnectCounterRef.current += 1;
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleReconnection() {
            return _ref.apply(this, arguments);
        };
    }();
    var initSocket = (0,react.useCallback)(function() {
        if (socketRef.current) return;
        setAuthToken(undefined);
        var key = getSecuritiesAccessToken().key;
        if (!key || !WS_URL) return;
        setAuthToken(key);
        setCookie(key);
        socketRef.current = new WebSocket(WS_URL);
        socketRef.current.binaryType = "arraybuffer";
        // @ts-ignore
        window.securitiesSocket = socketRef.current;
        socketRef.current.addEventListener("open", handleAuth, {
            once: true
        });
        socketRef.current.addEventListener("close", handleReconnection, {
            once: true
        });
    }, [
        handleAuth,
        handleReconnection
    ]);
    var resetSocket = (0,react.useCallback)(function() {
        var ref;
        if (!socketRef.current) return;
        if (((ref = socketRef.current) === null || ref === void 0 ? void 0 : ref.readyState) === WebSocket.OPEN) {
            socketRef.current.close();
        }
        socketRef.current = undefined;
        setAuthToken(undefined);
    }, []);
    var restartSocket = (0,react.useCallback)(function() {
        if (!isLoggedInRef.current) return;
        resetSocket();
        initSocket();
    }, [
        initSocket,
        resetSocket
    ]);
    var resetState = (0,react.useCallback)(function() {
        setIsReconnectionFailed(false);
        setAuthToken(undefined);
        setCookie(undefined);
        reconnectCounterRef.current = 1;
        if (reconnectIntervalRef.current) {
            clearInterval(reconnectIntervalRef.current);
            reconnectIntervalRef.current = undefined;
        }
    }, [
        setIsReconnectionFailed,
        setAuthToken,
        reconnectCounterRef,
        reconnectIntervalRef, 
    ]);
    var handleSocket = (0,react.useCallback)(function(isLogin) {
        if (!socketRef.current && isLogin) {
            restartSocket();
        } else if (socketRef.current && !isLogin) {
            resetSocket();
        }
        if (!isLogin) {
            resetState();
        }
    }, [
        isLoggedIn,
        initSocket,
        resetSocket
    ]);
    (0,react.useEffect)(function() {
        if (authToken && combinedChannel) {
            handleSendChannel(combinedChannel);
        }
    }, [
        authToken,
        combinedChannel,
        (ref1 = socketRef.current) === null || ref1 === void 0 ? void 0 : ref1.readyState,
        handleSendChannel, 
    ]);
    (0,react.useEffect)(function() {
        isLoggedInRef.current = isLoggedIn;
        handleSocket(isLoggedIn);
    }, [
        isLoggedIn
    ]);
    var contextValue = (0,react.useMemo)(function() {
        return {
            isAuthorized: !!authToken,
            token: authToken,
            socket: socketRef.current,
            setChannel: setChannel,
            setAction: setAction,
            removeAction: removeAction
        };
    }, [
        authToken,
        socketRef,
        setChannel,
        setAction,
        removeAction
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SecuritiesContext/* SecuritiesContext.Provider */.i.Provider, {
        value: contextValue,
        children: children
    });
};
/* harmony default export */ var websocket_SecuritiesProvider = (SecuritiesProvider);

// EXTERNAL MODULE: ./src/utils/clevertap.js
var utils_clevertap = __webpack_require__(48028);
;// CONCATENATED MODULE: ./src/hooks/useClevertap.ts
/* eslint-disable eqeqeq */ /* eslint-disable no-undef */ 




function useClevertap() {
    var clevertapRef = (0,react.useRef)();
    var initClevertap = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var clevertap;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return __webpack_require__.e(/* import() */ 5707).then(__webpack_require__.t.bind(__webpack_require__, 88739, 23));
                case 2:
                    clevertap = _ctx.sent.default;
                    clevertap.privacy.push({
                        optOut: false
                    });
                    clevertap.privacy.push({
                        useIP: false
                    });
                    clevertap.init(app/* CLEVERTAP_ID */.d7, "sg1");
                    clevertap.setLogLevel(3);
                    window.clevertap = clevertap;
                    (0,utils_clevertap/* clevertapInitProfileQueue */.QU)();
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    (0,react.useEffect)(function() {
        if (!clevertapRef.current) {
            initClevertap();
        }
    }, [
        clevertapRef.current,
        initClevertap
    ]);
    return null;
}
/* harmony default export */ var hooks_useClevertap = (useClevertap);

// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/global/WebSocketV2/index.ts
var WebSocketV2 = __webpack_require__(36784);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
;// CONCATENATED MODULE: ./src/hooks/useWebSocketSocialV2.ts





function useWebSocketSocialV2(param) {
    var isLoggedIn = param.isLoggedIn;
    var ref = (0,react.useState)(), webSocketSocialV2 = ref[0], setWebSocketSocialV2Connection = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var createSocialSocket = function() {
        return (0,WebSocketV2_slice/* getWskey */.fh)().then(function(wskey) {
            if (wskey !== null) {
                setWebSocketSocialV2Connection((0,WebSocketV2/* initWebsocketSocialV2 */.JC)(constant/* socketV2Key.social */.Iv.social, wskey));
            }
        });
    };
    (0,react.useEffect)(function() {
        if (!isLoggedIn) return;
        if (!webSocketSocialV2) {
            createSocialSocket();
        }
        dispatch(WebSocketV2_slice/* effects.initWebsocketSocialV2 */.Sz.initWebsocketSocialV2({
            webSocketSocialV2: webSocketSocialV2,
            createSocialSocket: createSocialSocket
        }));
    }, [
        webSocketSocialV2,
        isLoggedIn
    ]);
    return webSocketSocialV2;
}
/* harmony default export */ var hooks_useWebSocketSocialV2 = (useWebSocketSocialV2);

;// CONCATENATED MODULE: ./src/global/WebSocket/index.ts
var SOCKET_URL = "https://ws3.lab.stockbit.com/";
function initPrimus() {
    var server = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SOCKET_URL;
    // @ts-ignore
    if ( false || typeof window.Primus === "undefined") {
        return null;
    }
    // @ts-ignore
    var primus = window.Primus(server, {
        strategy: false
    });
    // @ts-ignore
    window.primus = primus;
    return primus;
}
/* harmony default export */ var global_WebSocket = (initPrimus);

;// CONCATENATED MODULE: ./src/hooks/useWebSocket.ts


// WebSocket



/**
 * @summary open websocket connection
 * @param {Object} primus - primus object
 * @returns {[*, () => void]}
 */ function useWebSocket(scriptLoaded) {
    var ref = (0,react.useState)(null), ws = ref[0], setWs = ref[1];
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var dispatch = (0,es/* useDispatch */.I0)();
    var clearPriceAlert = function() {
        dispatch(WebSocket_slice/* default.actions.clearAlert */.ZP.actions.clearAlert());
        localStorage.removeItem("price-alert");
    };
    (0,react.useEffect)(function() {
        if (!scriptLoaded) {
            return;
        }
        if (isLoggedIn) {
            var primus = global_WebSocket();
            setWs(primus);
            // @ts-ignore
            dispatch(WebSocket_slice/* effects.initWebsocket */.Sz.initWebsocket(primus));
            // @ts-ignore
            dispatch(WebSocket_slice/* effects.initListenData */.Sz.initListenData(primus));
        } else {
            clearPriceAlert();
            ws === null || ws === void 0 ? void 0 : ws.end();
        }
    }, [
        isLoggedIn,
        scriptLoaded
    ]);
    return ws;
}
/* harmony default export */ var hooks_useWebSocket = (useWebSocket);

;// CONCATENATED MODULE: ./src/global/Scripts/primus.tsx





var Primus = function() {
    var ref = (0,react.useState)(false), scriptLoaded = ref[0], setScriptLoaded = ref[1];
    hooks_useWebSocket(scriptLoaded);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        type: "text/javascript",
        src: "".concat(app/* assetPrefix */.Vc, "/js/primus.min.js"),
        async: true,
        onLoad: function() {
            return setScriptLoaded(true);
        }
    });
};
/* harmony default export */ var primus = (Primus);

;// CONCATENATED MODULE: ./src/global/Scripts/firebase.tsx


var Firebase = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                src: "https://www.gstatic.com/firebasejs/7.6.2/firebase-app.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                src: "https://www.gstatic.com/firebasejs/7.6.2/firebase-analytics.js"
            })
        ]
    });
};
/* harmony default export */ var firebase = (Firebase);

// EXTERNAL MODULE: ./src/utils/auth.js
var utils_auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/utils/crisp.js
var crisp = __webpack_require__(65458);
// EXTERNAL MODULE: ./src/utils/general.js
var utils_general = __webpack_require__(42227);
// EXTERNAL MODULE: ./node_modules/crisp-sdk-web/dist/crisp.esm.js
var crisp_esm = __webpack_require__(36661);
;// CONCATENATED MODULE: ./src/hooks/useCrisp.ts











function useCrisp() {
    var ref;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* isLoggedInSelector */.dd);
    var dataProfile = (0,es/* useSelector */.v9)(profile/* profileSelector */.Rd);
    // @ts-ignore
    var supportId = dataProfile === null || dataProfile === void 0 ? void 0 : (ref = dataProfile.support) === null || ref === void 0 ? void 0 : ref.id;
    (0,react.useEffect)(function() {
        crisp_esm/* Crisp.configure */.fv.configure(app/* CRISP_ID */.t0, {
            safeMode: true
        });
        var crispData = localStorage.getItem("crisp");
        if (crispData) {
            var crispDecoded = (0,utils_general/* decodeBase64ToJS */.OB)(crispData);
            // @ts-ignore
            if (crispDecoded === null || crispDecoded === void 0 ? void 0 : crispDecoded.id) {
                // @ts-ignore
                crisp_esm/* Crisp.setTokenId */.fv.setTokenId(crispDecoded.id);
            }
        }
        // configuration on crisp load
        if (isLoggedIn) {
            (0,crisp/* onLoaded */.l4)();
        }
        // configuration on open
        (0,crisp/* onOpen */.zp)();
        // configuration on receive message
        (0,crisp/* onReceiveMessage */.Dj)();
    }, []);
    (0,react.useEffect)(function() {
        try {
            if ((0,app/* isClient */.C5)() && isLoggedIn) {
                var crispData = localStorage.getItem("crisp");
                // @ts-ignore
                var ref = utils_auth/* default.getUserAccess */.Z.getUserAccess(), email = ref.email, avatar = ref.avatar, username = ref.username;
                if (supportId) {
                    crisp_esm/* Crisp.setTokenId */.fv.setTokenId(supportId);
                }
                var data = {
                    email: email,
                    avatar: avatar,
                    username: username
                };
                if (crispData) {
                    var crispDecoded = (0,utils_general/* decodeBase64ToJS */.OB)(crispData);
                    // @ts-ignore
                    var phone = (crispDecoded === null || crispDecoded === void 0 ? void 0 : crispDecoded.phone) || (dataProfile === null || dataProfile === void 0 ? void 0 : dataProfile.phone);
                    if (phone) {
                        data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            phone: phone
                        });
                    }
                }
                (0,crisp/* setNewSession */.kG)(data);
                localStorage.removeItem("crisp_visitor");
            }
        } catch (err) {
            console.log("Crisp Disabled");
        }
    }, [
        isLoggedIn,
        supportId
    ]);
}
/* harmony default export */ var hooks_useCrisp = (useCrisp);

;// CONCATENATED MODULE: ./src/typings/platform.ts
var Platform;
(function(Platform) {
    Platform["Unspecified"] = "unspecified";
    Platform["Web"] = "web";
    Platform["Desktop"] = "desktop";
})(Platform || (Platform = {}));

;// CONCATENATED MODULE: ./src/hooks/useSharedWindowData.ts



/** Shares non-confidential data to the window object for Nx module federation */ var useSharedWindowData = function() {
    (0,react.useEffect)(function() {
        window.webSharedData = {
            projectFolder: app/* PROJECT_FOLDER */.sP,
            platform: Platform.Web
        };
    }, []);
};
/* harmony default export */ var hooks_useSharedWindowData = (useSharedWindowData);

;// CONCATENATED MODULE: ./src/global/MainApp/index.tsx
/* eslint-disable wrap-iife */ 
/* eslint-disable no-undef */ 



// store




// configs

// styles

// scripts

// components



// hooks










// constants
var captchaSiteKey = "6LdKDugUAAAAAAdMruoiOks92IdMPvGMvlsVEEyI";
function MainApp(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var routerPath = router.asPath;
    var dispatch = (0,es/* useDispatch */.I0)();
    hooks_useSharedWindowData(); // Used for Nx module federation
    hooks_useCrisp();
    hooks_useClevertap();
    var userId = (0,es/* useSelector */.v9)(credentials/* userIdSelector */.dY);
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* isLoggedInSelector */.dd);
    var tradingType = (0,useTradingAccount/* default */.Z)().tradingType;
    hooks_useWebSocketSocialV2({
        isLoggedIn: isLoggedIn
    });
    (0,logger/* sentrySetUser */.Kp)(isLoggedIn);
    var isSecuritiesStaticPage = router.asPath.includes("/securities/static");
    var hideSupportButton = isSecuritiesStaticPage;
    var isFundachartPage = false;
    var renderPrimusScript = !isFundachartPage;
    var isScriptShouldShow = [
        isFundachartPage
    ].every(function(item) {
        return !item;
    });
    // Reset minimized header when route changes
    (0,react.useEffect)(function() {
        // @ts-ignore
        dispatch(MainLayout_slice/* default.actions.setHeaderMinimized */.ZP.actions.setHeaderMinimized(false));
    }, [
        routerPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: isScriptShouldShow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(google, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Scripts_TikTokPixel, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: !hideSupportButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportButton/* default */.Z, {
                    isLoggedIn: isLoggedIn
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: renderPrimusScript,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primus, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isScriptShouldShow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(firebase, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Datafeed/* DatafeedProvider */.l, {
                isLoggedIn: isLoggedIn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(websocket_SecuritiesProvider, {
                    isLoggedIn: isLoggedIn && !!tradingType,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
                        reCaptchaKey: captchaSiteKey,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components_browser_esm.ThemeProvider, {
                            theme: theme/* default */.ZP,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(global_GlobalStyles, {}),
                                children
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var global_MainApp = (wrapper.withRedux(MainApp));


/***/ }),

/***/ 61048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var lib_entities_stream__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25641);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51679);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14601);
/* harmony import */ var _StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47225);









// APIs
// External reducer

var STATUS_FOLLOWING = 1;
var STATUS_UNFOLLOWING = 0;
var STATUS_SAVED = 1;
var STATUS_UNSAVED = 0;
var STATUS_LIKED = 1;
var STATUS_UNLIKED = 0;
var initialState = {
    data: {},
    selected: {},
    isLoading: true,
    isLoadingMore: false,
    error: null,
    message: ""
};
// Selectors -----------------------------------------------------------
var convoSelector = function(state) {
    return state.streamConversation;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(convoSelector, function(convo) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, convo);
});
// Action type -----------------------------------------------------------
var CONTEXT = "@redux/streamConversation";
var actionType = {
    GET_CONVERSATION: "".concat(CONTEXT, "/GET_CONVERSATION"),
    LOAD_PREV_CONVERSATION: "".concat(CONTEXT, "/LOAD_PREV_CONVERSATION")
};
var // Helper -----------------------------------------------------------
IActionStatus;
(function(IActionStatus) {
    IActionStatus[IActionStatus["STATUS_FOLLOWING"] = 0] = "STATUS_FOLLOWING";
    IActionStatus[IActionStatus["STATUS_UNFOLLOWING"] = 1] = "STATUS_UNFOLLOWING";
    IActionStatus[IActionStatus["STATUS_SAVED"] = 2] = "STATUS_SAVED";
    IActionStatus[IActionStatus["STATUS_UNSAVED"] = 3] = "STATUS_UNSAVED";
    IActionStatus[IActionStatus["STATUS_LIKED"] = 4] = "STATUS_LIKED";
    IActionStatus[IActionStatus["STATUS_UNLIKED"] = 5] = "STATUS_UNLIKED";
})(IActionStatus || (IActionStatus = {}));
/**
 * Do Count of Stream Post Likes
 * @param state state
 * @param status status
 */ var countStreamPostLike = function(state, status) {
    if (status === STATUS_LIKED) {
        state.likes += 1;
    } else if (status === STATUS_UNLIKED) {
        state.likes -= 1;
    }
};
/**
 * Change Status of Action
 * @param state state object
 * @param postid post id
 * @param action property that want to change
 * @param status value that you want to apply to the property
 * @description
 * this for change follow, saved, liked, likes value
 * from state.selected
 */ var changeActionStatus = function(state, postid, action, status) {
    var ref, ref1, ref2;
    // check index of replies item of selected convo
    var replyIdx = (ref = state.selected) === null || ref === void 0 ? void 0 : (ref1 = ref.replies) === null || ref1 === void 0 ? void 0 : ref1.findIndex(function(reply) {
        return reply.postid === postid;
    });
    // change 'action' value of replies item with status
    if (replyIdx > -1) {
        state.selected.replies[replyIdx][action] = status;
        if (action === "liked") {
            countStreamPostLike(state.selected.replies[replyIdx], status);
        }
    } else if (((ref2 = state.selected.parent) === null || ref2 === void 0 ? void 0 : ref2.postid) === postid) {
        state.selected.parent[action] = status;
        if (action === "liked") {
            countStreamPostLike(state.selected.parent, status);
        }
    }
};
// Effects -----------------------------------------------------------
var effects = {
    getStreamConversation: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.GET_CONVERSATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var postId, parentId, response, _data, posts, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postId = param.postId, parentId = param.parentId;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getStreamConversation */ .Z.getStreamConversation({
                            postId: postId,
                            parentId: parentId
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to fetch stream conversation failed");
                    case 7:
                        _data = response.data, posts = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        data = (0,utils_stream__WEBPACK_IMPORTED_MODULE_3__/* .transformConversationV3 */ .PI)(posts.conversation);
                        return _ctx.abrupt("return", {
                            postid: postId,
                            data: data,
                            message: message
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    loadPreviousConversation: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)(actionType.LOAD_PREV_CONVERSATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var ref, lastReplyPostId, postid, response, _data, posts, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        lastReplyPostId = params.lastReplyPostId, postid = params.postid;
                        _ctx.next = 5;
                        return lib_api_stream__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getPrevStreamConversation */ .Z.getPrevStreamConversation(lastReplyPostId);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to fetch stream conversation failed");
                    case 8:
                        _data = response.data, posts = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 11:
                        data = {
                            more: !((ref = posts.pagination) === null || ref === void 0 ? void 0 : ref.is_last_page),
                            replies: (0,utils_stream__WEBPACK_IMPORTED_MODULE_3__/* .transformV3Response */ .bv)(posts.stream)
                        };
                        return _ctx.abrupt("return", {
                            postid: postid,
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers -----------------------------------------------------------
var reducers = {
    closeStreamConversation: function(state) {
        state.isLoading = initialState.isLoading;
        state.isLoadingMore = initialState.isLoadingMore;
    }
};
// Extra reducers -----------------------------------------------------------
var extraReducers = function(builder) {
    builder.addCase(effects.getStreamConversation.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getStreamConversation.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.selected = data;
            state.error = null;
            state.isLoading = false;
        }
        state.message = message;
    }).addCase(effects.getStreamConversation.rejected, function(state, action) {
        state.error = action.payload.error;
    }).addCase(effects.loadPreviousConversation.pending, function(state) {
        state.isLoadingMore = true;
        state.error = null;
    }).addCase(effects.loadPreviousConversation.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.error = error;
        } else {
            state.selected = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state.selected), {
                // @ts-ignore
                replies: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(data.replies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(state.selected.replies)),
                more: data.more
            });
            state.error = null;
        }
        state.isLoadingMore = false;
        state.message = message;
    }).addCase(effects.loadPreviousConversation.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoadingMore = false;
    })// Follow/unfollow stream convo data
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.followPost.fulfilled */ .Sz.followPost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "follow", STATUS_FOLLOWING);
    }).addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.unfollowPost.fulfilled */ .Sz.unfollowPost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "follow", STATUS_UNFOLLOWING);
    })// Save/unsave stream convo data
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.savePost.fulfilled */ .Sz.savePost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "saved", STATUS_SAVED);
    }).addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.unsavePost.fulfilled */ .Sz.unsavePost.fulfilled, function(state, action) {
        var postid = action.payload.postid;
        changeActionStatus(state, postid, "saved", STATUS_UNSAVED);
    })// Like/unline stream convo data
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.likePost.fulfilled */ .Sz.likePost.fulfilled, function(state, action) {
        var _payload = action.payload, postid = _payload.postid, error = _payload.error;
        if (!error) {
            changeActionStatus(state, postid, "liked", STATUS_LIKED);
        }
    }).addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.unlikePost.fulfilled */ .Sz.unlikePost.fulfilled, function(state, action) {
        var _payload = action.payload, postid = _payload.postid, error = _payload.error;
        if (!error) {
            changeActionStatus(state, postid, "liked", STATUS_UNLIKED);
        }
    })// When conversation success replied, the response will be added
    // as new reply to the state.data
    .addCase(lib_entities_stream__WEBPACK_IMPORTED_MODULE_1__/* .effects.postConversationStream.fulfilled */ .Sz.postConversationStream.fulfilled, function(state, action) {
        var data = action.payload.data;
        if (data) {
            // @ts-ignore
            var replies = state.selected.replies;
            var newReplies = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(replies).concat([
                data
            ]);
            // @ts-ignore
            state.selected.replies = newReplies;
        }
    })// When conversation reply success replied, the reply item state
    // will be updated with api response
    .addCase(lib_entities_stream__WEBPACK_IMPORTED_MODULE_1__/* .effects.updatePostStream.fulfilled */ .Sz.updatePostStream.fulfilled, function(state, action) {
        var data = action.payload.data;
        var isReply = (data === null || data === void 0 ? void 0 : data.postid) !== (data === null || data === void 0 ? void 0 : data.parent_postid);
        if (data) {
            var ref;
            // @ts-ignore
            if (isReply && ((ref = state.selected) === null || ref === void 0 ? void 0 : ref.replies)) {
                var _arg = action.meta.arg, commenterType = _arg.commenter_type;
                // @ts-ignore
                var replies = state.selected.replies;
                var idxReplies = replies.findIndex(function(reply) {
                    return (reply === null || reply === void 0 ? void 0 : reply.postid) === (data === null || data === void 0 ? void 0 : data.postid);
                });
                if (idxReplies > -1) {
                    // Update reply item
                    // update created using old and updated as created we receive from server
                    var newReplies = replies;
                    var currentComment = newReplies[idxReplies];
                    newReplies[idxReplies] = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                        commenter_type: commenterType,
                        created: currentComment.created,
                        created_display: currentComment.created_display,
                        updated: data === null || data === void 0 ? void 0 : data.created
                    });
                    // @ts-ignore
                    state.selected.replies = newReplies;
                }
            }
        }
    })// When stream post detail/conversation change the comment limitation
    // it will update the commenter_type of parent stream post
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.changeCommenter.fulfilled */ .Sz.changeCommenter.fulfilled, function(state, action) {
        var ref;
        var error = action.payload.error;
        var type = action.meta.arg.type;
        // @ts-ignore
        if (!error && ((ref = state.selected) === null || ref === void 0 ? void 0 : ref.parent)) {
            // @ts-ignore
            state.selected.parent.commenter_type = type;
        }
    })// Handle sideeffect when user post polling vote on convo
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.postVotePolling.fulfilled */ .Sz.postVotePolling.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (!error) {
            var ref, ref1;
            // @ts-ignore
            var selectedParent = (ref = state.selected) === null || ref === void 0 ? void 0 : (ref1 = ref.parent) === null || ref1 === void 0 ? void 0 : ref1.polling;
            if (selectedParent) {
                var ref2;
                if (selectedParent.length > 0 && ((ref2 = selectedParent[0]) === null || ref2 === void 0 ? void 0 : ref2.id) === data.id) {
                    // @ts-ignore
                    state.selected.parent.polling[0] = data;
                }
            }
        }
    })// Handle sideeffect when user click price target action on convo
    .addCase(_StreamWidget_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.postVoteTargetPrice.fulfilled */ .Sz.postVoteTargetPrice.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (!error) {
            var ref, ref1;
            // @ts-ignore
            if (((ref = state.selected) === null || ref === void 0 ? void 0 : (ref1 = ref.parent) === null || ref1 === void 0 ? void 0 : ref1.postid) === data.postid) {
                // @ts-ignore
                state.selected.parent = data;
            }
        }
    });
};
var streamConversation = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "streamConversation",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (streamConversation);


/***/ }),

/***/ 84468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ buttonSupportId; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var utils_crisp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65458);
/* eslint-disable react/require-default-props */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: #404040;\n  border: none;\n  border-radius: 50%;\n  bottom: 50px;\n  cursor: pointer;\n  display: flex;\n  height: 60px;\n  justify-content: center;\n  position: fixed;\n  right: 30px;\n  width: 60px;\n  z-index: 9999;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ButtonSupport = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].button.withConfig({
    componentId: "sc-a22cf76c-0"
})(_templateObject());
var Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Iconmoon */ .Gn.Iconmoon;
var buttonSupportId = "buttonSupport";
function SupportButton(param) {
    var isLoggedIn = param.isLoggedIn;
    if (isLoggedIn) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonSupport, {
        onClick: utils_crisp__WEBPACK_IMPORTED_MODULE_3__/* .handleClickSupport */ .lA,
        id: buttonSupportId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Iconmoon, {
            className: "icon-widget_support",
            color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.light */ .$_.light,
            hoverColor: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.light */ .$_.light,
            size: "40px"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SupportButton);


/***/ }),

/***/ 63600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qd": function() { return /* binding */ INDEX_DATA_FILTER; },
/* harmony export */   "ce": function() { return /* binding */ QUERY_KEY_DATA; },
/* harmony export */   "e_": function() { return /* binding */ FETCH_STATUS; },
/* harmony export */   "n0": function() { return /* binding */ FILTER_CHOICE; },
/* harmony export */   "t6": function() { return /* binding */ LIST_CHOICE; }
/* harmony export */ });
/* unused harmony exports SUGGESTIONS_PERPAGE, LIMIT_SEARCH_USER, USER_TYPES */
/* harmony import */ var features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28635);

var USER_TYPES = {
    OFFICIAL_USER: "OFFICIAL",
    TOP: "TOP"
};
var SUGGESTIONS_PERPAGE = 30;
var LIMIT_SEARCH_USER = 20;
var QUERY_KEY_DATA = {
    suggested: "getDataFriendSuggestionsListTrendingWidget",
    trending: "getDataTrendingList"
};
// fetch statuses
var FETCH_STATUS = {
    IDLE: "idle",
    PENDING: "pending",
    RESOLVED: "resolved",
    REJECTED: "rejected"
};
var FILTER_CHOICE = [
    {
        label: "Weekly",
        value: features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__/* .TrendingTimeFrame.ONE_WEEK */ .b.ONE_WEEK
    },
    {
        label: "Monthly",
        value: features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__/* .TrendingTimeFrame.ONE_MONTH */ .b.ONE_MONTH
    },
    {
        label: "All-time",
        value: features_discover_people_types__WEBPACK_IMPORTED_MODULE_0__/* .TrendingTimeFrame.ALL */ .b.ALL
    }, 
];
var LIST_CHOICE = {
    SUGGESTED: "suggested",
    TRENDING: "trending"
};
var INDEX_DATA_FILTER = {
    SUGGESTED: "useSuggestionList",
    TRENDING: "useTrendingList"
};



/***/ }),

/***/ 47514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable no-undef */ 



var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
var CHARTBIT_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/chartbit");
var ORDERBOOK_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/orderbook");
var getSearchCompany = function(query) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/search"), {
        params: {
            keyword: query,
            type: "company",
            page: 0
        }
    });
};
var getInitialData = function(symbol) {
    return requestExodus.get("".concat(CHARTBIT_URL, "/initial/").concat(symbol));
};
var getDailyPriceData = function(_param) {
    var symbol = _param.symbol, from = _param.from, to = _param.to, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "symbol",
        "from",
        "to"
    ]);
    var params = {};
    if (from && to) {
        params = {
            from: from,
            to: to,
            limit: 0
        };
    }
    params = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, params, props);
    return requestExodus.get("".concat(CHARTBIT_URL, "/").concat(symbol, "/price/daily"), {
        params: params
    });
};
var getIntradayPriceData = function(_param) {
    var symbol = _param.symbol, from = _param.from, to = _param.to, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "symbol",
        "from",
        "to"
    ]);
    var params = {};
    if (from && to) {
        params = {
            from: from,
            to: to,
            limit: 0
        };
    }
    params = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, params, props);
    return requestExodus.get("".concat(CHARTBIT_URL, "/").concat(symbol, "/price/intraday"), {
        params: params
    });
};
var getEvents = function(param) {
    var symbol = param.symbol, from = param.from, to = param.to;
    return requestExodus.get("".concat(CHARTBIT_URL, "/chart/corpaction"), {
        params: {
            from: from,
            to: to,
            symbol: symbol
        }
    });
};
var getLayout = function(symbol) {
    return requestExodus.get("".concat(CHARTBIT_URL, "/").concat(symbol, "/layout"));
};
var saveLayout = function(symbol, drawing) {
    return requestExodus.post("".concat(CHARTBIT_URL, "/").concat(symbol, "/layout"), {
        content: JSON.stringify(drawing)
    });
};
var getChartTemplate = function() {
    return requestExodus.get("".concat(CHARTBIT_URL, "/template"));
};
var loadChartTemplate = function(id, symbol) {
    return requestExodus.get("".concat(CHARTBIT_URL, "/").concat(symbol, "/template/").concat(id));
};
var saveChartTemplate = function(name, content) {
    return requestExodus.post("".concat(CHARTBIT_URL, "/template"), {
        name: name,
        content: JSON.stringify(content)
    });
};
var deleteChartTemplate = function(id) {
    return requestExodus.delete("".concat(CHARTBIT_URL, "/template/").concat(id));
};
var getCustomIndicator = function(params) {
    return requestExodus.get("".concat(CHARTBIT_URL, "/custom/indicator"), {
        params: params
    });
};
var getMobileTokenData = function(token) {
    return requestExodus.get("".concat(CHARTBIT_URL, "/token/").concat(token, "/mobile"));
};
var getQuote = function(symbol) {
    return requestExodus.get("".concat(ORDERBOOK_URL, "/companies/").concat(symbol));
};
var getVersion = function() {
    return requestExodus.get("".concat(CHARTBIT_URL, "/version"));
};
var getUserSettings = function() {
    return requestExodus.get("/user-setting/configurations", {
        params: {
            user_setting_type: "1"
        }
    });
};
var saveUserSettings = function(param) {
    var content = param.content;
    return requestExodus.post("/user-setting/configurations", {
        content: content,
        user_setting_type: 1
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getSearchCompany: getSearchCompany,
    getDailyPriceData: getDailyPriceData,
    getIntradayPriceData: getIntradayPriceData,
    getInitialData: getInitialData,
    getEvents: getEvents,
    getLayout: getLayout,
    saveLayout: saveLayout,
    getChartTemplate: getChartTemplate,
    loadChartTemplate: loadChartTemplate,
    saveChartTemplate: saveChartTemplate,
    deleteChartTemplate: deleteChartTemplate,
    getCustomIndicator: getCustomIndicator,
    getMobileTokenData: getMobileTokenData,
    getQuote: getQuote,
    getVersion: getVersion,
    getUserSettings: getUserSettings,
    saveUserSettings: saveUserSettings
});


/***/ }),

/***/ 20072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable camelcase */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 

var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodusNoAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
// URLs aliases
var TIPPING_EXODUS_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/tip");
// EXODUS TIPPING URL
var EXODUS_TIPPING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/tip");
/**
 * @return {APIResponse}
 */ var getTippingJar = function() {
    return requestExodusNoAlert.get("".concat(EXODUS_TIPPING_URL, "/jar"));
};
/**
 * Send tipping from stream
 * @param {Object} tipData
 * @param {Object} tipData.tipable - Target tip
 * @param {number} tipData.tipable.id - Target tip id
 * @param {Object} tipData.tipable.type - Target tip
 * @param {number} tipData.amount - Amount given
 * @param {string=} tipData.message - Additional message
 * @param {string=} tipData.callback_url - Additional message
 * @return {APIResponse}
 */ var sendTippingStream = function(tipData) {
    return requestExodus.post(TIPPING_EXODUS_URL, tipData);
};
/**
 * Claim tipping balance
 * @param {number} amount - Amount to be claimed
 * @return {APIResponse}
 */ var claimTippingBalance = function(amount) {
    return requestExodus.post("".concat(TIPPING_EXODUS_URL, "/claim"), {
        amount: amount
    });
};
/**
 * Update gopay account by number for tipping
 * @param {string} account - Account number
 * @return {APIResponse}
 */ var updateGopayAccount = function(account) {
    return requestExodus.patch("".concat(EXODUS_TIPPING_URL, "/gopay-account"), {
        gopay_account: account
    });
};
/**
 * Get detail tipping from notif
 * @param {string | number} tippingId
 * @return {APIResponse}
 */ var getTippingDetail = function(tippingId) {
    return requestExodusNoAlert.get("".concat(EXODUS_TIPPING_URL, "/detail/").concat(tippingId));
};
var getTippingActivity = function() {
    var tabActivity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "TIP_TAB_TIPPING";
    return requestExodusNoAlert.get("".concat(EXODUS_TIPPING_URL, "/activity"), {
        params: {
            tab: tabActivity
        }
    });
};
/**
 * Send tipping
 * @param {Object} tipData
 * @param {Object} tipData.tipable - Target tip
 * @param {number} tipData.tipable.id - Target tip id
 * @param {Object} tipData.tipable.type - Target tip
 * @param {number} tipData.amount - Amount given
 * @param {string=} tipData.message - Additional message
 * @param {string=} tipData.callback_url - Additional message
 * @return {APIResponse}
 */ var sendTipping = function(tipData) {
    return requestExodus.post(TIPPING_EXODUS_URL, tipData);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getTippingJar: getTippingJar,
    getTippingDetail: getTippingDetail,
    sendTippingStream: sendTippingStream,
    claimTippingBalance: claimTippingBalance,
    updateGopayAccount: updateGopayAccount,
    getTippingActivity: getTippingActivity,
    sendTipping: sendTipping
});


/***/ }),

/***/ 61942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ entities_livestream; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/livestream.ts
/* eslint-disable import/named */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 

var request = (0,requestExodus/* default */.Z)();
var LIVE_STREAM_URL = "".concat(api/* API_EXODUS_URL */.q7, "/live-stream");
/**
 * Get Livestreams Event List
 * @param { Object } params
 * @param {number=} params.page
 * @param {string=} params.limit
 * @param {string=} params.status
 * @returns {APIResponse}
 */ var getEventList = function(params) {
    return request.get("".concat(LIVE_STREAM_URL, "/event"), {
        params: params
    });
};
/**
 * Get Livestream Event
 * @param {string|number=} id
 * @returns {APIResponse}
 */ var getEvent = function(id) {
    return request.get("".concat(LIVE_STREAM_URL, "/event/").concat(id));
};
/**
 * Write Question
 * @param { Object } params
 * @param {number=} params.id
 * @param {string=} params.question
 * @returns {APIResponse}
 */ var writeQuestion = function(params) {
    return request.post("".concat(LIVE_STREAM_URL, "/event/").concat(params.id, "/question"), {
        question: params.question
    });
};
/**
 * Get Nont Login Livestream Event
 * @param {string|number=} id
 * @returns {APIResponse}
 */ var getEventNonLogin = function(id) {
    return request.get("".concat(LIVE_STREAM_URL, "/non-login/event/").concat(id));
};
/* harmony default export */ var livestream = ({
    getEventList: getEventList,
    getEvent: getEvent,
    writeQuestion: writeQuestion,
    getEventNonLogin: getEventNonLogin
});

;// CONCATENATED MODULE: ./src/lib/entities/livestream.ts








/**
 * Note for event filtered data Schema
 * because we pass status as argument, we will use that as key to save the response
 * the schema will look like this
 *
 * data[eventStatus]: [
 *   { ... }
 * ]
 */ var initialState = {
    eventList: {
        data: [],
        isLoading: false,
        message: "",
        error: ""
    },
    eventFiltered: {
        data: {},
        isLoading: false,
        isLoadingMore: false,
        hasMore: false,
        message: "",
        error: ""
    },
    event: {
        data: null,
        isLoading: false,
        message: "",
        error: ""
    },
    writeQuestion: {
        data: null,
        isLoading: false,
        message: "",
        error: ""
    }
};
var liveStream = function(state) {
    return state.liveStream;
};
var selectors = (0,es/* createSelector */.P1)(liveStream, function(liveStreamState) {
    return {
        events: liveStreamState.eventList,
        event: liveStreamState.event,
        eventFiltered: liveStreamState.eventFiltered,
        writeQuestions: liveStreamState.writeQuestion
    };
});
var CONTEXT = "@feature/livestream";
var actionType = {
    GET_EVENTS: "".concat(CONTEXT, "/GET_EVENTS"),
    GET_EVENTS_FILTERED: "".concat(CONTEXT, "/GET_EVENTS_FILTERED"),
    GET_EVENT: "".concat(CONTEXT, "/GET_EVENT"),
    WRITE_QUESTION: "".concat(CONTEXT, "/WRITE_QUESTION")
};
var effects = {
    getEventList: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENTS, // @ts-ignore
    (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getEventList({
                        page: 1,
                        limit: 20
                    });
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Failed to get event list");
                case 6:
                    _data = response.data, data = _data.data, message = _data.message;
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }))),
    getEvent: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return getEvent(props);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 6:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }()),
    getEventListFiltered: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_EVENTS_FILTERED, function() {
        var _ref = // @ts-ignore
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var _page, page, _limit, limit, status, response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _page = props.page, page = _page === void 0 ? 1 : _page, _limit = props.limit, limit = _limit === void 0 ? 16 : _limit, status = props.status;
                        _ctx.next = 4;
                        return getEventList({
                            page: page,
                            limit: limit,
                            status: status
                        });
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 7:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }()),
    writeQuestion: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.WRITE_QUESTION, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(props) {
            var response, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return writeQuestion(props);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Failed to get event list");
                    case 6:
                        _data = response.data, data = _data.data, message = _data.message;
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }())
};
var extraReducers = function(builder) {
    builder.addCase(effects.getEventList.pending, function(state) {
        state.eventList.isLoading = true;
        state.eventList.error = null;
    }).addCase(effects.getEventList.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.eventList.error = error;
        } else {
            state.eventList.data = data;
        }
        state.eventList.message = message;
        state.eventList.isLoading = false;
    }).addCase(effects.getEventList.rejected, function(state, action) {
        state.eventList.isLoading = false;
        state.eventList.error = action.payload.error;
    }).addCase(effects.getEvent.pending, function(state) {
        state.event.isLoading = true;
        state.event.error = null;
    }).addCase(effects.getEvent.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.event.error = error;
        } else {
            state.event.data = data;
        }
        state.event.message = message;
        state.event.isLoading = false;
    }).addCase(effects.getEvent.rejected, function(state, action) {
        state.event.isLoading = false;
        state.event.error = action.payload.error;
    }).addCase(effects.writeQuestion.pending, function(state) {
        state.writeQuestion.isLoading = true;
        state.writeQuestion.error = null;
    }).addCase(effects.writeQuestion.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.writeQuestion.error = error;
        } else {
            state.writeQuestion.data = data;
        }
        state.writeQuestion.message = message;
        state.writeQuestion.isLoading = false;
    }).addCase(effects.writeQuestion.rejected, function(state, action) {
        state.writeQuestion.isLoading = false;
        state.writeQuestion.error = action.payload.error;
    }).addCase(effects.getEventListFiltered.pending, function(state, action) {
        var page = action.meta.arg.page;
        state.eventFiltered.error = null;
        if (page > 1) {
            state.eventFiltered.isLoadingMore = true;
        } else {
            state.eventFiltered.isLoading = true;
        }
    }).addCase(effects.getEventListFiltered.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        var _arg = action.meta.arg, page = _arg.page, status = _arg.status;
        if (error) {
            state.eventFiltered.error = error;
        } else {
            if (page > 1) {
                state.eventFiltered.data = (0,_define_property/* default */.Z)({}, status, (0,_to_consumable_array/* default */.Z)(state.eventFiltered.data[status]).concat((0,_to_consumable_array/* default */.Z)(data)));
                state.eventFiltered.isLoadingMore = false;
            } else {
                state.eventFiltered.data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.eventFiltered.data), (0,_define_property/* default */.Z)({}, status, data));
                state.eventFiltered.isLoading = false;
            }
            if (data.length === 16) {
                state.eventFiltered.hasMore = true;
            } else {
                state.eventFiltered.hasMore = false;
            }
        }
        state.eventFiltered.message = message;
    }).addCase(effects.getEventListFiltered.rejected, function(state, action) {
        state.eventFiltered.isLoading = false;
        state.eventFiltered.error = action.payload.error;
    });
};
var liveStreamSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "livestream",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducers
});
/* harmony default export */ var entities_livestream = (liveStreamSlice);


/***/ }),

/***/ 98585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; }
/* harmony export */ });
/* unused harmony export selector */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_tipping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20072);



// APIs

// Initial state
var initialState = {
    detail: {},
    data: {},
    isLoading: false,
    error: null,
    message: ""
};
// Selectors
var selector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.entities.tipping;
}, function(tipping) {
    return {
        data: tipping.data,
        isLoading: tipping.isLoading,
        error: tipping.error,
        detail: tipping.detail
    };
});
// Action types
var CONTEXT = "@redux/entities";
var actionType = {
    GET_TIPPING_JAR: "".concat(CONTEXT, "/GET_TIPPING_JAR"),
    CLAIM_TIPPING_BALANCE: "".concat(CONTEXT, "/CLAIM_TIPPING_BALANCE"),
    SEND_TIPPING: "".concat(CONTEXT, "/SEND_TIPPING"),
    UPDATE_GOPAY_ACCOUNT: "".concat(CONTEXT, "/UPDATE_GOPAY_ACCOUNT"),
    GET_TIPPING_DETAIL: "".concat(CONTEXT, "/GET_TIPPING_DETAIL"),
    SEND_TIPPING_GENERAL: "".concat(CONTEXT, "/SEND_TIPPING_GENERAL")
};
// Effects
var effects = {
    sendTipping: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.SEND_TIPPING, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tipData) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_tipping__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sendTippingStream */ .Z.sendTippingStream(tipData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to send tip failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(tipData) {
            return _ref.apply(this, arguments);
        };
    }()),
    sendTippingGeneral: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.SEND_TIPPING_GENERAL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tipData) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_tipping__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sendTipping */ .Z.sendTipping(tipData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to send tip failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(tipData) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {};
var extraReducers = {
};
var tipping = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "tipping",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (tipping);


/***/ }),

/***/ 42826:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Upload image handler
 * @param file - File to be uploaded
 * @param url - AWS Bucket URL
 * @param awsFields - Additional aws fields from `getPolicy` API
 * @param - type upload chat|stream
 * @returns {Promise<*>} fetch function
 */ var uploadHandler = function(file, url, awsFields, type) {
    return new Promise(function(resolve, reject) {
        var fd = new FormData();
        var formerFile = null;
        // eslint-disable-next-line no-underscore-dangle
        if (file._file) formerFile = file._file;
        // eslint-disable-next-line array-callback-return
        if (type === "chat") {
            awsFields.map(function(field) {
                return fd.append(field.name, field.value);
            });
        } else if (type === "stream") {
            awsFields.map(function(field) {
                return fd.append(field.key, field.value);
            });
        }
        if (!formerFile) {
            fd.append("file", file);
        } else {
            fd.append("file", formerFile);
        }
        return fetch(url, {
            method: "POST",
            cache: "default",
            body: fd,
            mode: "no-cors"
        }).then(function(response) {
            resolve(response.ok);
        }).catch(function(error) {
            reject(new Error(error));
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (uploadHandler);


/***/ })

}]);